/* inb-page-config – Version: 20261005-1547 – gehört zu sections/inb-page-config.liquid */
(function(){
  // Richtwerte ISO 2936: s, l1 kurz, l1 lang (null = nicht genormt), l2
  // [s, l1 Standard, l1 Extra-lang, l2] – DIN ISO 2936:2016-10, Tabelle 1 (Spalten „Standard“ und „Extra-Lang“).
  // s = 5,5 sowie Extra-lang für s = 19 … 27 stehen nicht in der Norm: Werte aus TAB 08-15
  // (DIN 911 bzw. 911 L, Art.-Nr. 200/210). null = nicht lieferbar.
  const NORM = [
    [0.7,33,null,7],[0.9,33,null,11],[1.3,41,81,13],[1.5,46.5,91.5,15.5],[2,52,102,18],[2.5,58.5,114.5,20.5],
    [3,66,129,23],[3.5,69.5,140,25.5],[4,74,144,29],[4.5,80,156,30.5],[5,85,165,33],[5.5,90.5,175.5,35.5],[6,96,186,38],[7,102,197,41],[8,108,208,44],
    [9,114,219,47],[10,122,234,50],[11,129,247,53],[12,137,262,57],[13,145,277,63],[14,154,294,70],[15,161,307,73],[16,168,307,76],[17,177,337,80],[18,188,358,84],
    [19,199,379,89],[20,200,null,90],[21,211,null,96],[22,222,422,102],[23,233,null,108],[24,248,472,114],[27,277,527,127],[29,311,null,141],[30,315,590,142],[32,347,null,157],[36,391,null,176]
  ];
  // DIN ISO 2936, Tabelle 3: Mindest-Härte (HRC) und Mindest-Prüfdrehmoment (N·m)
  const HARD={0.7:0.08,0.9:0.18,1.3:0.53,1.5:0.82,2:1.9,2.5:3.8,3:6.6,3.5:10.3,4:16,4.5:22,5:30,6:52,7:80,8:120,9:165,10:220,11:282,12:370,13:470,14:590,15:725,16:880,17:980,18:1158,19:1360,21:1840,22:2110,23:2414,24:2750,27:3910,29:4000,30:4000,32:4000,36:4000};
  const FC_SIZES=[1.5,2,2.5,3,4,5,6,8,10];   // Pulverbeschichtung nur für diese Schlüsselweiten
  window.inbFcOk=s=>FC_SIZES.includes(Number(s));
  window.inbFcSizes=[1.5,2,2.5,3,4,5,6,8,10];   // Pulverbeschichtung lieferbar
  // DIN ISO 2936 Tabelle 1: [s max, s min, e max, e min]; 5,5 aus TAB 08-15
  const SE={0.7:[0.71,0.70,0.79,0.76],0.9:[0.89,0.88,0.99,0.96],1.3:[1.27,1.24,1.42,1.37],1.5:[1.50,1.48,1.68,1.63],2:[2.00,1.96,2.25,2.18],2.5:[2.50,2.46,2.82,2.75],
    3:[3.00,2.96,3.39,3.31],3.5:[3.50,3.45,3.96,3.91],4:[4.00,3.95,4.53,4.43],4.5:[4.50,4.45,5.10,5.04],5:[5.00,4.95,5.67,5.57],5.5:[5.50,5.45,6.24,6.14],6:[6.00,5.95,6.81,6.70],7:[7.00,6.94,7.95,7.85],8:[8.00,7.94,9.09,8.97],9:[9.00,8.94,10.23,10.10],11:[11.00,10.89,12.51,12.31],13:[13.00,12.89,14.79,14.57],15:[15.00,14.89,17.07,16.83],16:[16.00,15.89,18.21,17.96],18:[18.00,17.89,20.49,20.22],20:[20.00,19.87,22.77,22.45],21:[21.00,20.87,23.91,23.58],23:[23.00,22.87,26.19,25.84],29:[29.00,28.87,33.03,32.62],30:[30.00,29.87,34.17,33.75],
    10:[10.00,9.94,11.37,11.23],12:[12.00,11.89,13.65,13.44],14:[14.00,13.89,15.93,15.70],17:[17.00,16.89,19.35,19.09],19:[19.00,18.87,21.63,21.32],
    22:[22.00,21.87,25.05,24.71],24:[24.00,23.87,27.33,26.97],27:[27.00,26.87,30.75,30.36],32:[32.00,31.84,36.45,35.98],36:[36.00,35.84,41.01,40.50]};
  // Grenzabmaße l1 / l2 und Winkel c nach Schlüsselweite
  const tolL1=s=> s<=2?2 : s<=6?4 : s<=14?6 : s<=18?7 : 12;
  const tolL2=s=> s<=14?2 : s<=18?3 : 5;
  const tolC =s=> s<=17?'+2° / −1°':'+3° / −1°';
  const fmt2=n=>(Math.round(n*100)/100).toLocaleString('de-DE',{minimumFractionDigits:2});
  window.__normTol={SE,tolL1,tolL2,tolC};
  // Gestreckte Länge (±1) aus TAB 08-15 (HaFu): DIN 911 = Standard, DIN 911 L = Extra-lang. Nicht in ISO 2936.
  const GL_STD={0.7:37,0.9:41,1.5:58,2:65,2.5:73,3:81,4:93,5:106,5.5:113,6:120,7:127,8:134,10:150,12:168,14:194,17:221,19:248,22:280,24:314,27:350,32:440,36:495};
  const GL_LANG={1.5:103,2:115,2.5:129,3:144,4:163,5:186,5.5:198,6:210,7:232,8:234,10:257,12:293,14:334,17:381,19:428,22:480,24:538,27:600};
  // Zeilen der Maßtabelle: [Maß, Nennmaß, Grenzabmaß]
  // Erst gewählte Werte zeigen: ohne Schlüsselweite keine Querschnitts- und Toleranzwerte, ohne Länge keine l₁/l₂
  function hasSize(){ return !!document.querySelector('input[name=size]:checked'); }
  function hasLen(){ const r=document.querySelector('input[name=series]:checked'); if(!r) return false;
    return r.value!=='sonder' || (!!document.getElementById('l1').value && !!document.getElementById('l2').value); }
  window.inbHasSize=hasSize; window.inbHasLen=hasLen;
  function dimRows(){
    const s=st.size, d=SE[s], R=Math.max(s,1.5), S=hasSize(), L=S && hasLen(), X='–';
    const rows=[
      ['l₁', L?fmt(st.l1):X, L?'+0 / −'+tolL1(s):X],
      ['l₂', L?fmt(st.l2):X, L?'+0 / −'+tolL2(s):X],
      ['s',  S?(d?fmt2(d[0]):fmt(s)):X, S&&d?'+0 / −'+fmt2(d[0]-d[1]):X],
      ['e',  S&&d?fmt2(d[2]):X, S&&d?'+0 / −'+fmt2(d[2]-d[3]):X],
      ['r',  S && st.series!=='sonder' ? fmt(R) : X, X],   // Sonderlänge: Biegeradius nicht festgelegt
      ['c',  '90°', S?tolC(s):X],
    ];
    if(d && (st.endLong!=='kugel' || st.endShort!=='kugel')) rows.push(['f', !S?X : st.chamfer==='gratfrei' ? 'gratfrei' : '≤ '+fmt2((d[2]-d[1])/2), X]);
    // (Mittelwert l1 + Mittelwert l2) − 2 × s + 1 mm; Mittelwert = Nennmaß − halbes Grenzabmaß (+0/−t)
    const gl = Math.round((st.l1 - tolL1(s)/2) + (st.l2 - tolL2(s)/2) - 2*s + 1);
    if(st.l1>0 && st.l2>0) rows.push(['gestr. Länge', L?fmt(gl):X, L?'± 1':X]);
    return rows;
  }
  window.inbDimRows=dimRows;
  // ============ ANGABEN: „Übersicht · Abmessungen“ ============
  // Desktop: Umschalter im Kasten unter der Seitenkarte (Standard: 3D → Übersicht, Zeichnung → Abmessungen).
  // Wenig Höhe (< 700 px): Kasten klappt auf den Umschalter zusammen, Inhalt als Ebene über der Bühne.
  // Mobil: „Angaben“ unten öffnet die Ebene über der ganzen Vorschau; nichts wird kleiner.
  const tolText=()=> (![5.5,20].includes(st.size) && st.series!=='sonder') ? 'Toleranzen nach ISO 2936' : 'Toleranzen in Anlehnung an ISO 2936';
  window.inbTolText=tolText;
  const dimsHTML=()=>{ const R=dimRows(); return '<p class="cfg-dims__tol">'+tolText()+'</p><table class="cfg-dims"><thead><tr><th>Maß</th><th>Nennmaß</th><th>Grenzabmaß</th></tr></thead><tbody>'+R.map(r=>'<tr><th>'+r[0]+'</th><td>'+r[1]+'</td><td>'+r[2]+'</td></tr>').join('')+'</tbody></table><p class="cfg-dimtable__foot">Alle Maße in mm</p>'; };
  const infoState={tab:'over', open:false};
  const infoView=()=>{ const v=document.querySelector('.cfg-stage__view'); return v && v.getAttribute('data-view')==='2d' ? '2d' : '3d'; };
  const infoMobile=()=>matchMedia('(max-width: 989px)').matches, infoLow=()=>!infoMobile() && matchMedia('(max-height: 699px)').matches;
  const headHTML='<div class="cfg-infohead inb-choice-row" role="tablist" aria-label="Angaben"><button type="button" class="inb-button inb-button--choice-plain" data-info="over" role="tab">Übersicht</button><button type="button" class="inb-button inb-button--choice-plain" data-info="dims" role="tab">Abmessungen</button></div>';
  (function(){ const box=document.querySelector('.cfg-panel__info'); if(box && !box.querySelector('.cfg-infohead')){ box.insertAdjacentHTML('afterbegin',headHTML); box.insertAdjacentHTML('beforeend','<div class="cfg-infodims" hidden></div>'); const tb0=document.getElementById('tb'), body=document.createElement('div'); body.className='cfg-infobody'; tb0.parentNode.insertBefore(body,tb0); body.appendChild(tb0); body.appendChild(box.querySelector('.cfg-infodims')); }
    const lay=document.getElementById('dimTable'); if(lay){ lay.classList.add('cfg-infolay'); lay.innerHTML='<div class="cfg-infolay__top">'+headHTML+'<button type="button" class="inb-button inb-button--quiet inb-button--icon cfg-infolay__close" id="dimClose"><svg class="inb-icon" data-inb-icon="plus" viewBox="0 0 24 24" aria-hidden="true" style="transform:rotate(45deg)"><path d="M4 12h16"/><path d="M12 4v16"/></svg><span class="inb-visually-hidden">Schließen</span></button></div><div class="cfg-infolay__body"></div>'; }
    const meta=document.querySelector('#cfgMeta .inb-choice-row'); if(meta && !meta.querySelector('[data-info]')) meta.insertAdjacentHTML('afterbegin','<button type="button" class="inb-button inb-button--choice-plain" data-info="over">Übersicht</button><button type="button" class="inb-button inb-button--choice-plain" data-info="dims">Abmessungen</button>'); })();
  function infoRender(){
    const tab=infoState.tab, box=document.querySelector('.cfg-panel__info'), lay=document.getElementById('dimTable');
    const noSel = infoLow() && !infoState.open;   // wenig Höhe und keine Ebene offen: nichts hervorheben
    document.querySelectorAll('[data-info]').forEach(b=>{ const inMeta=!!b.closest('#cfgMeta'); const inLay=!!b.closest('.cfg-infolay'); const on = !(noSel && b.closest('.cfg-panel__info')) && (!inMeta || infoState.open) && (!(inLay && infoMobile()) || infoState.open) && b.getAttribute('data-info')===tab; b.setAttribute('aria-pressed',String(on)); b.setAttribute('aria-selected',String(on)); });
    if(box){ const tb=document.getElementById('tb'), dd=box.querySelector('.cfg-infodims'); if(tb){ tb.hidden=false; tb.classList.toggle('is-behind', tab!=='over'); } if(dd){ dd.hidden = tab!=='dims'; if(tab==='dims') dd.innerHTML=dimsHTML(); } }
    const noPanel=!!document.querySelector('.cfg-panel.is-summary');   // ab Schritt 7 gibt es keine Übersicht mehr
    if(noPanel) infoState.open=false;
    if(lay){ const mob=infoMobile(), show=!noPanel && (mob || (infoState.open && infoLow())); lay.hidden=!show; lay.classList.toggle('is-open', !!infoState.open); lay.classList.toggle('is-bar', mob);
      if(show && (infoState.open || !mob)){ const body=lay.querySelector('.cfg-infolay__body'); body.innerHTML = tab==='dims' ? dimsHTML() : '<div class="titleblock cfg-infolay__grid">'+((document.getElementById('tb')||{}).innerHTML||'')+'</div>'; } }
    const tg=document.getElementById('dimToggle'); if(tg) tg.setAttribute('aria-pressed',String(infoState.open));
    if(window.inbRefit3d && infoMobile() && !window.__mini3d) window.inbRefit3d();
  }
  window.inbDimRender=infoRender;
  window.inbDimApply=function(){ infoState.tab = infoView()==='2d' ? 'dims' : 'over'; infoRender(); };   // bei jedem Ansichtswechsel: Standard der Ansicht
  document.addEventListener('click',e=>{
    const t=e.target.closest('[data-info]'); if(t){ const k=t.getAttribute('data-info');
      if(t.closest('#cfgMeta') || (t.closest('.cfg-infolay') && infoMobile())){ infoState.open = !(infoState.open && infoState.tab===k); infoState.tab=k; infoRender(); return; }   // mobil: gleicher Reiter schließt
      infoState.tab=k; if(infoLow() && t.closest('.cfg-panel__info')) infoState.open=true; infoRender(); return; }
    if(e.target.closest('#dimToggle')){ infoState.open=!infoState.open; infoRender(); return; }
    if(e.target.closest('#dimClose')){ infoState.open=false; infoRender(); } });
  addEventListener('resize',()=>infoRender());
  const hrcOf=s=> s<=8 ? 52 : s<=14 ? 48 : 45;
  const hardTxt=s=>{ const md=HARD[s]; return md==null ? `min. ${hrcOf(s)} HRC` : `min. ${hrcOf(s)} HRC, ${String(md).replace('.',',')} N·m`; };
  const $ = id => document.getElementById(id);
  // Hinweiskasten füllen: note(el, 'info'|'change'|'error'|'ok', 'Titel.', 'Text'); leer = ausblenden
  const noteKind=(el,k)=>{ ['info','change','error','ok'].forEach(x=>el.classList.remove('cfg-note--'+x)); el.classList.add('cfg-note'); if(k) el.classList.add('cfg-note--'+k); };   // eigene Klassen bleiben erhalten
  window.inbNote=function(el,kind,title,text){ if(!el) return; if(!title && !text){ el.innerHTML=''; el.__html=''; noteKind(el); return; }
    title=(title||'').replace(/\.$/,'');   // Überschrift = Ereignis, ohne Punkt
    const html=(title?'<strong>'+title+'</strong> ':'')+(text||''); if(el.__html===html+kind) return; el.__html=html+kind;
    noteKind(el,kind); el.innerHTML=html; el.classList.remove('is-in'); void el.offsetWidth; el.classList.add('is-in'); };
  const fmt = n => (Math.round(n*10)/10).toLocaleString('de-DE');
  const fmtS = n => String(Math.round(n*10)/10);   // Schlüsselweite mit Punkt: 0.7, 2.5
  const STORE = 'iso2936-config-v1';
  // Farbcodierung: lieferbare RAL-Töne (Farbwerte für die Darstellung)
  const RAL=[['3001','#9C281C'],['5013','#18204C'],['5005','#24387C'],['5018','#309CDC'],['6024','#448838'],['6017','#70B054'],['1021','#F4BC44'],['1007','#E8943C'],['2004','#E06C34']];
  const ralOf=hex=>{ const r=RAL.find(x=>x[1].toLowerCase()===String(hex).toLowerCase()); return r?r[0]:''; };

  // Gemeinsame Geometrie für Zeichnung und 3D-Modell (Vielfache von s).
  // Biegeradius der Mittellinie: innen 0,6 s, außen 1,6 s. Schematisch.
  const GEO={bend:1.5};   // Mittellinie 1,5 s → Innenradius r = s (DIN ISO 2936: r ≥ s, mind. 1,5 mm)

  // Kugelkopf, schematisch nach Produktfotos, Patentschriften und der Fertigung
  // durch Polygondrehen. Jeder Querschnitt ist ein Sechskant mit der
  // Schlüsselweite 2·a(u), zusätzlich begrenzt durch einen Kreis mit Radius r(u):
  //   Kegel   Der Kreis schneidet zuerst die Ecken an, die Flächen laufen
  //           spitzbogig aus.
  //   Hals    rund und hohl gekehlt (Taille), dünnste Stelle rNeck.
  //   Kugel   sechs Flächen, längs gewölbt (Bogen mit Radius rBall um die
  //           Kugelmitte), Kanten scharf; in der Mitte Schlüsselweite s.
  //   Stirn   eben, sechseckig.
  const KK=(function(){
    const p={cone:0.26, rConeEnd:0.36, rNeck:0.30, rBall:0.5, aTip:0.33, kBall:12};
    p.rCorner=1/Math.sqrt(3);                                         // e/2
    const slope=(p.rCorner-p.rConeEnd)/p.cone;                        // Kegel, tangential in die Kehle
    p.kNeck=slope*slope/(4*(p.rConeEnd-p.rNeck));
    p.um=p.cone+(p.rConeEnd-p.rNeck)*2/slope;                         // dünnste Stelle
    p.uc=p.um+Math.sqrt(p.rBall**2-p.rNeck**2);                        // Kugelmitte
    p.len=p.uc+Math.sqrt(p.rBall**2-p.aTip**2);                        // Länge ab Schaftende
    p.r=u=> u<=p.cone ? p.rCorner-slope*u
          : u<=p.um ? p.rNeck+p.kNeck*(u-p.um)**2
          : p.rNeck+p.kBall*(u-p.um)**2;
    p.a=u=> u<p.um ? 0.5 : Math.sqrt(Math.max(p.rBall**2-(u-p.uc)**2,0));
    // Abstand von der Achse unter dem Winkel phi (Ecken bei 30° + n·60°)
    // Kanten leicht gerundet (Radius EDGE × s), wie bei einem gezogenen Sechskant
    p.EDGE=0.06;
    p.hexRho=(a,phi,rr)=>{
      const T=Math.PI/3, ph=(((phi-T/2)%T)+T)%T, flat=a/Math.cos(ph-T/2);
      if(!(rr>0)) return flat;
      const g=Math.min(ph,T-ph), c=(a-rr)/Math.cos(T/2), gT=Math.atan2(rr*0.5, c+rr*Math.cos(T/2));
      if(g>gT) return flat;
      const disc=rr*rr-(c*Math.sin(g))**2; if(disc<0) return flat;
      return Math.min(flat, c*Math.cos(g)+Math.sqrt(disc));
    };
    p.rho=(u,phi)=>{ const a=p.a(u); return Math.min(p.hexRho(a,phi,Math.min(p.EDGE,a*0.3)), p.r(u)); };
    p.stations=()=>{ const a=[], add=(u0,u1,n)=>{ for(let i=a.length?1:0;i<=n;i++) a.push(u0+(u1-u0)*i/n); };
      add(0,p.cone,12); add(p.cone,p.um,10); add(p.um,p.len,44); return a; };
    // Kontur der Seitenansicht (Blick auf zwei Flächen): halbe Breite = min(a, r)
    // top=true: Draufsicht, Blick auf eine Fläche; die Breite geht über die Ecken
    p.outline=(ex,ey,dx,dy,t,k,top)=>{
      const nx=-dy, ny=dx, L=p.len*k*t, sx=ex-dx*L, sy=ey-dy*L, A=[], B=[];
      p.stations().forEach(u=>{ const flat=Math.min(p.a(u),p.r(u)), w=top?Math.max(0,1-u/p.cone):0, h=(flat*(1-w)+p.rho(u,Math.PI/2)*w)*t /* unten: gleiche Kugel, Übergang bündig an den Schaft */, x=sx+dx*u*k*t, y=sy+dy*u*k*t;
        A.push([x+nx*h,y+ny*h]); B.push([x-nx*h,y-ny*h]); });
      return A.concat(B.reverse()).map(q=>q[0].toFixed(2)+','+q[1].toFixed(2)).join(' ');
    };
    p.fit=(avail,t)=>Math.max(0.4,Math.min(1,avail/(p.len*t)));
    return p;
  })();

  // Größen-Chips
  const sizesEl = $('sizes');
  NORM.forEach(([s])=>{
    const l = document.createElement('label'); l.className='chip';
    l.innerHTML = `<input type="radio" name="size" value="${s}"><span class="inb-button inb-button--choice">${fmtS(s)}</span>`;
    sizesEl.appendChild(l);
  });
  const tbody = document.querySelector('#normTable tbody');
  NORM.forEach(([s,a,b,c])=>{
    const tr=document.createElement('tr'); tr.dataset.s=s;
    tr.innerHTML=`<td>${fmtS(s)}</td><td>${fmt(a)}</td><td>${b?fmt(b):'–'}</td><td>${fmt(c)}</td>`;
    tbody.appendChild(tr);
  });

  const defaults = {size:8,series:'kurz',l1:100,l2:36,endLong:'gerade',endShort:'gerade',chamfer:'gefast',material:'CrV',surface:'verchromt',color:'#9C281C',markSize:false,engraving:'',qty:0,notes:'',company:'',person:'',email:'',address:'',city:'',phone:''};
  let st = Object.assign({}, defaults);
  // Kein Wiederherstellen aus dem Browser: ohne eigene Wahl steht immer das Grundprodukt da
  // Link auf eine Konfiguration: #k=… (nur die Maße und Ausführung, keine Kontaktdaten)
  const LINK_KEYS=['size','series','l1','l2','endLong','endShort','material','surface','color','markSize','engraving','qty'];
  try{ const m=location.hash.match(/#k=([^&]+)/); if(m){ const d=JSON.parse(decodeURIComponent(escape(atob(m[1])))); LINK_KEYS.forEach(k=>{ if(k in d) st[k]=d[k]; }); } }catch(e){}
  window.inbConfigLink=()=> location.href.split(/[?#]/)[0]+'?c='+encodeURIComponent(configCode());   // Link = Konfigurations-ID
  if(!ralOf(st.color)) st.color=RAL[0][1];

  const row = s => NORM.find(r=>r[0]===Number(s));

  function writeForm(){
    document.querySelectorAll('input[name=size]').forEach(i=>i.checked = Number(i.value)===Number(st.size));
    document.querySelectorAll('input[name=series]').forEach(i=>i.checked = i.value===st.series);
    ['l1','l2','endLong','endShort','material','surface','color','engraving','qty','notes','company','person','email','address','city','phone'].forEach(k=>{ $(k).value = st[k]||''; });
    $('markSize').checked = !!st.markSize;
    document.querySelectorAll('input[name=ral]').forEach(i=>i.checked = i.value.toLowerCase()===String(st.color).toLowerCase());
    document.querySelectorAll('input[name=kkLong]').forEach(i=>i.checked = i.value===st.endLong);
    document.querySelectorAll('input[name=stampYN]').forEach(i=>i.checked = (i.value==='ja')===!!st.markSize);
    document.querySelectorAll('input[name=kkShort]').forEach(i=>i.checked = i.value===st.endShort);
  }
  // Stempelung höchstens über die halbe Länge des langen Schenkels:
  // Zeichen (Versalien, gesperrt) ≈ 0,5 × s breit
  // Stempelung: Platz = halbe Länge von l₁ (Kalkulation wie bisher). Schrift jetzt schmaler und leichter gesetzt:
  // Zeichenbreite inkl. Laufweite ≈ 0,25 × s (vorher 0,5 × s); zwischen den Elementen 2 Zeichen Abstand.
  const STAMP_ADV=0.25, STAMP_GAP=2;
  function stampMaxChars(){ const s=st.size, l1=st.l1>0?st.l1:10; return Math.max(0, Math.floor((l1/2)/(STAMP_ADV*s))); }
  // Reihenfolge auf dem Schlüssel: 8 · Marke · Werkstoff · MADE IN GERMANY. Vorrang bei Platzmangel: 8 → Marke → MiG → Werkstoff
  function stampParts(){
    if(st.size<3) return {line:'', items:[], migFits:false, crv:''};
    const max=stampMaxChars(), sw=$('markSize').checked?String(fmtS(st.size)).replace('.',','):'';
    const own=($('engraving').value||'').trim(), brand= own || (st.inbus==='ja'?'INBUS®':'');
    const len=a=>a.filter(Boolean).reduce((n,x,i)=>n+x.length+(i?STAMP_GAP:0),0);
    const base=[sw,brand], MIG='MADE IN GERMANY';
    const migFits = len([...base,MIG])<=max;
    const migOn = st.mig && migFits;
    const withMig=[...base, migOn?MIG:''];
    const crv = !st.crvWant ? '' : len([...base,'59CrV4',migOn?MIG:''])<=max ? '59CrV4' : len([...base,'CrV',migOn?MIG:''])<=max ? 'CrV' : '';
    const crvFits = len([...base,'CrV',migOn?MIG:''])<=max;
    const items=[sw,brand,crv,migOn?MIG:''].filter(Boolean);
    return {line: items.join('  '), items, migFits, crvFits, crv, max, used: len(items)};
  }
  window.inbStampParts=()=>stampParts();
  window.inbL1=()=>st.l1;
  window.inbStampMax=()=>{ const all=stampMaxChars(), sw=$('markSize').checked ? String(fmtS(st.size)).length+STAMP_GAP : 0; return Math.max(0, all-sw); };   // eigene Marke hat Vorrang vor MiG und Werkstoff
  function readForm(){
    { const h=document.querySelector('input[name=hardYN]:checked'); st.hard = h ? h.value : ''; }
    { const ib=document.querySelector('input[name=inbusYN]:checked'); st.inbus = ib ? ib.value : ''; }
    { const ch=document.querySelector('input[name=chamfer]:checked'); st.chamfer = ch ? ch.value : (st.size<3 ? 'gratfrei' : 'gefast'); }   // Fase: gefast oder gratfrei (unter 3 mm immer gratfrei)
    const ral=document.querySelector('input[name=ral]:checked'); if(ral) $('color').value=ral.value;
    const sz = document.querySelector('input[name=size]:checked'); if(sz) st.size = Number(sz.value);
    const se = document.querySelector('input[name=series]:checked'); if(se) st.series = se.value;
    // Sonderlänge erst übernehmen, wenn das Feld verlassen wurde und der Wert gültig ist –
    // während des Tippens bleiben 3D und Zeichnung beim letzten gültigen Stand
    { const lo=2*(parseFloat((document.querySelector('input[name=size]:checked')||{}).value)||st.size), r0=row(st.size), hi=2*(r0[2]||r0[1]);
      const ok=(k,v)=> isFinite(v) && document.activeElement!==$(k) && v>=lo && v<=hi;
      const a=parseFloat($('l1').value), b=parseFloat($('l2').value);
      if(ok('l1',a)) st.l1=a;
      if(ok('l2',b) && b<=(ok('l1',a)?a:st.l1)) st.l2=b; }
    ['endLong','endShort','material','surface','color','engraving','notes','company','person','email','address','city','phone'].forEach(k=> st[k]=$(k).value||(k in defaults?defaults[k]:''));
    st.qty = parseInt($('qty').value,10);
    st.markSize = st.size>=3 && $('markSize').checked;
    st.mig = st.size>=3 && ((document.querySelector('input[name=migYN]:checked')||{}).value==='ja');
    st.crvWant = st.size>=3 && ((document.querySelector('input[name=crvYN]:checked')||{}).value==='ja');
    st.baseSurface = st.surface;                        // Oberfläche der freien Enden
    const fc=document.querySelector('input[name=fcYN]:checked');
    if(fc && fc.value==='ja' && document.querySelector('input[name=ral]:checked')) st.surface='farbcodiert';   // Farbe erst mit gewähltem RAL-Ton   // eigener Schritt „Farbe“
  }
  function applySeries(){
    const r = row(st.size);
    if(st.series==='lang' && !r[2]){ st.series='kurz'; }
    if(st.series==='kurz'){ st.l1=r[1]; st.l2=r[3]; }
    if(st.series==='lang'){ st.l1=r[2]; st.l2=r[3]; }
    const langInput = document.querySelector('input[name=series][value=lang]');
    langInput.disabled = !r[2];
    langInput.parentElement.title = r[2]?'':'Für diese Schlüsselweite ist keine lange Serie genormt';
    const custom = st.series==='sonder';
    $('l1').disabled = $('l2').disabled = false;   // Sonderlänge: jederzeit eingeben – das wählt Standard/Extra-lang ab
    // Norm unter Kurz und Lang, mit den Maßen für die gewählte Schlüsselweite
    $('normKurz').textContent = `${fmt(r[1])} × ${fmt(r[3])} mm`;
    $('normLang').textContent = r[2] ? `${fmt(r[2])} × ${fmt(r[3])} mm` : '–';
    window.inbNote($('langNote'), r[2]?null:'info', r[2]?'':'Extra-lang nicht verfügbar', r[2]?'':'Für diese Schlüsselweite nur Standardlänge.');
    if(!$('lenHint').__keep) window.inbNote($('lenHint'));   // nur Hinweise nach einer Umstellung
    { const lo=2*st.size, hi=2*(r[2]||r[1]); ['l1','l2'].forEach(k=>{ $(k).min=lo; $(k).max=hi; }); }
  }

  window.inbLenBounds=()=>{ const r=row(st.size); return {min:2*st.size, max:2*(r[2]||r[1])}; };
  function checks(){
    const r=row(st.size), devs=[], errs=[];
    const s=st.size;
    if(!(st.l1>0)||!(st.l2>0)) errs.push('Bitte beide Schenkellängen angeben.');
    else{
      const lMin=2*s, lMax=2*(r[2]||r[1]);   // Sonderlängen: je mindestens 2 × s, höchstens doppelt so lang wie Extra-lang
      if(st.l1 < lMin || st.l2 < lMin) errs.push(`l₁ und l₂ müssen mindestens ${fmt(lMin)} mm lang sein (2 × s).`);
      if(st.l1 > lMax || st.l2 > lMax) errs.push(`l₁ und l₂ dürfen höchstens ${fmt(lMax)} mm lang sein (2 × Extra-lang).`);
      if(st.l1 < st.l2) errs.push('Der lange Schenkel l₁ muss mindestens so lang sein wie l₂.');
      // Norm ergibt sich aus der gewählten Länge und dem Kugelkopf
      if(st.series==='sonder') devs.push(`Sonderlänge ${fmt(st.l1)} × ${fmt(st.l2)} mm (Norm: l₁ ${[r[1],r[2]].filter(Boolean).map(fmt).join(' bzw. ')} mm, l₂ ${fmt(r[3])} mm)`);
    }
    if(st.surface==='farbcodiert' && window.inbFcOk && !window.inbFcOk(s)) errs.push('Pulverbeschichtung gibt es nur für s = 1,5 · 2 · 2,5 · 3 · 4 · 5 · 6 · 8 · 10 mm.');
    if(st.hard==='nein') devs.push('Ungehärtet (ISO 2936 verlangt durchgehend gehärtete Schlüssel)');
    if(st.endLong==='kugel') devs.push('Kugelkopf am langen Schenkel (in ISO 2936 nicht beschrieben)');
    if(st.endShort==='kugel') devs.push('Kugelkopf am kurzen Schenkel (in ISO 2936 nicht beschrieben)');
    if(st.endShort==='kugel' && s<2) errs.push('Kugelkopf am kurzen Schenkel ist unter s = 2 mm nicht sinnvoll herstellbar.');
    if((st.endLong==='kugel'||st.endShort==='kugel') && s<1.5) errs.push('Kugelkopf ist erst ab s = 1,5 mm verfügbar.');
        if(st.engraving && s<3) errs.push('Eigene Stempelung ist erst ab s = 3 mm lesbar möglich.');
    if(st.surface==='farbcodiert' && window.inbFcSizes.indexOf(s)<0) errs.push('Pulverbeschichtung ist nur für s = 1,5 · 2 · 2,5 · 3 · 4 · 5 · 6 · 8 · 10 mm möglich.');
    return {devs,errs};
  }

  function code(){
    const e = (st.endLong==='kugel'?'K':'G')+(st.endShort==='kugel'?'K':'G');
    const sf = {'brüniert':'BR','phosphatiert':'PH','verchromt':'CR','vernickelt':'NI','verzinkt':'ZN','farbcodiert':'FC'+ralOf(st.color),'blank':'BL'}[st.surface];
    const ser = {kurz:'K',lang:'L',sonder:'S'}[st.series];
    return `ISO2936-${String(st.size)}-${ser}${fmt(st.l1)}x${fmt(st.l2)}-${e}-${st.material}-${sf}`;
  }

  // Zeichnung
  // Ansicht von unten auf den langen Schenkel: um die Achse um 90° gedreht, Blick auf die Außenseite;
  // die obere Fläche. Breite über Ecken e, in der Mitte die Fläche (Breite e/2),
  // darauf mittig die Stempelung. Links der kurze Schenkel von oben (Stirnseite).
  function topView(p){
    const eh=p.t/Math.sqrt(3), c=p.cy, xs=p.x0+p.t/2, st_=`fill="${p.fill}" stroke="${p.stroke}" stroke-width="${p.sw}" stroke-linejoin="round"`;
    // Von unten: der lange Schenkel über die ganze Länge bis zur Außenkante der
    // Biegung; der kurze Schenkel liegt dahinter und ist verdeckt.
    let g=`<rect x="${p.x0}" y="${c-eh}" width="${p.xeS-p.x0}" height="${2*eh}" ${st_}/>`;
    g+=`<line x1="${p.x0+p.ro}" y1="${c-eh/2}" x2="${p.xeS}" y2="${c-eh/2}" stroke="${p.stroke}" stroke-width="${p.thin}"/>`
      +`<line x1="${p.x0+p.ro}" y1="${c+eh/2}" x2="${p.xeS}" y2="${c+eh/2}" stroke="${p.stroke}" stroke-width="${p.thin}"/>`;
    if(p.endFill){ const xa=Math.max(p.x0+p.ro,p.xeS-p.uEnd); g+=`<rect x="${xa}" y="${c-eh}" width="${p.xeS-xa}" height="${2*eh}" fill="${p.endFill}" stroke="${p.stroke}" stroke-width="${p.sw}"/>`; }
    if(p.kL) g+=`<polygon points="${KK.outline(p.xe,c,1,0,p.t,p.fL,true)}" ${p.endFill?st_.replace(`fill="${p.fill}"`,`fill="${p.endFill}"`):st_}/>`;
    const txt=st.stampLine||'';   // 8 · Marke · Werkstoff · MADE IN GERMANY
    const xm=(p.x0+p.ro+p.xeS)/2, a0=p.x0-p.axis.over, a1=p.xe+p.axis.over, ax=(x1,x2)=>x2>x1?`<line x1="${x1.toFixed(2)}" y1="${c}" x2="${x2.toFixed(2)}" y2="${c}" stroke="${p.axis.color}" stroke-width="${p.axis.w}" stroke-dasharray="${p.axis.dash}"/>`:'';
    if(txt){
      // Schrifthöhe: Versalien füllen etwa 80 % der Fläche (Versalhöhe ≈ 0,72 × Schriftgröße; Luft für Grat und Ersatzschriften),
      // höchstens so breit, dass der Text auf das gerade Stück passt
      const room=Math.min((p.xeS-(p.x0+p.ro))*0.85, (st.l1/2)*(p.sc||1)), perChar=0.52+0.04;   // schmaler, wenig gesperrt; höchstens halbe Länge von l1
      const fs=Math.min(eh*0.8/0.72, 0.25*st.size*(p.sc||1)/perChar);   // feste Schriftgröße: 0,25 × s je Zeichen – unabhängig von der Textlänge
      const half=txt.length*fs*perChar/2+fs*0.5;   // Lücke in der Mittellinie
      g+=ax(a0,xm-half)+ax(xm+half,a1);
      const ta=`x="${xm.toFixed(2)}" text-anchor="middle" dominant-baseline="alphabetic" font-size="${fs.toFixed(2)}" font-weight="300" letter-spacing="${(fs*0.04).toFixed(2)}" ${p.font||''}`;
      if(p.deboss){   // Tiefprägung: heller Grat leicht versetzt, darüber dunkler als das Material
        g+=`<text class="cfg-stamp" ${ta} y="${(c+fs*0.35).toFixed(2)}" style="fill:${window.stampInk()}">${escapeXml(txt)}</text>`;   // Grundlinie so, dass die Versalien mittig stehen
      } else g+=`<text ${ta} y="${(c+fs*0.35).toFixed(2)}" style="fill:${p.textFill}">${escapeXml(txt)}</text>`;
    } else g+=ax(a0,a1);
    return g;
  }
  // Schrift auf der Farbe: hell oder dunkel je nach Helligkeit
  function onColor(hex){ const n=parseInt(String(hex).slice(1),16), r=n>>16&255, g=n>>8&255, b=n&255; return (0.299*r+0.587*g+0.114*b)>150 ? 'var(--ink)' : '#fff'; }

  function drawSVG(){
    const svg=$('svg'), s=st.size, l1=st.l1>0?st.l1:10, l2=st.l2>0?st.l2:5;
    // Zeichenfläche folgt dem Seitenverhältnis der Vorschau: Breite fest 800,
    // Höhe passend. So nutzt die Zeichnung den Platz, den der Bildschirm hat.
    const cvb=document.querySelector('.cfg-stage__canvas');
    let cr=window.__exportAspect ? {width:800, height:800/window.__exportAspect} : (cvb?cvb.getBoundingClientRect():null);
    { const bar=document.querySelector('.cfg-infolay.is-bar:not([hidden])'); if(!window.__exportAspect && cr && bar){ const br=bar.getBoundingClientRect(); if(br.height) cr={width:cr.width, height:Math.max(80, br.top-cr.top-8), top:cr.top, left:cr.left}; } }   // mobil: Leiste freihalten
    const W=800, H=Math.round(Math.min(1400, Math.max(360, cr&&cr.width>50&&cr.height>50 ? 800*cr.height/cr.width : 440)));
    svg.setAttribute('viewBox',`0 0 ${W} ${H}`); svg.dataset.vbw=W; svg.dataset.vbh=H;   // Grund-Ausschnitt; Zoom rechnet davon aus
    const side={x:40,y:30,w:W-100,h:H-50};
    const XF=window.__exportFonts, FD=XF?XF.d:15, FL=XF?XF.l:12.5, FA=XF?XF.a:14;   // Schriftgrößen wie in app-174; im Export in Papier-mm umgerechnet
    const eMm = s/Math.cos(Math.PI/6);
    // Zwei Anordnungen des Schnitts, die größere gewinnt:
    //  oben   – über dem kurzen Schenkel (hohe Fläche)
    //  rechts – rechts neben der Seitenansicht, auf Höhe des Schnitts (breite Fläche)
    const scAbove = Math.min((side.w-60)/l1, (H-300-7*FD)/(l2+eMm+2*s/Math.sqrt(3)));   // Platz für größere Schrift und Ausrichtung am Papier
    const scRight = Math.min((W-290)/(l1+s), (H-300)/(l2+eMm));
    const secRight = scRight > scAbove*1.05;
    const sc = Math.max(0.05, secRight ? scRight : scAbove);
    const t = Math.max(s*sc, 3);
    const R = Math.max(t, 1.5*sc);   // Innenradius r = s, mindestens 1,5 mm (wie 3D)
    // Rasterschritt fürs Ausrichten: die kräftigste Papierlinie (10, 5 oder 1 Teilung), die nicht zu weit auseinander liegt
    const kpx0=(cr&&cr.width)?Math.min(cr.width/W, cr.height/H):1, uMM=[1,2,5,10,20,50].find(k=>k*sc*kpx0>=5)||50;
    const snapStep=[10,5,1].map(k=>k*uMM*sc).find(v=>v<=90)||uMM*sc;
    const snapTo=(v,ref,minV)=>{ let n=Math.round((v-ref)/snapStep); let r=ref+n*snapStep; if(minV!=null) while(r<minV) r+=snapStep; return r; };
    // waagerecht mittig: linke Maße (50) + Schlüssel + ggf. Schnitt rechts mit Beschriftung
    const contentW = 50 + l1*sc + (secRight ? 90 + Math.max(s*sc,3) + 80 : 30);
    const x0 = Math.max(side.x+50, (W-contentW)/2 + 50);
    const kSec = Math.max(1, 30/(t/Math.sqrt(3)));    // Schnitt bei kleinen Schlüsseln vergrößert dargestellt
    const rcS = t/Math.sqrt(3)*kSec;                  // halbe Eckweite des Schnitts in px
    const topBlock = secRight ? 30 : 50 + 2*rcS + 92;  // Platz über der Seitenansicht (Schnitt oben)
    const usedH = topBlock + l2*sc + 70 + 2*rcS + 130;    // bis unter die Maßzahl l1 (mit Luft für Ausrichtung am Papier)
    const dy = Math.max(0, (H - side.y - usedH)/2);       // senkrecht mittig
    const yt = side.y + dy + topBlock;                   // Ende kurzer Schenkel (oben)
    const yb = yt + l2*sc;          // Unterkante langer Schenkel
    const xe = x0 + l1*sc;          // Ende langer Schenkel (rechts)
    // Abstand zur Ansicht unten: Platz für die untere Schnittkennzeichnung A (Linie, Pfeil, Buchstabe) plus Luft
    const gapMark = 4 + Math.max(10, t*0.45) + FA*1.4;          // untere Schnittkennzeichnung A
    const yL1 = yb + gapMark + 14;                                // Maßlinie l₁ unter der Seitenansicht
    const gapA = gapMark + 14 + FD*1.45 + 26;                     // darunter Maßzahl l₁, dann Luft bis zur Ansicht unten
    const ehPx = t/Math.sqrt(3), cyT = snapTo(yb + Math.max(56, gapA + 10) + ehPx, yb - t/2, yb + ehPx + gapA);   // Mitte der Draufsicht – auf einer Papierlinie
    // Kontur: kurzer Schenkel links senkrecht, Biegung unten links, langer Schenkel nach rechts
    // Technische Zeichnung: Flächen nur leicht getönt, Farbcodierung als Hauch der RAL-Farbe
    const steel = st.surface==='farbcodiert'? `color-mix(in srgb, ${st.color} 40%, #fff)` : (st.surface==='verchromt'||st.surface==='vernickelt'||st.surface==='blank'||st.surface==='verzinkt') ? 'var(--part-paper)' : 'var(--part-paper-dark)';   // deckend, damit das Raster nicht durchscheint
    const ro = R+t, ri = R;
    // Kugelkopf: Schaft endet früher, der Kopf reicht bis l1 bzw. l2
    const kL=st.endLong==='kugel', kS=st.endShort==='kugel';
    const fL=kL?KK.fit(xe-(x0+ro)-0.05*t,t):1, fS=kS?KK.fit((yb-ro)-yt-0.05*t,t):1;
    const xeS=kL?xe-KK.len*fL*t:xe, ytS=kS?yt+KK.len*fS*t:yt;
    const path = `M ${x0} ${ytS} L ${x0} ${yb-ro} A ${ro} ${ro} 0 0 0 ${x0+ro} ${yb} L ${xeS} ${yb} L ${xeS} ${yb-t} L ${x0+ro} ${yb-t} A ${ri} ${ri} 0 0 1 ${x0+t} ${yb-ro} L ${x0+t} ${ytS} Z`;
    let ends='';
    const coated=st.surface==='farbcodiert';
    // freie Enden deckend, sonst mischt sich der Farbhauch darunter
    const baseSteel=(st.baseSurface==='verchromt'||st.baseSurface==='vernickelt'||st.baseSurface==='blank'||st.baseSurface==='verzinkt')?'var(--part-light-solid)':'var(--part-dark-solid)';
    const endFill=coated?baseSteel:steel, uS=(kS?0.6:1.5)*t, uL=(kL?0.6:1.5)*t;   // freie Enden
    const ball=(ex,ey,dx,dy,f)=>`<polygon points="${KK.outline(ex,ey,dx,dy,t,f)}" fill="${endFill}" stroke="var(--ink)" stroke-width="1.3" stroke-linejoin="round"/>`;
    if(kL) ends+=ball(xe,yb-t/2,1,0,fL);
    if(kS) ends+=ball(x0+t/2,yt,0,-1,fS);

    const dim = (x1,y1,x2,y2,label,off,vert)=>{
      const a=4.5;   // schlanke, geschlossene Pfeile
      if(!vert){
        const y=y1+off;
        return `<g stroke="var(--line)" stroke-width=".7" fill="none">
          <line x1="${x1}" y1="${y1+3}" x2="${x1}" y2="${y+6}"/><line x1="${x2}" y1="${y2+3}" x2="${x2}" y2="${y+6}"/>
          <line x1="${x1}" y1="${y}" x2="${x2}" y2="${y}"/>
          <path d="M${x1} ${y} l${a*2} ${-a/2} v${a} z M${x2} ${y} l${-a*2} ${-a/2} v${a} z" fill="var(--line)" stroke="none"/></g>
          <text x="${(x1+x2)/2}" y="${off>=0 ? y+FD*1.15 : y-FD*0.45}" text-anchor="middle" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext); font-variant-numeric: tabular-nums">${label}</text>`;
      } else {
        const x=x1+off;
        return `<g stroke="var(--line)" stroke-width=".7" fill="none">
          <line x1="${x1-3}" y1="${y1}" x2="${x-6}" y2="${y1}"/><line x1="${x2-3}" y1="${y2}" x2="${x-6}" y2="${y2}"/>
          <line x1="${x}" y1="${y1}" x2="${x}" y2="${y2}"/>
          <path d="M${x} ${y1} l${-a/2} ${a*2} h${a} z M${x} ${y2} l${-a/2} ${-a*2} h${a} z" fill="var(--line)" stroke="none"/></g>
          <text x="${off>=0 ? x+FD*1.1 : x-FD*0.55}" y="${(y1+y2)/2}" text-anchor="middle" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext); font-variant-numeric: tabular-nums" transform="rotate(-90 ${off>=0 ? x+17 : x-9} ${(y1+y2)/2})">${label}</text>`;
      }
    };

    // Querschnitt Sechskant
    // Schnitt A–A durch den kurzen Schenkel, im Maßstab der Seitenansicht und auf
    // Höhe des Schnitts ausgerichtet. Blick längs des Schenkels: die Flächen
    // stehen links und rechts (zur Biegung und nach außen), die Ecken oben/unten.
    const hs=t/2*kSec, rc=hs/Math.cos(Math.PI/6);   // Schnitt ggf. vergrößert (kSec)
    const ya=ytS+Math.max(0,(yb-ro)-ytS)*0.45;         // Schnittverlauf A–A am kurzen Schenkel
    const cx = secRight ? snapTo(xe + 90 + hs, x0+t/2, xe + 70 + hs) : x0+t/2;       // rechts neben der Seitenansicht bzw. über dem kurzen Schenkel – auf einer Papierlinie
    const cy = secRight ? snapTo(Math.max(yb-t/2, yt+rc+40), yb-t/2) : snapTo(side.y+dy+50+rc, yb-t/2);   // rechts: in einer Flucht mit dem langen Schenkel; immer auf einer Papierlinie
    let hex=''; for(let i=0;i<6;i++){ const ang=Math.PI/6+i*Math.PI/3; hex+=`${i?'L':'M'}${cx+rc*Math.cos(ang)} ${cy+rc*Math.sin(ang)} `; } hex+='Z';
    const sY=cy+rc+20;                                 // Maßlinie s unter dem Sechskant
    // Grenzabmaß als kleinere, hochgestellte Zeile wie in Werkszeichnungen: „108 +0 / −6“
    function tolT(up,down,two){ const d=two?fmt2(down):String(down); return ` <tspan font-size="0.72em" dy="-0.35em">+${up} / −${d}</tspan><tspan dy="0.35em"></tspan>`; }
    const eVal = s/Math.cos(Math.PI/6);

    const stampFill = st.surface==='farbcodiert' ? onColor(st.color) : '#fff';
    const top = topView({x0,xe,xeS,cy:cyT,t,ro,kL,fL,kS,sc,fill:steel,endFill:coated?baseSteel:'',uEnd:uL,stroke:'var(--ink)',sw:1.3,thin:.6,textFill:'var(--ink)',fmax:400,fmin:7,font:'',deboss:true,axis:{over:12,color:'var(--graphite)',w:.8,dash:'10 3 2 3'}});

    // Millimeterpapier als Vektorlinien in der Zeichnung selbst: liegt dadurch immer
    // maßstäblich und deckungsgleich unter dem Schlüssel – beim Zoomen, Verschieben und
    // bei jeder Schlüsselweite. Kräftige Linie jeden 10. mm, mittlere jeden 5., feine jeden mm.
    const mmPaper=(()=>{
      const ax=x0+t/2, ay=yb-t/2;
      const crp=cvb?cvb.getBoundingClientRect():null, kpx=(crp&&crp.width)?Math.min(crp.width/W, crp.height/H):1;
      const u=[1,2,5,10,20,50].find(k=>k*sc*kpx>=5)||50, st_=u*sc;
      const X0=-2*W, X1=3*W, Y0=-2*H, Y1=3*H; let g='';
      for(let i=Math.ceil((X0-ax)/st_); ax+i*st_<=X1; i++){ const x=(ax+i*st_).toFixed(2); g+=`<line class="${i%10===0?'mm-b':i%5===0?'mm-m':'mm-f'}" x1="${x}" y1="${Y0}" x2="${x}" y2="${Y1}"/>`; }
      for(let i=Math.ceil((Y0-ay)/st_); ay+i*st_<=Y1; i++){ const y=(ay+i*st_).toFixed(2); g+=`<line class="${i%10===0?'mm-b':i%5===0?'mm-m':'mm-f'}" x1="${X0}" y1="${y}" x2="${X1}" y2="${y}"/>`; }
      svg.dataset.paperMm=u;
      return `<g class="mm-paper" aria-hidden="true">${g}</g>`;
    })();
    svg.innerHTML = `
      ${mmPaper}
      <defs><pattern id="hatch" width="5" height="5" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="5" stroke="var(--line)" stroke-width=".6"/></pattern><pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse"><path d="M20 0H0V20" fill="none" stroke="var(--grid)" stroke-width=".6" opacity=".6"/></pattern></defs>
      <rect x="0" y="0" width="${W}" height="${H}" fill="url(#grid)"/>
      <text x="${(x0+xe)/2}" y="${yt-FL*1.2}" text-anchor="middle" font-size="${FL.toFixed(1)}" letter-spacing="${(FL*0.14).toFixed(2)}" style="fill:var(--graphite)">SEITE</text>
      <path data-side-outline d="${path}" fill="${steel}" stroke="var(--ink)" stroke-width="1.3" stroke-linejoin="round"/>
      ${coated?`<rect x="${Math.max(x0+ro,xeS-uL)}" y="${yb-t}" width="${xeS-Math.max(x0+ro,xeS-uL)}" height="${t}" fill="${baseSteel}"/><rect x="${x0}" y="${ytS}" width="${t}" height="${Math.min(yb-ro,ytS+uS)-ytS}" fill="${baseSteel}"/>
      <path d="${path}" fill="none" stroke="var(--ink)" stroke-width="1.3" stroke-linejoin="round"/>`:''}
      ${ends}
      <text x="${(x0+xe)/2}" y="${cyT+ehPx+FL*2}" text-anchor="middle" font-size="${FL.toFixed(1)}" letter-spacing="${(FL*0.14).toFixed(2)}" style="fill:var(--graphite)">UNTEN${(st.stampLine)?' / STEMPELUNG':''}</text>
      ${top}
      <line x1="${x0+t/2}" y1="${yt-12}" x2="${x0+t/2}" y2="${yb-ro}" stroke="var(--line)" stroke-dasharray="16 3 2 3" stroke-width=".7"/>
      <line x1="${x0+ro}" y1="${yb-t/2}" x2="${xe+12}" y2="${yb-t/2}" stroke="var(--line)" stroke-dasharray="16 3 2 3" stroke-width=".7"/>
      ${(()=>{ // Winkel c zwischen den Innenkanten, Radius r an der Biegung, Einzelheit X an den Enden
        const ix=x0+t, iy=yb-t, room=Math.min(l1*sc*0.35, (yb-yt)*0.45), Ra=Math.max(R*1.9, Math.min(room, R*3.4));
        if(Ra < R*1.6 || room < R*1.8) return '';
        const ah=4.5, TA=`fill="var(--line)" stroke="none"`;
        let g=`<g stroke="var(--line)" stroke-width=".7" fill="none"><path d="M${ix} ${iy-Ra} A ${Ra} ${Ra} 0 0 1 ${ix+Ra} ${iy}"/></g>`;
        g+=`<path d="M${ix} ${iy-Ra} l${ah*2} ${-ah/2} v${ah} z" ${TA}/><path d="M${ix+Ra} ${iy} l${-ah/2} ${-ah*2} h${ah} z" ${TA}/>`;
        const lx=ix+Ra+FD*0.35, ly=iy-FD*0.45;   /* Winkelangabe rechts neben dem unteren Bogenende, über dem langen Schenkel */
        g+=`<text x="${lx}" y="${ly}" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext)">c</text>`;
        // Radius r: Pfeil aus dem Inneren auf die Biegung
        const fcx=ix+R, fcy=iy-R, px=fcx-R*0.7071, py=fcy+R*0.7071, qd=Math.max(R*0.2, Ra*0.62-R), qx=fcx+qd*0.7071, qy=fcy-qd*0.7071;   /* Radius innen, deutlich vor dem Winkelbogen */
        g+=`<g data-hint-drop><g stroke="var(--line)" stroke-width=".7" fill="none"><line x1="${qx}" y1="${qy}" x2="${px}" y2="${py}"/></g>`;
        const ux=(px-qx), uy=(py-qy), ul=Math.hypot(ux,uy)||1, nx=ux/ul, ny=uy/ul;
        g+=`<path d="M${px} ${py} L${px-nx*ah*2-ny*ah/2} ${py-ny*ah*2+nx*ah/2} L${px-nx*ah*2+ny*ah/2} ${py-ny*ah*2-nx*ah/2} z" ${TA}/>`;
        g+=`<text x="${qx+FD*0.15}" y="${qy-FD*0.15}" text-anchor="start" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext)">r</text></g>`;
        return g; })()}
      ${dim(x0,yb,xe,yb,'l₁'+((window.__exportAspect||hasLen())?' = '+fmt(st.l1):''),yL1-yb,false)}
      ${dim(x0,yt,x0,yb,'l₂'+((window.__exportAspect||hasLen())?' = '+fmt(st.l2):''),-26,true)}
      <text x="${cx}" y="${cy-rc-FL*1.1-(kSec>1.05?FL*1.25:0)}" text-anchor="middle" font-size="${FL.toFixed(1)}" letter-spacing="${(FL*0.14).toFixed(2)}" style="fill:var(--graphite)">SCHNITT A–A${kSec>1.05?`<tspan x="${cx}" dy="${(FL*1.25).toFixed(1)}" font-style="italic">VERGRÖSSERT</tspan>`:''}</text>
      ${(()=>{ // Schnittverlauf A–A am langen Schenkel (wie DIN ISO 2936, Bild 1): kurze dicke Schnittlinie oben und unten,
        //  Pfeil von links mit der Spitze an der Schnittlinie (Blickrichtung zum Ende des Schenkels)
        const xa=x0+ro+(xeS-(x0+ro))*0.62, yT=yb-t-4, yB=yb+4, L=Math.max(10,t*0.45), aw=Math.max(12,t*0.5), ah=4.5;
        const arrow=(y)=>`<line x1="${xa-aw}" y1="${y}" x2="${xa-ah*2}" y2="${y}" stroke="var(--ink)" stroke-width="1"/><path d="M${xa-1} ${y} l${-ah*2} ${-ah/2} v${ah} z" fill="var(--ink)"/>`;
        let g=`<g stroke="var(--ink)" stroke-width="1.6"><line x1="${xa}" y1="${yT-L}" x2="${xa}" y2="${yT}"/><line x1="${xa}" y1="${yB}" x2="${xa}" y2="${yB+L}"/></g>`;
        g+=arrow(yT-L)+arrow(yB+L);   /* Pfeile an den äußeren Enden der Schnittlinie */
        g+=`<text x="${xa-aw*0.55}" y="${yT-L-FA*0.45}" text-anchor="middle" font-size="${FA.toFixed(1)}" font-weight="600" style="fill:var(--ink)">A</text>`;
        g+=`<text x="${xa-aw*0.55}" y="${yB+L+FA*1.15}" text-anchor="middle" font-size="${FA.toFixed(1)}" font-weight="600" style="fill:var(--ink)">A</text>`;
        return '<g data-hint-drop>'+g+'</g>'; })()}
      <path d="${hex}" fill="var(--part-light)"/><path d="${hex}" fill="url(#hatch)"/>
      ${st.surface==='farbcodiert' ? (()=>{ const w=Math.max(1.6,t*0.07), k=(rc-w/2)/rc; let h2=''; for(let i=0;i<6;i++){ const ang=Math.PI/6+i*Math.PI/3; h2+=`${i?'L':'M'}${cx+rc*k*Math.cos(ang)} ${cy+rc*k*Math.sin(ang)} `; } return `<path d="${h2}Z" fill="none" stroke="${st.color}" stroke-width="${w}" stroke-linejoin="miter"/>`; })() : ''}
      <path d="${hex}" fill="none" stroke="var(--ink)" stroke-width="1.3"/>
      <circle cx="${cx}" cy="${cy}" r="${rc}" fill="none" stroke="var(--line)" stroke-dasharray="2 2" stroke-width=".6"/>
      <line x1="${cx-hs-10}" y1="${cy}" x2="${cx+hs+10}" y2="${cy}" stroke="var(--line)" stroke-dasharray="16 3 2 3" stroke-width=".7"/>
      <line x1="${cx}" y1="${cy-rc-8}" x2="${cx}" y2="${cy+rc+8}" stroke="var(--line)" stroke-dasharray="16 3 2 3" stroke-width=".7"/>
      <g stroke="var(--line)" stroke-width=".7">
        <line x1="${cx-hs}" y1="${cy+rc/2+3}" x2="${cx-hs}" y2="${sY+6}"/><line x1="${cx+hs}" y1="${cy+rc/2+3}" x2="${cx+hs}" y2="${sY+6}"/>
        <line x1="${cx-hs}" y1="${sY}" x2="${cx+hs}" y2="${sY}"/>
        <line x1="${cx+3}" y1="${cy-rc}" x2="${cx+hs+22}" y2="${cy-rc}"/><line x1="${cx+3}" y1="${cy+rc}" x2="${cx+hs+22}" y2="${cy+rc}"/>
        <line x1="${cx+hs+16}" y1="${cy-rc}" x2="${cx+hs+16}" y2="${cy+rc}"/>
      </g>
      <path d="M${cx-hs} ${sY} l9 -2.2 v4.4 z M${cx+hs} ${sY} l-9 -2.2 v4.4 z M${cx+hs+16} ${cy-rc} l-2.2 9 h4.4 z M${cx+hs+16} ${cy+rc} l-2.2 -9 h4.4 z" fill="var(--line)"/>
      <text x="${cx}" y="${sY+FD*1.3}" text-anchor="middle" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext); font-variant-numeric: tabular-nums">s${(window.__exportAspect||hasSize())?' = '+String(fmtS(s)).replace('.',','):''}</text>
      <text x="${cx+hs+16+FD*1.1}" y="${cy}" text-anchor="middle" font-size="${FD.toFixed(1)}" transform="rotate(-90 ${cx+hs+16+FD*1.1} ${cy})" style="fill:var(--dimtext)">e${(window.__exportAspect||hasSize())?' = '+fmt2(SE[s]?SE[s][2]:eVal):''}</text>
      ${(()=>{ // Fase f: kurzer Hinweispfeil auf die Kante am Schenkelende (Wert in der Maßtabelle)
        if(!SE[s]) return '';
        const ah=4.5, TA='fill="var(--line)" stroke="none"';
        const lead=(px,py,dx,dy)=>{ const L=Math.max(22, t*0.9), qx=px+dx*L, qy=py+dy*L, ul=Math.hypot(dx,dy), nx=dx/ul, ny=dy/ul;
          return `<line x1="${qx}" y1="${qy}" x2="${px}" y2="${py}" stroke="var(--line)" stroke-width=".7"/>`
            +`<path d="M${px} ${py} L${px+nx*ah*2-ny*ah/2} ${py+ny*ah*2+nx*ah/2} L${px+nx*ah*2+ny*ah/2} ${py+ny*ah*2-nx*ah/2} z" ${TA}/>`
            +`<text x="${qx+dx*FD*0.35}" y="${qy+dy*FD*0.35+FD*0.35}" text-anchor="middle" font-size="${FD.toFixed(1)}" style="fill:var(--dimtext)">f</text>`; };
        const leadD=(...a)=>'<g data-hint-drop>'+lead(...a)+'</g>';
        if(st.chamfer==='gratfrei') return '';   // gratfrei: keine Fase
        return (st.endLong!=='kugel' ? leadD(xe, yb-t, 0.7071, -0.7071) : '')      // Ende langer Schenkel
             + (st.endShort!=='kugel' ? leadD(x0, yt, -0.7071, -0.7071) : ''); })()}   // Ende kurzer Schenkel
    `;
    window.__paperAxis={x:x0+t/2, y:yb-t/2, sc};
    svg.dataset.side=[x0, yt, xe-x0, yb-yt].map(v=>v.toFixed(1)).join(' ');   // Seitenansicht (für den Hinweis)   // sc: Zeicheneinheiten je mm
    if(!window.__exportAspect && window.inbDimRender) window.inbDimRender();
    { const tn=document.getElementById('tolNote'); if(tn){ const iso = ![5.5,20].includes(st.size) && st.series!=='sonder';   // ISO beschreibt nur Normgrößen mit Normlänge
        tn.textContent = iso ? 'Toleranzen nach ISO 2936' : 'Toleranzen in Anlehnung an ISO 2936'; } }
    // Zeichnung nach dem tatsächlichen Inhalt mittig setzen (Ausschnitt verschieben, Papier geht mit)
    try{
      const bbs=[...svg.children].filter(c=>!c.classList.contains('mm-paper')&&c.tagName!=='defs').map(c=>{try{return c.getBBox()}catch(e){return null}}).filter(b=>b&&(b.width||b.height));
      if(bbs.length){ const top=Math.min(...bbs.map(b=>b.y)), bot=Math.max(...bbs.map(b=>b.y+b.height)), lft=Math.min(...bbs.map(b=>b.x)), rgt=Math.max(...bbs.map(b=>b.x+b.width));
        const mg=18, bw=(rgt-lft)+2*mg, bh=(bot-top)+2*mg, A=W/H;
        let vw = bw/bh > A ? bw : bh*A, vh = vw/A;
        if(W/vw > 1.6){ vw=W/1.6; vh=H/1.6; }            // nicht übermäßig vergrößern (Schrift bliebe sonst riesig)
        svg.dataset.vbx=((lft+rgt)/2-vw/2).toFixed(2); svg.dataset.vby=((top+bot)/2-vh/2).toFixed(2);
        svg.dataset.vbw=vw.toFixed(2); svg.dataset.vbh=vh.toFixed(2);
        svg.setAttribute('viewBox',`${svg.dataset.vbx} ${svg.dataset.vby} ${svg.dataset.vbw} ${svg.dataset.vbh}`); }
    }catch(e){}
    if(window.inbSwapRender && !window.__exportAspect) window.inbSwapRender();
    if(window.inb2dApply) window.inb2dApply();   // Mittellinien: kurzer Schenkel (senkrecht), langer Schenkel (waagerecht)
    requestAnimationFrame(()=>window.inbAlignPaper&&window.inbAlignPaper());
  }
  // Millimeterpapier so verschieben, dass eine kräftige Linie (alle 40 px) genau auf den
  // Mittellinien des Schlüssels liegt – auch nach Zoomen und Verschieben
  window.inbAlignPaper=function(){ return;   // ersetzt durch Vektor-Millimeterpapier in der Zeichnung

    const svg=$('svg'), stage=document.querySelector('.cfg-stage'), a=window.__paperAxis; if(!svg||!stage||!a) return;
    // Lage und Maßstab aus dem sichtbaren Rechteck der Zeichnung (enthält den Zoom per CSS-Transform;
    // getScreenCTM berücksichtigt den in Safari nicht)
    const vb=svg.viewBox.baseVal, br=svg.getBoundingClientRect(); if(!vb||!vb.width||!br.width) return;
    const k=Math.min(br.width/vb.width, br.height/vb.height);
    const offX=br.left+(br.width-vb.width*k)/2-vb.x*k, offY=br.top+(br.height-vb.height*k)/2-vb.y*k;
    const q={x:offX+a.x*k, y:offY+a.y*k}, r=stage.getBoundingClientRect(), m={a:k,b:0};
    // Bildschirm-Pixel je Millimeter am Schlüssel (inkl. Zoom); feinste Teilung 1 mm, bei zu dichten Linien 2, 5 oder 10 mm
    const pxmm=(a.sc||1)*Math.hypot(m.a,m.b);
    const u=[1,2,5,10,20,50].find(k=>k*pxmm>=5)||50, fine=u*pxmm, mid=fine*5, big=fine*10;
    const ox=(((q.x-r.left)%big)+big)%big, oy=(((q.y-r.top)%big)+big)%big;
    stage.style.backgroundSize=[big,big,mid,mid,fine,fine].map(v=>v.toFixed(2)+'px '+v.toFixed(2)+'px').join(', ');
    stage.style.backgroundPosition=Array(6).fill(ox.toFixed(2)+'px '+oy.toFixed(2)+'px').join(', ');
    stage.dataset.paperMm=u;   // Teilung in mm (zur Kontrolle)
  };
  window.addEventListener('resize',()=>requestAnimationFrame(()=>window.inbAlignPaper()));
  window.inbRender=function(){ try{ render(); }catch(e){} };
  window.inbDraw=function(){ try{ drawSVG(); }catch(e){} };
  // Prägefarbe: immer die Farbe der Oberfläche, deutlich dunkler – wie eingeschlagen.
  // Auch bei Pulverbeschichtung (z. B. Rot → Dunkelrot).
  window.stampInk=function(){
    const MAP={blank:'#6f7378', verchromt:'#6a6f75', vernickelt:'#756f66', verzinkt:'#687079', phosphatiert:'#3e4145', 'brüniert':'#34373b'};
    if(st.surface==='farbcodiert'){ const n=parseInt(st.color.slice(1),16), f=0.62; const r=Math.round((n>>16&255)*f), g=Math.round((n>>8&255)*f), b=Math.round((n&255)*f); return `rgb(${r},${g},${b})`; }
    return MAP[st.baseSurface||st.surface]||'#44484d';
  };
  function escapeXml(t){return t.replace(/[<>&"']/g,c=>({'<':'&lt;','>':'&gt;','&':'&amp;','"':'&quot;',"'":'&#39;'}[c]));}

  // Zusammenfassung in der Leiste: dieselben Zeilen wie der Anfragetext,
  // Norm-Status unten in Grün oder Rot
  // Konfigurations-ID: zufällig und je Vorgang eindeutig (nicht aus den Merkmalen ablesbar).
  // Gleiche Konfiguration in derselben Sitzung behält ihre ID, jede Änderung bekommt eine neue.
  const ID_CHARS='ABCDEFGHJKLMNPQRSTUVWXYZ23456789';   // ohne 0/O und 1/I, gut vorlesbar
  let idCache={};
  // Konfigurations-ID = die komplette Konfiguration in kurzer, lesbarer Schreibweise (kein Server nötig).
  // Aufbau: <s><Serie>[-KG|GK|KK]-<H|U>-<Oberfläche[RAL]>[-SW][-INB|-T.<Text>][-Q<Menge>]-<Prüfzeichen>
  //   Serie: K Standard · L Extra-lang · S<l1>X<l2> Sonderlänge
  //   Oberfläche: BL blank · PH phosphatiert · ZN verzinkt · NI vernickelt · CR verchromt; RAL angehängt (NI3001)
  //   Text: Leerzeichen → _, Bindestrich → ~
  const SURF_CODE={blank:'BL',phosphatiert:'PH',verzinkt:'ZN',vernickelt:'NI',verchromt:'CR'};
  const num=v=>String(Math.round(v*10)/10);
  // Prüfzeichen nach Luhn mod N (N = 36, Zeichen 0–9 und A–Z): erkennt jeden einzelnen falschen
  // Buchstaben bzw. jede falsche Ziffer und fast alle Vertauschungen benachbarter Zeichen.
  // Sonderzeichen (-, ., ~, _, Ä, ®, …) gehen über ihren Zeichencode mit ein.
  const A36='0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const luhnVal=ch=>{ const i=A36.indexOf(ch); return i>=0 ? i : ch.codePointAt(0)%36; };
  function checkChar(str){ const n=36, chars=[...str]; let factor=2, sum=0;
    for(let i=chars.length-1;i>=0;i--){ let add=factor*luhnVal(chars[i]); factor = factor===2 ? 1 : 2; add = Math.floor(add/n) + (add % n); sum += add; }
    return A36[(n - (sum % n)) % n]; }
  function configCode(){
    const p=[];
    p.push(num(st.size)+({kurz:'K',lang:'L'}[st.series] || ('S'+num(st.l1)+'X'+num(st.l2))));
    const e=(st.endLong==='kugel'?'K':'G')+(st.endShort==='kugel'?'K':'G'); if(e!=='GG') p.push(e);
    if(st.chamfer==='gratfrei' && st.size>=3) p.push('GR');
    p.push(st.hard==='nein'?'U':'H');
    p.push(st.surface==='farbcodiert' ? 'NI'+ralOf(st.color) : (SURF_CODE[st.surface]||'CR'));
    if(st.markSize) p.push('SW');
    // (Marke folgt unten; Werkstoff und MiG ans Ende der Stempelung)
    const own=(document.getElementById('engraving')||{}).value||'';
    if(own.trim()) p.push('T.'+own.trim().toUpperCase().replace(/-/g,'~').replace(/ /g,'_'));
    else if(st.inbus==='ja' && st.size>=3) p.push('INB');
    if(st.crv) p.push('CRV');
    if(st.migOn) p.push('MIG');
    if(st.qty>0) p.push('Q'+st.qty);
    const body=p.join('-'); return body+'-'+checkChar(body);
  }
  function configId(){ return configCode(); }
  // Rückweg: ID prüfen und in Formularwerte übersetzen (null = ungültig)
  window.inbParseCode=function(raw){
    const code=String(raw||'').trim().replace(/^.*[?&]c=/,'').split('&')[0]; let str; try{ str=decodeURIComponent(code); }catch(e){ str=code; }
    const parts=str.toUpperCase().replace(/[™]/g,'').split('-'); if(parts.length<4) return null;
    const ck=parts.pop(), body=parts.join('-'); if(checkChar(body)!==ck) return null;
    const m=parts.shift().match(/^(\d+(?:\.\d+)?)(K|L|S(\d+(?:\.\d+)?)X(\d+(?:\.\d+)?))$/); if(!m) return null;
    const size=parseFloat(m[1]); if(!NORM.some(r=>r[0]===size)) return null;
    const o={size, series: m[2]==='K'?'kurz': m[2]==='L'?'lang':'sonder', l1: m[3]?parseFloat(m[3]):null, l2: m[4]?parseFloat(m[4]):null,
             endLong:'gerade', endShort:'gerade', hard:null, surface:null, ral:null, sw:false, inbus:false, text:'', qty:0};
    for(const seg of parts){
      if(/^(KG|GK|KK)$/.test(seg)){ o.endLong=seg[0]==='K'?'kugel':'gerade'; o.endShort=seg[1]==='K'?'kugel':'gerade'; }
      else if(seg==='H'||seg==='U'){ o.hard=seg==='H'?'ja':'nein'; }
      else if(/^(BL|PH|ZN|NI|CR)(\d{4})?$/.test(seg)){ const mm=seg.match(/^(BL|PH|ZN|NI|CR)(\d{4})?$/); o.surface=Object.keys(SURF_CODE).find(k=>SURF_CODE[k]===mm[1]); o.ral=mm[2]||null; }
      else if(seg==='GR' || seg==='UF') o.chamfer='gratfrei';
      else if(seg==='SW') o.sw=true;
      else if(seg==='INB') o.inbus=true;
      else if(seg==='CRV') o.crv=true;
      else if(seg==='MIG') o.mig=true;
      else if(/^T\./.test(seg)) o.text=seg.slice(2).replace(/~/g,'-').replace(/_/g,' ');
      else if(/^Q\d+$/.test(seg)) o.qty=parseInt(seg.slice(1),10);
      else return null;
    }
    if(!o.hard||!o.surface) return null;
    return o;
  };
  window.inbCodeOf=()=>configCode();
  window.inbResetConfigIds=()=>{ idCache={}; };
  const normName=()=> 'ISO 2936';   // gilt für Standard und Extra-lang (Bezeichnung dort: „… — 10 L“)
  function renderSummary(chk){
    const txt=summary(chk).split('\n'), a=txt.indexOf('Konfiguration'), rows=[];
    // Noch nicht gewählt: Platzhalter statt der Werte des Grundprodukts
    const isSet=k=>{ const li=document.querySelector('.cfg-step[data-key="'+k+'"]'); return !!(li&&li.classList.contains('is-set')); };
    const step={'Schlüsselweite':'size','Schenkellänge':'length','Legierung':'material','Gehärtet':'material','Oberfläche':'material','Farbe':'material','Kugelkopf':'ends','Fase':'ends','Stempelung':'stamp','Menge':'qty'};
    const ph={'Schlüsselweite':'X mm','Schenkellänge':'l₁ X mm, l₂ X mm','Legierung':'59CrV4','Gehärtet':'–','Oberfläche':'–','Farbe':'–','Kugelkopf':'–','Fase':'–','Stempelung':'–','Menge':'X Stück'};
    for(let i=a+1;i<txt.length && txt[i];i++){ const k=txt[i].indexOf(': '), key=txt[i].slice(0,k); rows.push([key, isSet(step[key])?txt[i].slice(k+2):ph[key], !isSet(step[key])]); }
    const all=Object.values(step).every(isSet);
    const sid=document.getElementById('sumId'); if(sid) sid.textContent = all?configId():'–';
    $('sumList').innerHTML=rows.map(([k,v,open,c])=>`<dt class="${c||''}">${escapeXml(k)}</dt><dd class="${(c||'')+(open?' is-open':'')}">${escapeXml(v)}</dd>`).join('');
    const bad=chk.errs.length||chk.devs.length, n=$('sumNorm');
    n.textContent = chk.errs.length ? 'Prüfung nötig' : chk.devs.length ? `${chk.devs.length} ${chk.devs.length===1?'Abweichung':'Abweichungen'} von ISO 2936` : 'Normkonform nach '+normName();
    n.className='cfg-summary__norm inb-text-body-s '+(bad?'is-deviation':'is-conform');
    renderSumDims();
    { const box=$('sumNormNote'), li=[...chk.errs.map(e=>'<li><strong>Zu klären:</strong> '+escapeXml(e)+'</li>'), ...chk.devs.map(d=>'<li>'+escapeXml(d)+'</li>')];
      if(chk.errs.length) window.inbNote(box,'error','Angaben prüfen','<ul class="cfg-note__list">'+li.join('')+'</ul>');
      else if(chk.devs.length) window.inbNote(box,'change',(chk.devs.length===1?'Abweichung':chk.devs.length+' Abweichungen')+' von ISO 2936','Anfrage als Sonderanfertigung.<ul class="cfg-note__list">'+li.join('')+'</ul>');
      else window.inbNote(box,'ok','Normkonform','Entspricht '+normName()+'.'); }
  }
  window.inbRenderSummary=()=>renderSummary(checks());
  // Speichern-Seite: kurzer Link mit Konfigurations-ID und QR-Code dazu
  // (im Shop muss /konf/<ID> auf die gespeicherte Konfiguration weiterleiten – dafür wird die ID serverseitig abgelegt)
  window.inbRenderQr=function(){ const box=document.getElementById('qrBox'), lk=document.getElementById('qrLink'); if(!box||!lk) return;
    const id=configId(), url='https://www.inbus.de/konfigurator?c='+encodeURIComponent(id);
    lk.textContent='www.inbus.de/konfigurator?c='+id;
    if(!window.QRCodeLib){ box.textContent=''; return; }
    const q=new window.QRCodeLib(-1, window.QRLevel.M); q.addData(url); q.make(); const n=q.getModuleCount(), m=2; let d='';
    for(let r=0;r<n;r++) for(let c=0;c<n;c++) if(q.isDark(r,c)) d+=`M${c+m} ${r+m}h1v1h-1z`;
    box.innerHTML=`<svg viewBox="0 0 ${n+2*m} ${n+2*m}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="#fff"/><path d="${d}" fill="#131313"/></svg>`; };
  function renderSumDims(){ const el=document.getElementById('sumDims'); if(!el) return; const R=dimRows();
    el.innerHTML='<p class="cfg-share__label">Abmessungen</p><p class="cfg-dims__tol">'+(window.inbTolText?window.inbTolText():'')+'</p><table class="cfg-dims"><thead><tr><th>Maß</th><th>Nennmaß</th><th>Grenzabmaß</th></tr></thead><tbody>'+R.map(r=>'<tr><th>'+r[0]+'</th><td>'+r[1]+'</td><td>'+r[2]+'</td></tr>').join('')+'</tbody></table><p class="cfg-dimtable__foot">Alle Maße in mm</p>'; }
  // Anfragetext: ohne Auffüllen mit Leerzeichen (das richtet sich nur in
  // Festbreitenschrift aus und läuft in E-Mails und im Shop auseinander).
  // Gleiche Begriffe wie in der Leiste, Blöcke mit Überschrift.
  function summary(chk){
    const fc = st.surface==='farbcodiert';
    const kk = {'gerade|gerade':'ohne Kugelkopf','kugel|gerade':'am langen Schenkel','gerade|kugel':'am kurzen Schenkel','kugel|kugel':'an beiden Schenkeln'}[st.endLong+'|'+st.endShort];
    const serie = {kurz:'Standard (Norm)',lang:'Extra-lang (Norm)',sonder:'Sonderlänge'}[st.series];
    const norm = chk.errs.length ? 'Prüfung nötig' : chk.devs.length ? `${chk.devs.length} ${chk.devs.length===1?'Abweichung':'Abweichungen'} von ISO 2936` : 'normkonform nach '+normName();
    const lines = [
      'Anfrage Sonderanfertigung',
      'Sechskant-Stiftschlüssel nach Maß, Basis ISO 2936',
      '',
      `Konfigurations-ID: ${configId()}`,
      `Norm: ${norm}`,
      '',
      'Konfiguration',
      `Schlüsselweite: ${fmtS(st.size)} mm`,
      `Schenkellänge: ${serie}, l₁ ${fmt(st.l1)} mm, l₂ ${fmt(st.l2)} mm`,
      `Legierung: 59CrV4`,
      `Gehärtet: ${st.hard==='ja' ? 'Ja ('+hardTxt(st.size)+' nach ISO 2936)' : st.hard==='nein' ? 'Nein' : '–'}`,
      `Oberfläche: ${($('surface').selectedOptions[0]&&$('surface').value)?$('surface').selectedOptions[0].text:'Blank (geölt)'}`,
      `Farbe: ${fc?'RAL '+ralOf(st.color)+', Pulverbeschichtung':'ohne'}`,
      `Kugelkopf: ${kk}`,
      `Fase: ${st.chamfer==='gratfrei'?'gratfrei':'gefast'}`,
      `Stempelung: ${(st.stampLine||'')||'ohne'}`,
      `Menge: ${isFinite(st.qty)?st.qty.toLocaleString('de-DE'):'–'} Stück`,
    ];
    if(chk.devs.length) lines.push('', 'Abweichungen von ISO 2936', ...chk.devs.map(d=>'– '+d));
    if(chk.errs.length) lines.push('', 'Zu klären', ...chk.errs.map(e=>'– '+e));
    if(st.notes && st.notes.trim()) lines.push('', 'Hinweise zur Anfrage', st.notes.trim());
    const k=[st.company, st.person, st.address, st.city, st.phone?'Telefon: '+st.phone:'', st.email?'E-Mail: '+st.email:''].filter(Boolean);
    if(k.length) lines.push('', 'Kontakt', ...k);
    return lines.join('\n');
  }

  // Vorschau ändert die Größe (Fenster, Leiste, Handy quer): Zeichnung neu anordnen
  if(window.ResizeObserver){ const cv=document.querySelector('.cfg-stage__canvas'); if(cv){ let tmo; new ResizeObserver(()=>{ clearTimeout(tmo); tmo=setTimeout(()=>{ try{ drawSVG(); }catch(e){} },60); }).observe(cv); } }
  // Bezeichnung der Stempelung für Texte: INBUS® als Marke, sonst „eigene „…““
  window.inbStampLabel=(txt)=> !txt ? '' : (txt==='INBUS®' ? 'INBUS®' : 'eigene „'+txt+'“');
  function stampText(){ if(st.size<3) return ''; const own=($('engraving').value||'').trim(); return own ? own : (st.inbus==='ja' ? 'INBUS®' : ''); }
  function render(){
    { const kk=!!document.querySelector('input[name=kkLong][value=kugel]:checked, input[name=kkShort][value=kugel]:checked'); const n=$('kkNote'); if(n && n.hidden===kk){ n.hidden=!kk; if(kk){ n.classList.remove('is-in'); void n.offsetWidth; n.classList.add('is-in'); } } }   // Hinweis erst nach mindestens einem „Ja“
    { const sz=document.querySelector('input[name=size]:checked'); window.inbNote($('sizeNote'), (sz && [5.5,20].includes(parseFloat(sz.value)))?'info':null, (sz && [5.5,20].includes(parseFloat(sz.value)))?'Keine ISO-Größe.':'', (sz && [5.5,20].includes(parseFloat(sz.value)))?('s = '+String(sz.value).replace('.',',')+' mm nicht in ISO 2936, Maße nach DIN 911.'):''); }
    { const h=document.querySelector('input[name=hardYN]:checked'); if(h && h.value==='nein') window.inbNote($('hardNote'),'info','Nicht nach ISO 2936.','ISO 2936 fordert durchgehend gehärtete Schlüssel. Ungehärtet gilt als Sonderanfertigung.'); else window.inbNote($('hardNote')); }
    // Stempelung: effektiver Text und Höchstzahl der Zeichen
    { const mx=window.inbStampMax(), el=$('engraving'); el.maxLength=Math.max(1,mx);
      if(el.value.length>mx){ el.value=el.value.slice(0,mx); }
      $('stampMax').textContent = st.size<3 ? '' : `Höchstens ${mx} Zeichen.`;
      st.engraving = stampText();
      const sp=stampParts(); st.stampLine=sp.line; st.crv=sp.crv; st.migOn=sp.items.includes('MADE IN GERMANY');
      const pv=$('stampPreview'); if(pv) pv.textContent = st.size<3 ? '' : (sp.line ? 'Auf dem Schlüssel: '+sp.line : ''); }
    // Gehärtet: Werte aus der Norm neben Ja/Nein
    { const hi=$('hardInfo'), md=HARD[st.size]; if(hi) hi.textContent = `ISO 2936, s = ${fmtS(st.size)} mm: Härte mind. ${hrcOf(st.size)} HRC`+(md!=null?` · Prüfdrehmoment mind. ${String(md).replace('.',',')} N·m`:''); }
    applySeries();
    ['l1','l2'].forEach(k=>{
      const sonder=st.series==='sonder', r=row(st.size), norm = k==='l1' ? ((st.series==='lang'&&r[2])?r[2]:r[1]) : r[3];   // Platzhalter: Maß der gewählten Normlänge
      $(k).placeholder = '';   // Sonderlänge: Felder leer, die Normmaße stehen unter den Knöpfen
      if(!sonder && document.activeElement!==$(k)) $(k).value = '';   // Normlänge: Felder leer; bei Sonderlänge gehört das Feld der Eingabe
    });
    $('colorRow').hidden = st.surface!=='farbcodiert';
    const chk = checks();
    const status=$('status');
    if(chk.errs.length){ status.textContent='Prüfung erforderlich'; }
    else if(chk.devs.length){ status.textContent=`${chk.devs.length} ${chk.devs.length===1?'Abweichung':'Abweichungen'} von ISO 2936`; }
    else { status.textContent='Normkonform nach ISO 2936'; }

    const dl=$('devs');
    const items=[...chk.errs.map(e=>`<li style="color:var(--warn)"><strong>Zu klären:</strong> ${escapeXml(e)}</li>`), ...chk.devs.map(d=>`<li>${escapeXml(d)}</li>`)];
    dl.className = 'devlist'; dl.hidden = !items.length;
    dl.innerHTML = items.join('');

    document.querySelectorAll('#normTable tbody tr').forEach(tr=>tr.classList.toggle('cur', Number(tr.dataset.s)===st.size));

    // Feld „Norm“ trägt den Status: bei Abweichung ganz rot
    const nDev=chk.devs.length, normBad=nDev>0||chk.errs.length>0;
    const normTxt= chk.errs.length ? 'Prüfung nötig'
                 : nDev ? `${nDev} ${nDev===1?'Abweichung':'Abweichungen'}` : 'Normkonform';
    // Schriftfeld: Kopfzeile, Werte unter der Zeichnung, kurze Fassung für mobil
    const cell=([k,v,c])=>`<div${c?` class="${c}"`:''}><span class="k">${k}</span><span class="v">${escapeXml(String(v))}</span></div>`;
    // Norm: ein Feld wie die anderen. Normgerecht steht die Norm da,
    // sonst „Sonderanfertigung“ (nicht fertigbar: „Prüfung nötig“)
    // Angaben zeigen „–“, bis der jeweilige Schritt gewählt ist (wie bei der Menge)
    const picked=n=>!!document.querySelector('input[name="'+n+'"]:checked');
    const hasSize=picked('size'), hasSeries=picked('series'), hasSurf=!!$('surface').value,
          hasEnds=picked('kkLong')&&picked('kkShort'), hasStamp=(st.size<3)||(picked('stampYN')&&picked('inbusYN'));
    const normHtml=cell(['Norm', !hasSeries ? '–' : chk.errs.length ? 'Prüfung nötig' : nDev ? 'Sonderanfertigung' : normName()]);
    const endT=v=>v==='kugel'?'Kugelkopf':'gerade';
    const stamp=st.stampLine||'ohne';   // z. B. 8  INBUS®  59CrV4  MADE IN GERMANY
    const codeCell=['Konfigurations-ID',code(),'code'];
    // Oberfläche mit RAL in der zweiten Zeile; die Zeile steht immer da, damit nichts springt
    const fcTxt=st.surface==='farbcodiert' ? ` / <span class="tb-fc" style="--tb-fc:${st.color}" title="Pulverbeschichtet, RAL ${ralOf(st.color)}">RAL ${ralOf(st.color)}</span>` : '';
    const surfCell=!hasSurf ? cell(['Oberfläche','–']) : `<div><span class="k">Oberfläche</span><span class="v" title="${escapeXml(st.baseSurface||st.surface)}${st.surface==='farbcodiert'?' / pulverbeschichtet, RAL '+ralOf(st.color):''}">${escapeXml(st.baseSurface||st.surface)}${fcTxt}</span></div>`;
    // Überschrift je nach Auswahl „Gehärtet“ bzw. „Ungehärtet“; darunter nur Härte und Prüfdrehmoment nach Norm
    const hasHard=picked('hardYN'), hardKey='Gehärtet', hardVal=!hasHard ? '–' : (st.hard==='ja' ? hardTxt(st.size) : 'Nein');   // Überschrift immer „Gehärtet“
    $('tb').innerHTML=cell(['Schlüsselweite',hasSize?fmtS(st.size)+' mm':'–'])+normHtml
      +cell(['Legierung','59CrV4'])+cell([hardKey,hardVal])+surfCell
      +[['Kugelkopf',hasEnds?(st.endLong==='kugel'?'Ja':'Nein')+' / '+(st.endShort==='kugel'?'Ja':'Nein')+(st.chamfer==='gratfrei'?', gratfrei':''):'–'],   // langer / kurzer Schenkel
        ['Stempelung',hasStamp?stamp:'–'],
        ['Menge',(st.qty>0?st.qty.toLocaleString('de-DE')+' Stück':'–')]].map(cell).join('');
    $('tbMobile').innerHTML=normHtml+cell(codeCell);

    drawSVG();
    $('svgSec').innerHTML = $('svg').innerHTML;   // Querschnitt: gleicher Inhalt, eigener Ausschnitt
    $('sum').textContent = summary(chk);
    renderSummary(chk);
    if(typeof updatePreview==='function') try{ updatePreview(); }catch(e){}
    if(typeof V3!=='undefined') try{ V3.update(); }catch(e){ console.error(e); }
    try{ localStorage.setItem(STORE, JSON.stringify(st)); }catch(e){}
  }

  $('cfg').addEventListener('input', e=>{
    const id=e.target.id, name=e.target.name;
    if((id==='l1'||id==='l2') && st.series!=='sonder'){
      document.querySelector('input[name=series][value=sonder]').checked = true;
    }
    readForm();
    if(name==='size' && st.series==='sonder'){ const r=row(st.size); st.l1=r[1]; st.l2=r[3]; }
    render();
  });
  ['l1','l2'].forEach(k=>$(k).addEventListener('blur',()=>render()));
  // Sonderlänge: was schon getippt ist; Normmaße eingegeben → zurück auf Kurz bzw. Lang
  const lenTyped={l1:false,l2:false};
  $('cfg').addEventListener('change', e=>{ if(e.target.name==='series' && e.target.value!=='sonder'){ lenTyped.l1=lenTyped.l2=false; render(); } }, true);
  ['l1','l2'].forEach(k=>$(k).addEventListener('input',()=>{ lenTyped[k]=$(k).value!==''; }, true));
  ['l1','l2'].forEach(k=>$(k).addEventListener('change',normBack));
  $('resetBtn').addEventListener('click',()=>{ lenTyped.l1=lenTyped.l2=false; });
  // „Zurücksetzen“ in der Navigation: erster Klick fragt nach, zweiter setzt zurück
  (function(){ const b=$('resetMid'); let armed=false, t=null;
    const disarm=()=>{ armed=false; b.textContent='Zurücksetzen'; b.classList.remove('is-armed'); };
    b.addEventListener('click',()=>{ if(!armed){ armed=true; b.textContent='Zurücksetzen?'; b.classList.add('is-armed'); clearTimeout(t); t=setTimeout(disarm,4000); return; }
      clearTimeout(t); disarm(); $('resetBtn').click(); });
    b.addEventListener('blur',()=>{ if(armed){ clearTimeout(t); t=setTimeout(disarm,300); } }); })();
  function normBack(){
    if(st.series!=='sonder' || !lenTyped.l1 || !lenTyped.l2) return;
    const r=row(st.size), a=parseFloat($('l1').value), b=parseFloat($('l2').value);
    const to = (a===r[1] && b===r[3]) ? 'kurz' : (r[2] && a===r[2] && b===r[3]) ? 'lang' : null;
    if(!to) return;
    const i=document.querySelector(`input[name=series][value=${to}]`); i.checked=true;
    i.dispatchEvent(new Event('input',{bubbles:true})); i.dispatchEvent(new Event('change',{bubbles:true}));
    setTimeout(()=>{ const h=$('lenHint'); h.__keep=true; window.inbNote(h,'change', to==='kurz'?'Standardlänge erkannt':'Extra-lang erkannt', to==='kurz'?'Maße entsprechen der Standardlänge.':'Maße entsprechen Extra-lang.'); clearTimeout(h.__t); h.__t=setTimeout(()=>{ h.__keep=false; window.inbNote(h); },8000); },0);
  }
  $('cfg').addEventListener('change', e=>{ if(e.target.name==='series'||e.target.name==='size'){ readForm(); render(); } });

  function flash(msg){ const t=$('toast'); t.textContent=msg; clearTimeout(flash._t); flash._t=setTimeout(()=>t.textContent='',2500); }
  async function copy(text,msg){
    try{ await navigator.clipboard.writeText(text); flash(msg); }
    catch(e){
      const ta=document.createElement('textarea'); ta.value=text; document.body.appendChild(ta); ta.select();
      try{ document.execCommand('copy'); flash(msg);}catch(_){ flash('Kopieren nicht möglich. Bitte den Text markieren und manuell kopieren.'); }
      ta.remove();
    }
  }
  // Drucken: zwei Seiten A4 quer – 1. Zusammenfassung, 2. Zeichnungsblatt (wie PDF)
  function buildPrint(){
    const chk=checks(), rows=[...document.querySelectorAll('#sumList dt')].map(dt=>[dt.textContent, dt.nextElementSibling?dt.nextElementSibling.textContent:''])
      .filter(([k])=>k!=='Konfigurations-ID');
    const devs=chk.devs, today=new Date().toLocaleDateString('de-DE');
    const contact=[st.person,st.company,st.email,st.phone].filter(Boolean);
    const esc=escapeXml;
    return `<section class="print-page print-summary">
        <header class="print-head"><h1>Winkelschraubendreher <strong>nach Maß</strong></h1><p>Zusammenfassung · ${esc(today)}</p></header>
        <div class="print-cols">
          <dl class="print-list">${rows.map(([k,v])=>`<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('')}</dl>
          <div class="print-side">
            <p class="print-k">Konfigurations-ID</p><p class="print-id">${esc(configId())}</p>
            <p class="print-k">Typ</p><p class="print-v">${esc(code())}</p>
            <p class="print-k">Norm</p><p class="print-v">${esc(chk.devs.length?'Sonderanfertigung':normName())}</p>
            ${devs.length?`<p class="print-k">Abweichungen von ISO 2936</p><ul class="print-v">${devs.map(d=>`<li>${esc(d)}</li>`).join('')}</ul>`:''}
            ${contact.length?`<p class="print-k">Kontakt</p><p class="print-v">${contact.map(esc).join('<br>')}</p>`:''}
          </div>
        </div>
        <footer class="print-foot">Die Zeichnung folgt auf Seite 2. Wir prüfen jede Konfiguration auf Realisierbarkeit.</footer>
      </section>
      <section class="print-page print-sheet">${buildSheet()}</section>`;
  }
  $('printBtn').onclick = ()=> {
    let host=$('printDoc'); if(!host){ host=document.createElement('div'); host.id='printDoc'; document.body.appendChild(host); }
    host.innerHTML=buildPrint();
    setTimeout(()=>window.print(),80);
  };
  $('resetBtn').onclick = ()=>{ st=Object.assign({},defaults); try{localStorage.removeItem(STORE);}catch(e){} writeForm(); render(); flash('Zurückgesetzt ✓'); };


  // ---------- Fertigungszeichnung A4 quer (Einheiten: mm) ----------
  const INK='#000', THIN=0.25, THICK=0.5, FONT='Helvetica, Arial, sans-serif';
  function scaleLabel(m){ return m>=1 ? `${m}:1` : `1:${Math.round(1/m)}`; }
  function pickScale(fits){ const c=[10,5,2,1,0.5,0.2,0.1]; for(const m of c){ if(fits(m)) return m; } return 0.1; }
  const tx=(x,y,t,size=3.5,anchor='start',extra='')=>`<text x="${x}" y="${y}" font-family="${FONT}" font-size="${size}" text-anchor="${anchor}" fill="${INK}" ${extra}>${escapeXml(String(t))}</text>`;
  const ln=(x1,y1,x2,y2,w=THIN,dash='')=>`<line x1="${x1}" y1="${y1}" x2="${x2}" y2="${y2}" stroke="${INK}" stroke-width="${w}" ${dash?`stroke-dasharray="${dash}"`:''}/>`;
  function arrow(x,y,dir){ // dir: 'l','r','u','d' = Richtung der Spitze
    const L=2.5,W=0.9; let p;
    if(dir==='l') p=`${x},${y} ${x+L},${y-W/2*2} ${x+L},${y+W}`;
    if(dir==='r') p=`${x},${y} ${x-L},${y-W} ${x-L},${y+W}`;
    if(dir==='u') p=`${x},${y} ${x-W},${y+L} ${x+W},${y+L}`;
    if(dir==='d') p=`${x},${y} ${x-W},${y-L} ${x+W},${y-L}`;
    return `<polygon points="${p}" fill="${INK}"/>`;
  }
  function hDim(x1,x2,yRef,yDim,label){ // Hilfslinien von yRef nach yDim
    const d=yDim>yRef?1:-1, inside=(x2-x1)>12;
    let o=ln(x1,yRef+d*1,x1,yDim+d*2)+ln(x2,yRef+d*1,x2,yDim+d*2);
    if(inside){ o+=ln(x1,yDim,x2,yDim)+arrow(x1,yDim,'l')+arrow(x2,yDim,'r')+tx((x1+x2)/2,yDim-1.2,label,3.5,'middle'); }
    else { o+=ln(x1-8,yDim,x2+8,yDim)+arrow(x1,yDim,'r')+arrow(x2,yDim,'l')+tx(x2+9,yDim+1.2,label,3.5,'start'); }
    return o;
  }
  function vDim(y1,y2,xRef,xDim,label){
    const d=xDim>xRef?1:-1, inside=(y2-y1)>12;
    let o=ln(xRef+d*1,y1,xDim+d*2,y1)+ln(xRef+d*1,y2,xDim+d*2,y2);
    const cy=(y1+y2)/2;
    if(inside){ o+=ln(xDim,y1,xDim,y2)+arrow(xDim,y1,'u')+arrow(xDim,y2,'d')+tx(xDim-1.2,cy,label,3.5,'middle',`transform="rotate(-90 ${xDim-1.2} ${cy})"`); }
    else { o+=ln(xDim,y1-8,xDim,y2+8)+arrow(xDim,y1,'d')+arrow(xDim,y2,'u')+tx(xDim+(d>0?1.5:-1.5),y1-9,label,3.5,d>0?'start':'end'); }
    return o;
  }

  function exportDrawing(aspect,fonts){
    const svg=$('svg'), keep={html:svg.innerHTML, vb:svg.getAttribute('viewBox'), x:svg.dataset.vbx, y:svg.dataset.vby};
    let inner='', sc=1;
    try{
      window.__exportAspect=aspect; window.__exportFonts=fonts||null; drawSVG(); sc=(window.__paperAxis&&window.__paperAxis.sc)||1; inner=svg.innerHTML;
    } finally { window.__exportAspect=null; window.__exportFonts=null; drawSVG(); }
    // ohne Millimeterpapier und altes Rastermuster
    inner=inner.replace(/<g class="mm-paper"[\s\S]*?<\/g>/,'').replace(/<rect[^>]*fill="url\(#grid\)"[^>]*\/?>(<\/rect>)?/g,'');
    // CSS-Farben in feste Werte auflösen (die Datei hat kein Stylesheet)
    const host=document.querySelector('.cfg.cfg-app')||document.body, probe=document.createElement('span'); host.appendChild(probe);
    const toRgb=str=>{ probe.style.color=''; probe.style.color=str; let c=getComputedStyle(probe).color||'#000';
      const m=c.match(/color\(srgb ([\d.]+) ([\d.]+) ([\d.]+)(?: \/ ([\d.]+))?\)/);
      if(m){ const r=[1,2,3].map(i=>Math.round(parseFloat(m[i])*255)); c=m[4]!=null?`rgba(${r.join(',')},${m[4]})`:`rgb(${r.join(',')})`; }
      return c; };
    inner=inner.replace(/var\(--[\w-]+\)/g, v=>toRgb(v)).replace(/color-mix\([^()]*(?:\([^()]*\)[^()]*)*\)/g, v=>toRgb(v));
    probe.remove();
    // Rahmen des Inhalts in einer sichtbaren Hilfsfläche messen
    const tmp=document.createElementNS('http://www.w3.org/2000/svg','svg'); tmp.setAttribute('viewBox','0 0 800 800'); tmp.style.cssText='position:fixed;left:-10000px;top:0;width:800px;height:800px;';
    tmp.innerHTML=inner; document.body.appendChild(tmp);
    let bb={x:0,y:0,width:800,height:600}; try{ const g=tmp.getBBox(); if(g.width) bb=g; }catch(e){}
    tmp.remove();
    const pad=6;
    return {inner, sc, bx:bb.x-pad, by:bb.y-pad, bw:bb.width+2*pad, bh:bb.height+2*pad};
  }
  function buildSheet(){
    const s=st.size, l1=st.l1>0?st.l1:s*10, l2=st.l2>0?st.l2:s*4;
    const chk=checks(), code0=code();
    const drawNo = ($('drawNo').value.trim()) || code0;
    const rev = $('rev').value.trim()||'A';
    const drawer = $('drawer').value.trim() || st.person || '';
    const today = new Date().toLocaleDateString('de-DE');
    let o='';
    // Rahmen
    o+=`<rect x="0" y="0" width="297" height="210" fill="#fff"/>`;
    o+=`<rect x="20" y="10" width="267" height="190" fill="none" stroke="${INK}" stroke-width="0.7"/>`;

    // Zeichnung: dieselbe wie auf dem Bildschirm (Seite, unten, Schnitt A–A), in Normmaßstab
    // in den Zeichenbereich gesetzt (links, x 25–205, y 15–158 mm)
    const EX={x:25,y:15,w:180,h:143};
    // Schrift auf dem Papier nach DIN: Maßzahlen und Schnittbuchstaben 3,5 mm, Ansichtsüberschriften 2,5 mm
    let dr=exportDrawing(EX.w/EX.h), mStd=1, f=1;
    for(let pass=0; pass<3; pass++){
      mStd = pickScale(k=> dr.bw/dr.sc*k<=EX.w && dr.bh/dr.sc*k<=EX.h);   // Papier-mm je Schlüssel-mm
      f = mStd/dr.sc;                                                       // Papier-mm je Zeicheneinheit
      // höchstens 1,6-fach der Bildschirmgröße, sonst stoßen Beschriftungen bei sehr kleinen Schlüsseln aneinander
      const next=exportDrawing(EX.w/EX.h,{d:Math.min(3.5/f,24), l:Math.min(2.5/f,20), a:Math.min(3.5/f,22)});
      const fits=next.bw*f<=EX.w && next.bh*f<=EX.h; dr=next; if(fits) break;
    }
    f = mStd/dr.sc;
    const m = mStd;
    const gw=dr.bw*f, gh=dr.bh*f, gx=EX.x+(EX.w-gw)/2, gy=EX.y+(EX.h-gh)/2;
    o+=`<svg x="${gx.toFixed(2)}" y="${gy.toFixed(2)}" width="${gw.toFixed(2)}" height="${gh.toFixed(2)}" viewBox="${dr.bx.toFixed(2)} ${dr.by.toFixed(2)} ${dr.bw.toFixed(2)} ${dr.bh.toFixed(2)}" overflow="visible"><g font-family="${FONT}">${dr.inner}</g></svg>`;
    o+=tx(EX.x,EX.y+EX.h+5,`Maßstab ${scaleLabel(m)} · Maße in mm`,2.5);

    // Hinweise
    const notes=[
      `Sechskant-Stiftschlüssel, L-Form, Basis ISO 2936`,
      `Werkstoff: 59CrV4${st.hard==='ja'?', gehärtet ('+hardTxt(st.size)+')':st.hard==='nein'?', ungehärtet':''}`,
      `Oberfläche: ${{'brüniert':'Brüniert','phosphatiert':'Phosphatiert','verchromt':'Verchromt','vernickelt':'Vernickelt','verzinkt':'Verzinkt','blank':'Blank (geölt)'}[st.baseSurface||st.surface]||'Blank (geölt)'}${st.surface==='farbcodiert'?', pulverbeschichtet RAL '+ralOf(st.color)+' (Enden frei: 1,5 × s, vor Kugelkopf 0,6 × s)':''}`,
      `Stempelung: ${(st.stampLine)?(st.stampLine||'')+', mittig auf der Außenseite des langen Schenkels (siehe Ansicht unten)':'ohne'}`,
      `Grenzabmaße für s, Härte und Prüfdrehmoment nach ISO 2936`,
      `Nicht tolerierte Maße: ISO 2768-m`,
      `e = theoretisches Eckmaß, nur zur Information`,
    ];
    if(chk.devs.length){ notes.push('Abweichungen von ISO 2936:'); chk.devs.forEach(d=>notes.push('  – '+d)); }
    // Maßtabelle (rechts oben): Maß · Nennmaß · Grenzabmaß
    { const R=window.inbDimRows(), x=215, c2=241, c3=260, x2=283; let y=20;
      o+=tx(x,y,'Maße (alle Maße in mm)',3.5,'start','font-weight="bold"'); y+=5;
      o+=tx(x,y,'Maß',2.3,'start','fill-opacity="0.6"')+tx(c2,y,'Nennmaß',2.3,'start','fill-opacity="0.6"')+tx(c3,y,'Grenzabmaß',2.3,'start','fill-opacity="0.6"'); y+=1.6;
      R.forEach(r=>{ o+=ln(x,y,x2,y,THIN*0.6); y+=3.7; o+=tx(x,y,r[0],2.6)+tx(c2,y,r[1],2.6)+tx(c3,y,r[2],2.6); y+=1.3; });
      o+=ln(x,y,x2,y,THIN*0.6);
      window.__sheetNotesY=Math.max(86, y+10); }
    let ny=window.__sheetNotesY||86; o+=tx(215,ny,'Hinweise',3.5,'start','font-weight="bold"'); ny+=5;
    const wrap=(t,n)=>{const w=t.split(' '),r=[];let c='';w.forEach(x=>{if((c+' '+x).trim().length>n){r.push(c);c=(c.startsWith('  ')?'    ':'')+x;}else c=(c?c+' ':'')+x;});if(c)r.push(c);return r;};
    notes.forEach((n,i)=>{ wrap((n.startsWith('  ')?'':(i+1)+'. ')+n,48).forEach(line=>{ if(ny<152){ o+=tx(215,ny,line,2.5); ny+=3.6; } }); });

    // Schriftfeld 180 x 36 unten rechts (x 107..287, y 164..200)
    const X=107,Y=164,W=180,H=36;
    o+=`<rect x="${X}" y="${Y}" width="${W}" height="${H}" fill="#fff" stroke="${INK}" stroke-width="0.7"/>`;
    const cols=[X,X+45,X+90,X+135,X+W], rows=[Y,Y+9,Y+18,Y+27,Y+H];
    rows.slice(1,-1).forEach(y=>o+=ln(X,y,X+W,y,THIN));
    // Zellen: [col,row,colspan,label,value]
    const surfName={'phosphatiert':'phosphatiert','verchromt':'verchromt','vernickelt':'vernickelt','verzinkt':'verzinkt','blank':'blank (geölt)','brüniert':'brüniert'}[st.baseSurface||st.surface]||'—';
    const surfTxt=$('surface').value ? surfName+(st.surface==='farbcodiert'?', RAL '+ralOf(st.color):'') : '—';
    const qtyTxt=st.qty>0?st.qty.toLocaleString('de-DE')+' Stück':'—';
    const cells=[
      [0,0,1,'Kunde',st.company||st.person||'—'],[1,0,1,'Erstellt','Konfigurator'],[2,0,1,'Datum',today],[3,0,1,'Maßstab',scaleLabel(m)],
      [0,1,2,'Benennung','Winkelschraubendreher s '+fmtS(s)+' mm'],[2,1,1,'Norm',chk.devs.length?'Sonderanfertigung':normName()],[3,1,1,'Stückzahl',qtyTxt],
      [0,2,1,'Werkstoff','59CrV4'+(st.hard==='ja'?', gehärtet':'')],[1,2,1,'Oberfläche',surfTxt],[2,2,1,'Allgemeintoleranz','ISO 2768-m'],[3,2,1,'Format / Blatt','A4, Blatt 1/1'],
      [0,3,1,'Konfigurations-ID',configId()],[1,3,2,'Aufruf','www.inbus.de/konfigurator'],[3,3,1,'Änderungsstand',rev],
    ];
    cells.forEach(([c,r,span,k,v])=>{
      const x=cols[c], y=rows[r], w=cols[c+span]-x;
      if(c>0) o+=ln(x,y,x,y+9,THIN);
      o+=tx(x+1.2,y+2.8,k,1.9);
      let val=String(v); const maxc=Math.floor(w/1.75); if(val.length>maxc) val=val.slice(0,maxc-1)+'…';
      o+=tx(x+1.2,y+7.3,val,r===3&&c===0?3.2:2.8,'start',r===1&&c===0?'font-weight="bold"':'');
    });
    // Projektionssymbol (Methode 1) links neben dem Schriftfeld
    const px=92, py=182;
    o+=`<path d="M ${px-6} ${py-3} L ${px-1} ${py-1.5} L ${px-1} ${py+1.5} L ${px-6} ${py+3} Z" fill="none" stroke="${INK}" stroke-width="${THIN}"/>`;
    o+=`<circle cx="${px+5}" cy="${py}" r="3" fill="none" stroke="${INK}" stroke-width="${THIN}"/><circle cx="${px+5}" cy="${py}" r="1.5" fill="none" stroke="${INK}" stroke-width="${THIN}"/>`;
    o+=ln(px-8,py,px+10,py,0.18,'3 1 0.6 1');
    o+=tx(20+3,196,'Erstellt mit dem ISO-2936-Konfigurator. Maße in mm.',2.2);

    return `<svg xmlns="http://www.w3.org/2000/svg" width="297mm" height="210mm" viewBox="0 0 297 210">${o}</svg>`;
  }

  function sheetName(ext){ return (($('drawNo').value.trim())||code()).replace(/[^\w.,\-]+/g,'_')+'.'+ext; }
  function flash2(msg,warn){ const t=$('toast2'); t.style.color=warn?'var(--warn)':'var(--ok)'; t.textContent=msg; clearTimeout(flash2._t); flash2._t=setTimeout(()=>t.textContent='',4000); }
  function updatePreview(){ const e=$('sheetPrev'); if(e && !e.hidden) e.innerHTML = buildSheet(); }   // nur, wenn die Vorschau sichtbar ist
  window.inbBuildSheet=()=>buildSheet();

  // Test: normaler Browser-Download statt der Funktion der Vorschauumgebung
  const downloads=true;
  function save(filename,data){
    try{
      const blob = data instanceof Blob ? data : new Blob([data],{type:'image/svg+xml'});
      const url=URL.createObjectURL(blob); const a=document.createElement('a');
      a.href=url; a.download=filename; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(()=>URL.revokeObjectURL(url),1000); flash2(`${filename} gespeichert.`);
    }catch(err){ flash2('Export nicht möglich: '+(err&&err.message||'unbekannter Fehler'),true); }
  }
  $('svgBtn').onclick=()=>{ if(!downloads) return; save(sheetName('svg'), '<?xml version="1.0" encoding="UTF-8"?>\n'+buildSheet()); };
  // DINPro ins PDF einbetten (Lizenz vorhanden). jsPDF braucht TrueType (.ttf); die Web-Schriften
  // liegen im Shop nur als .woff2 vor. Deshalb die .ttf-Dateien unter denselben Namen in
  // Shopify › Dateien hochladen. Fehlen sie, bleibt es bei Helvetica.
  const PDF_FONT_BASE=window.INB_PDF_FONT_BASE||'https://cdn.shopify.com/s/files/1/0970/6887/6108/files/';
  const PDF_FONTS=[['DINPro.ttf','normal'],['DINPro-Bold.ttf','bold']];
  let pdfFontOk=null;
  async function embedDin(doc){
    if(pdfFontOk===false) return false;
    try{
      for(const [file,style] of PDF_FONTS){
        const res=await fetch(PDF_FONT_BASE+file,{mode:'cors'}); if(!res.ok) throw new Error(file+' '+res.status);
        const buf=new Uint8Array(await res.arrayBuffer()); let bin=''; for(let i=0;i<buf.length;i+=0x8000) bin+=String.fromCharCode.apply(null,buf.subarray(i,i+0x8000));
        doc.addFileToVFS(file,btoa(bin)); doc.addFont(file,'DINPro',style);
      }
      pdfFontOk=true; return true;
    }catch(e){ pdfFontOk=false; console.warn('DINPro für PDF nicht geladen:',e); return false; }
  }
  $('pdfBtn').onclick=async()=>{
    if(!downloads) return;
    if(!window.jspdf || !(window.svg2pdf||(window.jspdf.jsPDF.API&&window.jspdf.jsPDF.API.svg))){ flash2('PDF-Bibliothek konnte nicht geladen werden. SVG-Export ist weiterhin möglich.',true); return; }
    $('pdfBtn').disabled=true; flash2('PDF wird erzeugt …');
    try{
      const holder=document.createElement('div'); holder.style.cssText='position:fixed;left:-10000px;top:0;width:1122px;';
      const doc=new window.jspdf.jsPDF({orientation:'landscape',unit:'mm',format:'a4'});
      const din=await embedDin(doc);
      let sheet=buildSheet(); if(din) sheet=sheet.split('font-family="'+FONT+'"').join('font-family="DINPro"');
      holder.innerHTML=sheet; document.body.appendChild(holder);
      const el=holder.querySelector('svg');
      doc.setProperties({title:'Zeichnung '+sheetName('pdf').replace('.pdf',''),subject:'Sechskant-Stiftschlüssel ISO 2936',creator:'INBUS'});
      if(doc.svg) await doc.svg(el,{x:0,y:0,width:297,height:210});
      else await window.svg2pdf.svg2pdf(el,doc,{x:0,y:0,width:297,height:210});
      holder.remove();
      const blob=doc.output('blob');
      await save(sheetName('pdf'),blob);
      if(!din) flash2('PDF gespeichert – mit Ersatzschrift (DINPro als .ttf nicht gefunden).',true);
    }catch(e){ flash2('PDF konnte nicht erzeugt werden: '+(e.message||e),true); }
    finally{ $('pdfBtn').disabled=false; }
  };
  ['drawNo','rev','drawer'].forEach(k=>$(k).addEventListener('input',updatePreview));


  // ---------- 3D-Vorschau ----------
  var V3 = (function(){
    const box=$('v3'), msg=$('v3msg');
    if(!window.THREE){ msg.textContent='Die 3D-Ansicht konnte nicht geladen werden.'; return {update(){}}; }
    let renderer;
    try{ renderer=new THREE.WebGLRenderer({antialias:true,alpha:true}); }
    catch(e){ msg.textContent='Dieser Browser unterstützt keine 3D-Darstellung (WebGL).'; return {update(){}}; }
    msg.remove();
    renderer.setPixelRatio(Math.min(Math.max(window.devicePixelRatio||1,1.5),2));   // mindestens 1,5-fach: Kanten bleiben scharf
    renderer.outputEncoding=THREE.sRGBEncoding;
    renderer.toneMapping=THREE.ACESFilmicToneMapping;
    box.insertBefore(renderer.domElement, box.firstChild);
    const scene=new THREE.Scene(), gridScene=new THREE.Scene();
    // Nebel in exakt der Farbe des Grunds. Der Renderer gibt sRGB aus, Farben im Nebel rechnet three.js linear –
    // deshalb die CSS-Farbe erst in linear umrechnen, sonst wird das Ende heller (weiß) statt grau.
    // Nebel etwas dunkler als der Grund (wie das dichte Raster in der Ferne), damit der Boden hinten
    // grau ausläuft und nicht in fast Weiß verschwindet
    const fogCol=(()=>{ const m=(getComputedStyle(document.querySelector('.cfg-stage')).backgroundColor.match(/\d+/g)||[240,240,240]).map(Number).map(v=>Math.max(0,v-14)); const c=new THREE.Color(m[0]/255,m[1]/255,m[2]/255); return c.convertSRGBToLinear ? c.convertSRGBToLinear() : c; })();
    scene.fog=new THREE.Fog(fogCol, 100, 400);
    const camera=new THREE.PerspectiveCamera(35,1,0.1,10000);
    scene.add(new THREE.HemisphereLight(0xf2f5f8,0x3a4048,0.9));
    const key=new THREE.DirectionalLight(0xffffff,1.6); key.position.set(1,1.4,1.2); scene.add(key);
    const rim=new THREE.DirectionalLight(0xbcd2ff,0.9); rim.position.set(-1.2,0.4,-1); scene.add(rim);
    const fill=new THREE.DirectionalLight(0xffffff,0.5); fill.position.set(0,-1,0.6); scene.add(fill);

    // einfache Umgebung für metallische Reflexe
    (function(){
      const c=document.createElement('canvas'); c.width=256; c.height=128; const g=c.getContext('2d');
      const gr=g.createLinearGradient(0,0,0,128); gr.addColorStop(0,'#ffffff'); gr.addColorStop(.4,'#c9d2dc'); gr.addColorStop(.5,'#39414a'); gr.addColorStop(1,'#15191e');
      g.fillStyle=gr; g.fillRect(0,0,256,128);
      g.fillStyle='#fff'; g.fillRect(30,14,70,18); g.fillRect(150,20,60,12); g.fillRect(0,60,256,3);
      const tex=new THREE.CanvasTexture(c); tex.mapping=THREE.EquirectangularReflectionMapping; tex.encoding=THREE.sRGBEncoding;
      const pm=new THREE.PMREMGenerator(renderer); scene.environment=pm.fromEquirectangular(tex).texture; tex.dispose(); pm.dispose();
    })();

    const group=new THREE.Group(); scene.add(group);
    let grid=null, radius=100;
    const target=new THREE.Vector3();
    const sph={theta:0.72,phi:0.87,dist:300};
    let spin=false, needs=true;

    class Arc3 extends THREE.Curve{
      constructor(cx,cy,r,a0,a1){super();this.cx=cx;this.cy=cy;this.r=r;this.a0=a0;this.a1=a1;}
      getPoint(t,out=new THREE.Vector3()){const a=this.a0+(this.a1-this.a0)*t;return out.set(this.cx+this.r*Math.cos(a),this.cy+this.r*Math.sin(a),0);}
    }
    const FINISH={
      'brüniert':{color:0x2b2f34,metalness:.75,roughness:.42},
      'phosphatiert':{color:0x3a3d40,metalness:.45,roughness:.78},
      'verzinkt':{color:0xc3ccd4,metalness:.85,roughness:.38},   // leicht bläulich-silbern
      'verchromt':{color:0xc9ced4,metalness:.9,roughness:.42},   // matt verchromt: kühl, weiche Reflexe
      'vernickelt':{color:0xe8e0cf,metalness:1,roughness:.08},   // vernickelt: warm, hochglänzend
      'blank':{color:0xb9c0c7,metalness:.95,roughness:.34},
    };
    function matFor(flat, fin){
      fin=fin||st.surface;
      const f = fin==='farbcodiert' ? {color:new THREE.Color(st.color).convertSRGBToLinear(),metalness:.1,roughness:.5} : FINISH[fin]||FINISH['brüniert'];
      const m=new THREE.MeshStandardMaterial({color:f.color,metalness:f.metalness,roughness:f.roughness,flatShading:flat,side:THREE.DoubleSide,envMapIntensity:1});
      if(fin!=='farbcodiert') m.color.convertSRGBToLinear && m.color.convertSRGBToLinear();
      m.userData.fin=fin;   // für weiche Übergänge in der Willkommens-Animation
      return m;
    }
    // Stempelung: Schrift als Bild auf einer flachen Folie, direkt über der
    // Außenseite des langen Schenkels, weg von der Biegung (wie in der Ansicht von unten).
    // Dunkle Oberflächen bekommen helle Schrift, helle dunkle.
    function stampMesh(txt, xMid, s0, room){
      const flatW=s0/Math.sqrt(3);                       // Breite der Fläche = e/2
      const H=128, c=document.createElement('canvas'), g=c.getContext('2d');
      const font='300 '+Math.round(H*0.9)+'px DINPro, "Arial Narrow", Arial, sans-serif';   // Light, schmal gesetzt
      g.font=font; if('letterSpacing' in g) g.letterSpacing=Math.round(H*0.9*0.04)+'px';
      const w=Math.ceil(g.measureText(txt).width+H*0.4);
      c.width=Math.min(4096,w); c.height=H;
      const g2=c.getContext('2d'); g2.font=font; if('letterSpacing' in g2) g2.letterSpacing=Math.round(H*0.9*0.04)+'px'; g2.textAlign='center'; g2.textBaseline='alphabetic';
      const light = st.surface==='farbcodiert' ? onColor(st.color)!=='#fff' : !(st.surface==='brüniert'||st.surface==='phosphatiert');
      // Tiefprägung: heller Grat leicht versetzt, darüber immer dunkler als das Material
      g2.fillStyle = window.stampInk();   // Oberflächenfarbe, deutlich dunkler; ohne hellen Schatten
      g2.fillText(txt, c.width/2, H/2 + H*0.9*0.35);   // Versalien optisch mittig
      const tex=new THREE.CanvasTexture(c); tex.encoding=THREE.sRGBEncoding; tex.anisotropy=renderer.capabilities.getMaxAnisotropy();
      // feste Schriftgröße: 0,25 × s je Zeichen (wie in der Zeichnung), unabhängig von der Textlänge; höchstens so hoch wie die Fläche
      const fontPx=H*0.9, k=Math.min(0.25*s0/(0.56*fontPx), flatW*0.8/0.72*0.9/H);
      let h=H*k, wW=c.width*k;
      const m=new THREE.MeshStandardMaterial({map:tex, transparent:true, depthWrite:false, metalness:.2, roughness:.8, polygonOffset:true, polygonOffsetFactor:-2});
      const mesh=new THREE.Mesh(new THREE.PlaneGeometry(wW,h), m);
      mesh.rotation.x=Math.PI/2;                         // Folie auf der Außenseite (Normale −y)
      mesh.position.set(xMid, -(s0/2+s0*0.004), 0);
      return mesh;
    }
    function clear(){
      group.children.slice().forEach(o=>{ group.remove(o); o.traverse(n=>{ if(n.geometry) n.geometry.dispose(); [].concat(n.material||[]).forEach(mt=>{ if(mt.map) mt.map.dispose(); mt.dispose(); }); }); });
      if(grid){ gridScene.remove(grid); grid.traverse(n=>{ if(n.geometry) n.geometry.dispose(); if(n.material) n.material.dispose(); }); grid=null; }
    }
    // Sechskant entlang des Pfads extrudieren: Flächen eben, Kanten scharf, längs glatt
    function hexSweep(path,segs,r,cut){
      // Bezug: B steht senkrecht auf der Biegeebene, N liegt in ihr. Ecken bei
      // 30° + n·60°, damit eine Fläche zur Biegung zeigt – wie in der Zeichnung.
      // Die sechs Kanten sind leicht gerundet (Radius KK.EDGE × s): je Ecke ein
      // kleiner Bogen, dazwischen die ebenen Flächen.
      const ap=r*Math.cos(Math.PI/6), rr=KK.EDGE*2*ap, c=(ap-rr)/Math.cos(Math.PI/6), K=4, prof=[];
      for(let j=0;j<6;j++){ const aj=Math.PI/6+j*Math.PI/3;
        for(let q=0;q<=K;q++){ const ps=aj-Math.PI/6+q*(Math.PI/3)/K;
          prof.push({x:c*Math.cos(aj)+rr*Math.cos(ps), y:c*Math.sin(aj)+rr*Math.sin(ps), nx:Math.cos(ps), ny:Math.sin(ps)}); } }
      const M=prof.length, rings=[], Bz=new THREE.Vector3(0,0,1);
      for(let i=0;i<=segs;i++){
        const P=path.getPointAt(i/segs), T=path.getTangentAt(i/segs), B=Bz.clone(), N=new THREE.Vector3().crossVectors(B,T).normalize();
        const ring=prof.map(q=>P.clone().addScaledVector(N,q.x).addScaledVector(B,q.y));
        const nrm=prof.map(q=>N.clone().multiplyScalar(q.nx).addScaledVector(B,q.ny));
        rings.push({P,N,B,ring,nrm});
      }
      const pos=[],nor=[],idx=[]; let v=0;
      for(let m=0;m<M;m++){
        const m2=(m+1)%M;
        for(let i=0;i<=segs;i++){
          const R=rings[i], a=R.ring[m], b=R.ring[m2], na=R.nrm[m], nb=R.nrm[m2];
          pos.push(a.x,a.y,a.z,b.x,b.y,b.z); nor.push(na.x,na.y,na.z,nb.x,nb.y,nb.z);
          if(i>0){ const k=v+(i-1)*2; idx.push(k,k+2,k+1, k+1,k+2,k+3); }
        }
        v+=(segs+1)*2;
      }
      const g=new THREE.BufferGeometry();
      g.setAttribute('position',new THREE.Float32BufferAttribute(pos,3)); g.setAttribute('normal',new THREE.Float32BufferAttribute(nor,3)); g.setIndex(idx);
      // Bereiche: 0 = Mitte (Farbe), 1 = Enden (Oberfläche)
      if(cut){ for(let m=0;m<M;m++){ const b0=m*segs*6; g.addGroup(b0,cut[0]*6,1); g.addGroup(b0+cut[0]*6,(cut[1]-cut[0])*6,0); g.addGroup(b0+cut[1]*6,(segs-cut[1])*6,1); } }
      return {geo:g, first:rings[0], last:rings[segs]};
    }
    // Gerades Ende mit gerundeter Kante: Viertelkreis vom Schaft zur Stirnfläche
    // (Radius re), dann die ebene Stirnfläche auf dem eingezogenen Umriss.
    function roundEnd(R,out,re){
      const F=6, M=R.ring.length, pos=[], nor=[], idx=[];
      const ringAt=k=>{ const th=k/F*Math.PI/2, ax=re*Math.sin(th), inw=re*(1-Math.cos(th));
        return R.ring.map((p,m)=>{ const n=R.nrm[m]; return { p:p.clone().addScaledVector(out,ax).addScaledVector(n,-inw), n:n.clone().multiplyScalar(Math.cos(th)).addScaledVector(out,Math.sin(th)).normalize() }; }); };
      const rs=[]; for(let k=0;k<=F;k++) rs.push(ringAt(k));
      let v=0;
      for(let m=0;m<M;m++){ const m2=(m+1)%M;
        for(let k=0;k<=F;k++){ const a=rs[k][m], b=rs[k][m2]; pos.push(a.p.x,a.p.y,a.p.z,b.p.x,b.p.y,b.p.z); nor.push(a.n.x,a.n.y,a.n.z,b.n.x,b.n.y,b.n.z);
          if(k>0){ const q=v+(k-1)*2; idx.push(q,q+2,q+1, q+1,q+2,q+3); } }
        v+=(F+1)*2; }
      const g=new THREE.BufferGeometry(); g.setAttribute('position',new THREE.Float32BufferAttribute(pos,3)); g.setAttribute('normal',new THREE.Float32BufferAttribute(nor,3)); g.setIndex(idx);
      // Stirnfläche auf dem letzten (eingezogenen) Umriss
      const last=rs[F], P=R.P.clone().addScaledVector(out,re), cv=[P.x,P.y,P.z], cn=[out.x,out.y,out.z], ci=[];
      last.forEach(q=>{ cv.push(q.p.x,q.p.y,q.p.z); cn.push(out.x,out.y,out.z); });
      for(let j=0;j<M;j++) ci.push(0,1+j,1+((j+1)%M));
      const gc=new THREE.BufferGeometry(); gc.setAttribute('position',new THREE.Float32BufferAttribute(cv,3)); gc.setAttribute('normal',new THREE.Float32BufferAttribute(cn,3)); gc.setIndex(ci);
      return [g,gc];
    }
    function cap(R,outward){
      const v=[R.P.x,R.P.y,R.P.z], n=[], idx=[];
      R.ring.forEach(p=>v.push(p.x,p.y,p.z));
      const M=R.ring.length;
      for(let k=0;k<=M;k++) n.push(outward.x,outward.y,outward.z);
      for(let j=0;j<M;j++) idx.push(0,1+j,1+((j+1)%M));
      const g=new THREE.BufferGeometry(); g.setAttribute('position',new THREE.Float32BufferAttribute(v,3)); g.setAttribute('normal',new THREE.Float32BufferAttribute(n,3)); g.setIndex(idx); return g;
    }
    // Kugelkopf aus dem gemeinsamen Profil KK: Querschnitt = Sechskant,
    // begrenzt durch den Kreis r(u). Je Fläche ein eigener Streifen, damit
    // die Kanten scharf bleiben, wo Flächen stehen.
    function ballEnd(R,t,s0,len){
      const k=len/(KK.len*s0), us=KK.stations(), K=24, pos=[], idx=[]; let v=0;
      const pt=(u,phi)=>{ const rr=KK.rho(u,phi)*s0;
        return R.P.clone().addScaledVector(t,u*k*s0).addScaledVector(R.N,rr*Math.cos(phi)).addScaledVector(R.B,rr*Math.sin(phi)); };
      for(let j=0;j<6;j++){                                            // je Fläche ein Streifen (Ecke bis Ecke)
        us.forEach((u,i)=>{
          for(let q=0;q<=K;q++){ const p=pt(u,Math.PI/6+(j+q/K)*Math.PI/3); pos.push(p.x,p.y,p.z); }
          if(i>0){ const r0=v+(i-1)*(K+1), r1=v+i*(K+1); for(let q=0;q<K;q++) idx.push(r0+q,r1+q,r0+q+1, r0+q+1,r1+q,r1+q+1); }
        });
        v+=us.length*(K+1);
      }
      const g=new THREE.BufferGeometry();
      g.setAttribute('position',new THREE.Float32BufferAttribute(pos,3)); g.setIndex(idx); g.computeVertexNormals();
      // Stirnfläche: eben, sechseckig
      const c=R.P.clone().addScaledVector(t,KK.len*k*s0), cv=[c.x,c.y,c.z], cn=[t.x,t.y,t.z], ci=[];
      for(let j=0;j<6;j++){ const p=pt(KK.len,Math.PI/6+j*Math.PI/3); cv.push(p.x,p.y,p.z); cn.push(t.x,t.y,t.z); ci.push(0,1+j,1+((j+1)%6)); }
      const gc=new THREE.BufferGeometry(); gc.setAttribute('position',new THREE.Float32BufferAttribute(cv,3)); gc.setAttribute('normal',new THREE.Float32BufferAttribute(cn,3)); gc.setIndex(ci);
      return [g,gc];
    }
    function build(){
      clear();
      const s0=st.size, l1=st.l1>0?st.l1:s0*10, l2=st.l2>0?Math.max(st.l2,s0*1.2):s0*4;
      const rHex=s0/Math.sqrt(3);        // Umkreisradius = e/2
      const Rc=Math.min(Math.max(s0*GEO.bend, 1.5*(s0/Math.max(st.size,0.1))+s0/2), Math.max(l2-s0/2-0.01,0.01)*0.9); // Mittellinie: Innenradius r = s, mind. 1,5 mm
      const yTop0=l2-s0/2, xEnd0=l1-s0/2;
      const kS=st.endShort==='kugel', kL=st.endLong==='kugel';
      const lenFor=straight=>Math.max(0.4*KK.len*s0, Math.min(KK.len*s0, straight-Rc-0.05*s0));
      const bS=kS?lenFor(yTop0):0, bL=kL?lenFor(xEnd0):0;
      const re=KK.EDGE*s0;   // Rundung auch an geraden Stirnseiten
      const yTop=yTop0-(kS?bS:re), xEnd=xEnd0-(kL?bL:re);
      const path=new THREE.CurvePath();
      if(yTop>Rc) path.add(new THREE.LineCurve3(new THREE.Vector3(0,yTop,0),new THREE.Vector3(0,Rc,0)));
      path.add(new Arc3(Rc,Rc,Rc,Math.PI,1.5*Math.PI));
      if(xEnd>Rc) path.add(new THREE.LineCurve3(new THREE.Vector3(Rc,0,0),new THREE.Vector3(xEnd,0,0)));
      const segs=Math.min(600,Math.max(120,Math.round((l1+l2)/s0*8)));
      // Farbcodierung läuft nicht bis in die Enden: frei bleiben 1,5 × s an geraden
      // Enden und 0,6 × s vor einem Kugelkopf (dazu der Kopf selbst)
      const coated=st.surface==='farbcodiert';
      const mBody=matFor(false, coated?(st.baseSurface||'blank'):st.surface);
      let cut=null;
      if(coated){
        const Lp=path.getLength(), u0=(kS?0.6:1.5)*s0, u1=(kL?0.6:1.5)*s0;
        const n0=Math.min(segs-1,Math.round(u0/Lp*segs)), n1=Math.max(n0+1,segs-Math.round(u1/Lp*segs));
        cut=[n0,n1];
      }
      const sw=hexSweep(path,segs,rHex,cut);
      group.add(new THREE.Mesh(sw.geo, coated?[matFor(false,'farbcodiert'),mBody]:mBody));
      const stampTxt=st.stampLine||'';   // 8 · Marke · Werkstoff · MADE IN GERMANY
      if(stampTxt && xEnd>Rc) group.add(stampMesh(stampTxt,(Rc+xEnd)/2,s0,Math.min(xEnd-Rc, st.l1/2)));
      const tS=path.getTangentAt(0).negate(), tE=path.getTangentAt(1);
      const ball=(R,t,len,tag)=>{ ballEnd(R,t,s0,len).forEach(g=>{ const ms=new THREE.Mesh(g,mBody.clone()); ms.userData.ball=tag; group.add(ms); }); };
      // Kurzer Schenkel = Pfadanfang, langer Schenkel = Pfadende
      if(kS) ball(sw.first,tS,bS,'S'); else roundEnd(sw.first,tS,re).forEach(g=>group.add(new THREE.Mesh(g,mBody.clone())));
      if(kL) ball(sw.last,tE,bL,'L'); else roundEnd(sw.last,tE,re).forEach(g=>group.add(new THREE.Mesh(g,mBody.clone())));
      // zentrieren
      const bb=new THREE.Box3().setFromObject(group), c=bb.getCenter(new THREE.Vector3()), size=bb.getSize(new THREE.Vector3());
      group.children.forEach(o=>o.position.sub(c));
      radius=size.length()*0.5+s0*0.5;   // Hüllkugel: fürs Drehen
      bbox.copy(size);                    // Quader: fürs genaue Einpassen
      // Bodenraster: Maschenweite im Verhältnis zum Kameraabstand. Weil sich die
      // Kamera bei jeder Änderung neu einpasst, bleibt das Netz auf dem Bildschirm
      // gleich groß und springt nicht mehr zwischen festen Stufen (1, 2, 5, 10 mm …).
      distFit=fitAll(); const d0=distFit;
      // Millimeterpapier: feine Linien (1), mittlere (je 5) und kräftige (je 10) übereinander
      const unit=d0*0.012, gs=unit*500, y=-size.y/2-s0*0.8; window.__fineHalf=gs*3/2;
      grid=new THREE.Group(); grid.position.y=y;
      // fein nur in der Nähe, mittel und kräftig sehr weit – im Nebel ohne sichtbares Ende
      [[1,0.18,3],[5,0.38,8],[10,0.6,40]].forEach(([k,op,ext])=>{   // fein reicht jetzt bis in den Nebel
        const g=new THREE.GridHelper(gs*ext, Math.round(500*ext/k), 0x5c6167, 0x5c6167);
        g.material.transparent=true; g.material.opacity=op; g.material.depthWrite=false; g.position.y=k*1e-4*unit; grid.add(g);
      });
      gridScene.add(grid);   // eigene Szene: wird zuerst gezeichnet, der Schlüssel liegt immer darüber
      needs=true;
    }
    let userZoom=false; const bbox=new THREE.Vector3(1,1,1);
    const VIEWS={iso:[0.72,0.87],   // Start: von vorn rechts, etwa 40° von oben; kurzer Schenkel steht, langer läuft nach vorn
        front:[0,Math.PI/2],top:[0,0.0001],end:[Math.PI/2,Math.PI/2],bottom:[0,Math.PI-0.0001]};
    let angGoal=null;   // weiche Kamerafahrt zu einer Ansicht
    function setView(v, soft){ userZoom=false;
      const V=VIEWS[v];
      document.querySelectorAll('.v3tools [data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===v)));
      target.set(0,0,0); fitDist();
      if(soft && !reduce){ angGoal={t:V[0], p:V[1]}; } else { sph.theta=V[0]; sph.phi=V[1]; angGoal=null; }
      needs=true;
    }
    // von außen: weich zu einer Ansicht fahren (z. B. zur Stempelung nach unten)
    let resumeSpin=false;
    window.inbView=v=>{ if(!VIEWS[v]) return; if(spin){ resumeSpin=true; setSpin(false); } setView(v,true); };
    window.inbResumeSpin=()=>{ if(!resumeSpin) return; resumeSpin=false; setView('iso',true); setSpin(true); };
    // Zurücksetzen: Startansicht (Isometrie, Drehen an, eigener Zoom verworfen)
    window.inbCamReset=()=>{ resumeSpin=false; userZoom=false; target.set(0,0,0); setView('iso',true); setSpin(!reduce); };
    // Einpassen: genau auf den Schlüssel in der aktuellen Blickrichtung (Quader
    // projiziert, etwa 12 % Rand). Beim Drehen über die Hüllkugel, damit er
    // nie aus der Fläche läuft.
    // Abstand gleitet zum neuen Wert, statt zu springen
    // Ein Abstand je Schlüssel, der für ALLE Blickrichtungen und fürs Drehen
    // passt. Beim Wechsel der Ansicht dreht die Kamera nur, ohne zu zoomen;
    // bei neuer Schlüsselweite wird der Abstand sofort gesetzt (das Netz
    // skaliert mit), also kein Zoom-Effekt.
    let distGoal=null, distFit=null;
    function fitAll(){
      const th=sph.theta, ph=sph.phi, sp=spin; spin=false; let m=0;
      const dirs=[[0.72,0.87],[0,Math.PI/2],[Math.PI/2,Math.PI/2],[0,0.0001],[0,Math.PI-0.0001]];
      for(let k=0;k<12;k++) dirs.push([k*Math.PI/6,0.87]);             // Drehen läuft auf Höhe der Isometrie
      dirs.forEach(([t,p])=>{ sph.theta=t; sph.phi=p; m=Math.max(m,fitValue()); });
      sph.theta=th; sph.phi=ph; spin=sp; return m;
    }
    function fitDist(){ if(distFit==null) distFit=fitAll(); distGoal=null; sph.dist=distFit; needs=true; }
    function fitValue(){
      const r=region(), H=box.clientHeight||1, tv=Math.tan(THREE.MathUtils.degToRad(camera.fov/2));
      const v=Math.atan(tv*r.h/H), h=Math.atan(tv*r.w/H);   // Winkel der Vorschau-Fläche, nicht der ganzen Bühne
      if(spin) return radius/Math.sin(Math.min(v,h))*1.02;
      const p=Math.min(Math.max(sph.phi,0.0001),Math.PI-0.0001), t=sph.theta;
      const back=new THREE.Vector3(Math.sin(p)*Math.sin(t), Math.cos(p), Math.sin(p)*Math.cos(t));
      const fwd=back.clone().negate();
      let right=new THREE.Vector3().crossVectors(fwd,new THREE.Vector3(0,1,0));
      if(right.lengthSq()<1e-6) right.set(1,0,0); right.normalize();
      const up=new THREE.Vector3().crossVectors(right,fwd).normalize();
      let hx=0, hy=0, zn=0;
      for(const sx of [-1,1]) for(const sy of [-1,1]) for(const sz of [-1,1]){
        const c=new THREE.Vector3(sx*bbox.x/2, sy*bbox.y/2, sz*bbox.z/2);
        hx=Math.max(hx,Math.abs(c.dot(right))); hy=Math.max(hy,Math.abs(c.dot(up))); zn=Math.max(zn,c.dot(back));
      }
      return zn+Math.max(hy/Math.tan(v), hx/Math.tan(h))*1.12;
    }
    function place(){
      const d=sph.dist, p=Math.min(Math.max(sph.phi,0.0001),Math.PI-0.0001);
      camera.position.set(target.x+d*Math.sin(p)*Math.sin(sph.theta), target.y+d*Math.cos(p), target.z+d*Math.sin(p)*Math.cos(sph.theta));
      camera.near=Math.max(d/100,0.05); camera.far=d*20; camera.updateProjectionMatrix();
      camera.lookAt(target);
    }
    // Die 3D-Fläche füllt die ganze Bühne (Boden läuft hinter der Leiste weiter),
    // der Schlüssel bleibt aber in der Vorschau-Fläche: die Bildmitte wird dorthin
    // verschoben (setViewOffset) und die Einpassung rechnet mit dieser Fläche.
    function region(){
      const sb=box.getBoundingClientRect(), c=document.querySelector('.cfg-stage__canvas'), cr=c?c.getBoundingClientRect():sb;
      let w=cr.width||sb.width, h=cr.height||sb.height;
      if(innerWidth<=989){ const pn=document.querySelector('.cfg-panel'); if(pn){ const pr=pn.getBoundingClientRect(); if(pr.top>cr.top && pr.top<cr.top+h+40) h=Math.max(60, Math.min(h, pr.top-cr.top-12)); } }   // mobil: nichts unter Karte/Leiste
      const bar=document.querySelector('.cfg-infolay.is-bar:not([hidden])'); if(bar && !bar.classList.contains('is-open')){ const br=bar.getBoundingClientRect(); if(br.height) h=Math.max(60, br.top-cr.top-8); }   // mobil: Leiste „Übersicht · Abmessungen“ freihalten
      return {w, h, dx:(cr.left+w/2)-(sb.left+sb.width/2), dy:(cr.top+h/2)-(sb.top+sb.height/2)};
    }
    function applyOffset(){
      const W=box.clientWidth, H=box.clientHeight; if(!W||!H) return;
      const r=region(); camera.setViewOffset(W,H,-r.dx,-r.dy,W,H); camera.updateProjectionMatrix();
    }
    function resize(){
      const w=box.clientWidth, h=box.clientHeight; if(!w||!h) return;
      renderer.setSize(w,h,false); camera.aspect=w/h; applyOffset(); distFit=null; if(!userZoom) fitDist(); needs=true;
    }
    window.addEventListener('resize',()=>{ applyOffset(); distFit=null; if(!userZoom) fitDist(); needs=true; });
    // Die Vorschaufläche kann sich ändern, ohne dass sich das Fenster ändert (Schriftfeld, Leiste): dann neu einpassen
    { const cv=document.querySelector('.cfg-stage__canvas'); if(cv && window.ResizeObserver) new ResizeObserver(()=>{ applyOffset(); distFit=null; if(!userZoom) fitDist(); needs=true; }).observe(cv); }
    new ResizeObserver(resize).observe(box);
    window.inbRefit3d=()=>{ applyOffset(); distFit=null; if(!userZoom) fitDist(); needs=true; };

    // Steuerung: drehen, verschieben, zoomen (Maus und Touch)
    const ptrs=new Map(); let last=null, pinch0=0, mode='rot';
    const el=renderer.domElement;
    el.addEventListener('contextmenu',e=>e.preventDefault());
    el.addEventListener('pointerdown',e=>{ angGoal=null; window.inbMarkView(null); el.setPointerCapture(e.pointerId); ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
      mode=(e.button===2||e.shiftKey)?'pan':'rot'; last={x:e.clientX,y:e.clientY};
      if(ptrs.size===2){ const [a,b]=[...ptrs.values()]; pinch0=Math.hypot(a.x-b.x,a.y-b.y); last={x:(a.x+b.x)/2,y:(a.y+b.y)/2}; }
      stopSpin(); });
    el.addEventListener('pointermove',e=>{
      if(!ptrs.has(e.pointerId)) return; ptrs.set(e.pointerId,{x:e.clientX,y:e.clientY});
      if(ptrs.size===2){
        const [a,b]=[...ptrs.values()], d=Math.hypot(a.x-b.x,a.y-b.y), m={x:(a.x+b.x)/2,y:(a.y+b.y)/2};
        if(pinch0){ distGoal=null; sph.dist*=pinch0/d; clampDist(); userZoom=true; } pinch0=d; pan(m.x-last.x,m.y-last.y); last=m; needs=true; return;
      }
      const dx=e.clientX-last.x, dy=e.clientY-last.y; last={x:e.clientX,y:e.clientY};
      if(mode==='pan') pan(dx,dy); else { sph.theta-=dx*0.008; sph.phi-=dy*0.008; sph.phi=Math.min(Math.max(sph.phi,0.02),Math.PI-0.02); }
      needs=true;
    });
    const up=e=>{ ptrs.delete(e.pointerId); pinch0=0; if(ptrs.size===1){ const v=[...ptrs.values()][0]; last={x:v.x,y:v.y}; } };
    el.addEventListener('pointerup',up); el.addEventListener('pointercancel',up);
    el.addEventListener('pointerup',()=>idleRestart()); el.addEventListener('pointercancel',()=>idleRestart());
    el.addEventListener('wheel',e=>{ e.preventDefault(); window.inbMarkView(null); idleRestart(); if(spin) setSpin(false); userZoom=true; distGoal=null; sph.dist*=Math.exp(e.deltaY*0.0012); clampDist(); needs=true; },{passive:false});
    el.addEventListener('dblclick',()=>setView('iso'));
    function clampDist(){ sph.dist=Math.min(Math.max(sph.dist,radius*0.6),radius*25); }
    function pan(dx,dy){
      const h=2*sph.dist*Math.tan(THREE.MathUtils.degToRad(camera.fov/2)), k=h/box.clientHeight;
      const right=new THREE.Vector3().setFromMatrixColumn(camera.matrix,0), upv=new THREE.Vector3().setFromMatrixColumn(camera.matrix,1);
      target.addScaledVector(right,-dx*k).addScaledVector(upv,dy*k);
    }
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function spinLabel(){ const t=document.getElementById('spinToggle'); if(t) t.textContent = spin ? 'Rotation aus' : 'Rotation an'; }   // nennt, was ein Klick tut
    function setSpin(on){ spin=on; spinLabel(); if(on && window.inbMarkView) window.inbMarkView('spin'); $('spinOn').setAttribute('aria-pressed',String(on)); $('spinOff').setAttribute('aria-pressed',String(!on)); if(!userZoom){ fitDist(); } needs=true; }
    function stopSpin(){ if(spin) setSpin(false); }
    // Nach 10 s ohne Bedienung: zurück in die Ausgangslage und weiterdrehen
    // (auf der Stempel-Seite zurück auf die Unterseite, ohne Drehen)
    let idleT=null;
    function idleRestart(){ clearTimeout(idleT); idleT=setTimeout(()=>{
        const onStamp=!!document.querySelector('.cfg-flow > .cfg-step.is-page[data-key=stamp]') && !!document.querySelector('input[name=stampYN]:checked');
        userZoom=false; target.set(0,0,0); distGoal=null;
        if(onStamp){ setView('bottom',true); } else { setView('iso',true); setSpin(!reduce); }
        applyOffset(); fitDist(); needs=true; }, 10000); }
    window.inbIdleRestart=idleRestart;
    // Standbild des 3D-Modells für die Mini-Vorschau (direkt nach dem Zeichnen auslesen)
    window.inbSnap3d=function(){ try{ place(); gridScene.fog=scene.fog; renderer.autoClear=false; renderer.clear(); renderer.render(gridScene,camera); renderer.clearDepth(); renderer.render(scene,camera); return renderer.domElement.toDataURL('image/png'); }catch(e){ return null; } };
    $('spinOn').onclick=()=>setSpin(true);
    $('spinToggle').onclick=()=>setSpin(!spin);
    window.inbSpin=on=>setSpin(!!on);
    $('spinOff').onclick=()=>setSpin(false);
    // Unten: Rotation · Isometrie · Front · Seite · Oben · Unten. Fett ist, was man sieht;
    // schaut man selbst hinein (Ziehen, Zoomen), ist keins davon gewählt.
    window.inbMarkView=v=>document.querySelectorAll('.v3tools [data-view]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.view===v)));
    document.querySelectorAll('.v3tools [data-view]').forEach(b=>b.onclick=()=>{
      if(b.dataset.view==='spin'){ setView('iso',true); setSpin(true); }
      else { setSpin(false); setView(b.dataset.view,true); }
    });
    let dead=false;
    function stop3d(err){
      dead=true; console.error('3D-Vorschau angehalten:', err);
      const p=document.createElement('div'); p.className='v3msg inb-text-body-s inb-text-muted'; p.textContent='Die 3D-Ansicht konnte nicht dargestellt werden.'; box.appendChild(p);
    }
    function loop(){
      if(dead) return; requestAnimationFrame(loop);
      const cw=box.clientWidth, ch=box.clientHeight, pr=renderer.getPixelRatio(), cv=renderer.domElement;
      if(cw&&ch&&(cv.width!==Math.floor(cw*pr)||cv.height!==Math.floor(ch*pr))) resize();
      if(distGoal!=null){ const dd=distGoal-sph.dist; if(Math.abs(dd)>distGoal*0.002){ sph.dist+=dd*0.12; } else { sph.dist=distGoal; distGoal=null; } needs=true; }
      if(angGoal){   // weich, kürzester Weg um die Achse
        let dt=angGoal.t-sph.theta; dt=Math.atan2(Math.sin(dt),Math.cos(dt)); const dp=angGoal.p-sph.phi;
        if(Math.abs(dt)<0.002 && Math.abs(dp)<0.002){ sph.theta=angGoal.t; sph.phi=angGoal.p; angGoal=null; }
        else { sph.theta+=dt*0.06; sph.phi+=dp*0.06; }
        needs=true;
      }
      if(window.__v3Swap && window.__v3Swap()) needs=true;
      if(window.__v3Fade && window.__v3Fade()) needs=true;
      if(spin && !angGoal){ sph.theta+=0.006; needs=true; } if(!needs) return; needs=false;
      if(scene.fog){ const lim=(window.__fineHalf||1e9)*0.9; scene.fog.near=Math.min(sph.dist*1.2, lim*0.45); scene.fog.far=Math.min(sph.dist*3.2, lim); }   // Nebel endet, bevor das feine Raster aufhört   // Nebel folgt dem Kameraabstand   // erst hinfahren, dann drehen (sonst halten sich Fahrt und Drehen die Waage)
      try{ place(); gridScene.fog=scene.fog; renderer.autoClear=false; renderer.clear(); renderer.render(gridScene,camera); renderer.clearDepth(); renderer.render(scene,camera); }catch(err){ stop3d(err); }   // erst Boden, dann Schlüssel: von oben liegt er auf dem Raster, von unten davor
    }
    let key0='', first=true;
    // Willkommens-Animation: Oberfläche und Farbe gehen weich ineinander über, ein neuer
    // Kugelkopf blendet ein. Größe, Längen und Kamera bleiben dabei stehen.
    let fade=null, lastEnds={L:null,S:null};
    function look(){ const out={}; group.traverse(o=>{ if(!o.isMesh) return; [].concat(o.material).forEach(m=>{ if(!m||!m.color||m.map) return; const r=m.userData.fin==='farbcodiert'?'coat':'body'; if(!out[r]) out[r]={c:m.color.clone(),mt:m.metalness,rg:m.roughness}; }); }); return out; }
    function startFade(prev,prevBalls){
      const list=[]; group.traverse(o=>{ if(!o.isMesh) return; [].concat(o.material).forEach(m=>{ if(!m||!m.color||m.map) return;
        const r=m.userData.fin==='farbcodiert'?'coat':'body', from=prev[r]||prev.body||prev.coat; if(!from) return;
        const to={c:m.color.clone(),mt:m.metalness,rg:m.roughness}; const isNewBall=!!o.userData.ball && prevBalls[o.userData.ball]!=='kugel';   // nur ein neu erscheinender Kugelkopf blendet ein
        if(isNewBall) m.userData.newBall=true;
        m.color.copy(from.c); m.metalness=from.mt; m.roughness=from.rg; if(isNewBall){ m.transparent=true; m.opacity=0; }
        list.push({m,from,to,ball:isNewBall}); }); });
      fade={t0:performance.now(), list};
    }
    // Willkommens-Animation: ganzer Schlüssel blendet aus, der neue blendet ein
    let swap=null;
    function setOp(op,done){ group.traverse(o=>{ if(!o.isMesh) return; [].concat(o.material).forEach(m=>{ if(!m) return; if(m.userData.newBall && !done) return;
      if(m.userData.wasT===undefined) m.userData.wasT=m.transparent;
      if(done){ m.transparent=m.userData.wasT; m.opacity=1; delete m.userData.wasT; } else { m.transparent=true; m.opacity=op; m.depthWrite=op>0.98; }
      m.needsUpdate=true; }); }); }
    window.__v3Swap=()=>{ if(!swap) return false; const now=performance.now(), D=swap.phase==='out'?1400:1800, LOW=0.72;   // nur leicht abdunkeln, nicht ganz aus
      const k=Math.min(1,(now-swap.t0)/D), e=k<.5?2*k*k:1-Math.pow(-2*k+2,2)/2;
      setOp(swap.phase==='out'?1-(1-LOW)*e:LOW+(1-LOW)*e, false);
      if(k>=1){ if(swap.phase==='out'){ const prev=look(), pb={...lastEnds}; try{ build(); }catch(err){ stop3d(err); swap=null; return true; } lastEnds={L:st.endLong,S:st.endShort}; startFade(prev,pb); setOp(LOW,false); swap={phase:'in',t0:now}; }
                else { setOp(1,true); swap=null; } }
      return true; };
    window.__v3Fade=()=>{ if(!fade) return false; const k=Math.min(1,(performance.now()-fade.t0)/1800), e=k<.5?2*k*k:1-Math.pow(-2*k+2,2)/2;
      fade.list.forEach(({m,from,to,ball})=>{ m.color.copy(from.c).lerp(to.c,e); m.metalness=from.mt+(to.mt-from.mt)*e; m.roughness=from.rg+(to.rg-from.rg)*e; if(ball){ m.opacity=e; if(k>=1){ m.transparent=false; m.opacity=1; delete m.userData.newBall; } } });
      if(k>=1) fade=null; return true; };
    return { update(){
      const k=[st.size,st.l1,st.l2,st.endLong,st.endShort,st.surface,st.color,st.stampLine].join('|');
      if(k===key0||dead) return;
      const demo=!!window.__demoFade && !first && !swap, prev=null;
      const prevBalls={...lastEnds};
      key0=k;
      if(demo){ window.__demoFade=false; swap={phase:'out', t0:performance.now()}; needs=true; return; }
      try{ build(); }catch(err){ stop3d(err); return; }
      lastEnds={L:st.endLong, S:st.endShort};
      if(demo){ window.__demoFade=false; swap={phase:'out', t0:performance.now()}; needs=true; return; }   // neuer Schlüssel wird nach dem Ausblenden gebaut   // Kamera bleibt stehen
      if(first){ first=false; resize(); spin=!reduce; spinLabel(); setView('iso'); if(spin) window.inbMarkView('spin'); $('spinOn').setAttribute('aria-pressed',String(spin)); $('spinOff').setAttribute('aria-pressed',String(!spin)); loop(); }   // Standard: Drehen an, Isometrie
      else { applyOffset(); userZoom=false; fitDist(); needs=true; }   // neuer Schlüssel: Bildmitte und Abstand frisch, eigener Zoom verfällt
    }};
  })();

  // Willkommens-Animation: alle 3,5 s wechselt zufällig die Oberfläche (mal mit, mal ohne RAL)
  // oder ein Kugelkopf erscheint bzw. verschwindet. Keine Stempelung. Endet mit „Konfiguration starten“.
  window.inbDemo=(function(){
    let timer=null; const METALS=['blank','phosphatiert','vernickelt','verchromt','verzinkt'];
    const pick=a=>a[Math.floor(Math.random()*a.length)];
    function tick(){
      // ein ganz neuer Schlüssel: Oberfläche mal mit, mal ohne RAL; Kugelköpfe zufällig
      const before=[st.surface,st.color,st.endLong,st.endShort].join('|');
      for(let tries=0; tries<5; tries++){
        if(Math.random()<0.45){ st.baseSurface='vernickelt'; st.surface='farbcodiert'; st.color=pick(RAL)[1]; }
        else { st.baseSurface=null; st.surface=pick(METALS); }
        st.endLong=Math.random()<0.5?'kugel':'gerade'; st.endShort=Math.random()<0.35?'kugel':'gerade';
        if([st.surface,st.color,st.endLong,st.endShort].join('|')!==before) break;
      }
      st.markSize=false; st.engraving='';
      window.__demoFade=true; try{ V3.update(); }catch(e){}
    }
    const reduceM=window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    return {
      start(){ if(timer||reduceM) return; timer=setInterval(tick,6000); /* ruhiger Takt */ },
      stop(){ if(timer){ clearInterval(timer); timer=null; } window.__demoFade=false; if(window.inbRender) window.inbRender(); }
    };
  })();
  if(!row(st.size)) st.size=defaults.size;
  writeForm(); render();
})();
;
/* Probe: Ablauf in der Seitenleiste.
   Schritte als Aufklapper, einer offen. Die Zahl ist schwarz und wird grün,
   sobald im Schritt etwas gewählt wurde. Unten „Teilen und speichern“ und
   „Anfrage senden“, die jeweils ihren Teil darunter aufklappen.
   Versendet wird in der Probe nichts. */
(function(){
  var $=function(id){ return document.getElementById(id); };
  var steps=[].slice.call(document.querySelectorAll('.cfg-step')).filter(function(li){ return li.getAttribute('data-key')!=='finish'; });
  var finalStep=document.querySelector('.cfg-step--final');
  // Ein Schritt ist erst erreichbar, wenn im vorigen gewählt wurde.
  // Grau = gesperrt, schwarz = erreichbar, grün = gewählt.
  // Einblenden, sobald ein Element frei wird (Knopf, Auswahl, Feld, Schritt)
  function unlockFx(){}   // offene Variante: ohne Einblenden
  document.addEventListener('animationend',function(e){ if(e.animationName==='cfg-unlock') e.target.classList.remove('cfg-unlock'); });
  function gate(){
    var reach=true;
    steps.forEach(function(li){
      var head=li.querySelector('.cfg-step__head');
      if(reach && li.classList.contains('is-locked')){ unlockFx(li.querySelector('.inb-steps__marker')); unlockFx(head); }
      li.classList.toggle('is-locked',!reach); head.disabled=true;
      var fs=li.querySelector('fieldset'); if(fs) fs.disabled=!reach;       // gesperrter Schritt: alles darin inaktiv
      if(!li.classList.contains('is-set')) reach=false;
    });
    // Teilen und Anfrage erst, wenn alle Schritte gewählt sind
    var all=steps.every(function(li){ return li.classList.contains('is-set'); });
    document.querySelectorAll('.cfg-finish__buttons .inb-button').forEach(function(b){ b.disabled=!all; });
    if(finalStep){ finalStep.classList.toggle('is-locked',!all); if(!all) finalStep.classList.remove('is-set'); }   // 7: grau, schwarz, nach Versand grün
    var lock=document.getElementById('finishLock'); if(lock) lock.hidden=all;
    if(window.inbRenderSummary) window.inbRenderSummary();
    var setNow=steps.filter(function(x){ return x.classList.contains('is-set'); }).length;
    // Nur scrollen, wenn im vordersten Schritt gewählt wurde und er damit fertig ist –
    // nicht, wenn man weiter oben etwas nachträglich ändert
    var firstOpen=steps.findIndex(function(x){ return !x.classList.contains('is-set') || (x.getAttribute('data-key')==='qty' && !qtySeen); }); if(firstOpen<0) firstOpen=steps.length;
    // Sichtbar halten, was als Nächstes dran ist – aber nur so weit, bis es ganz
    // zu sehen ist. Ist der Schritt fertig: die Überschrift des nächsten Schritts.
    // Sonst: die nächste noch offene Frage im selben Schritt (z. B. Pulverbeschichtung
    // nach der Oberfläche, kurzer Schenkel nach dem langen, das Textfeld nach „Ja“).
    if(wantScroll && pickedLi){
      var idx=steps.indexOf(pickedLi), target=null;
      if(pickedLi.classList.contains('is-set') && idx===firstOpen-1){
        target=nextFieldAfter(pickedLi);   // bis zum Ende des ersten Eingabefelds im nächsten Schritt
      } else if(!pickedLi.classList.contains('is-set') && idx===firstOpen){
        target=firstOpenQuestion(pickedLi);
      }
      if(target) reveal(target);
    }
    wantScroll=false; pickedLi=null; setBefore=setNow;
    // Zusammenfassung: unter den Knöpfen, geht auf, sobald alle Schritte grün sind. Vorher angeteasert (oben sichtbar, nach unten
    // ausgeblendet wie die Karten „im Schrauberalltag“), bei allen Schritten
    // grün gehen sie sanft auf
    var rv=document.getElementById('cfgReveal');
    if(rv && rv.classList.contains('is-open')!==all){
      if(all){ rv.classList.add('is-open'); rv.style.maxHeight=rv.scrollHeight+'px'; }
      else { rv.style.maxHeight=rv.scrollHeight+'px'; void rv.offsetHeight; rv.classList.remove('is-open'); rv.style.maxHeight=''; }
      rv.setAttribute('aria-hidden',String(!all));
    }
  }
  // Offene Variante: alle Schritte stehen aufgeklappt da
  function open(){
    steps.forEach(function(x){
      x.classList.add('is-open');
      x.querySelector('.cfg-step__head').setAttribute('aria-expanded','true');
      x.querySelector('.cfg-step__body').hidden=false;
    });
  }
  steps.forEach(function(li){
    li.querySelector('.inb-steps__marker').addEventListener('click',function(){ li.querySelector('.cfg-step__head').click(); });
    li.querySelector('.cfg-step__head').addEventListener('click',function(){ if(li.classList.contains('is-locked')) return; open(li.classList.contains('is-open')?null:li); if(li.getAttribute('data-key')==='qty' && li.classList.contains('is-open')) mark(li); });
  });

  // Reiter in Schritt 3: Oberfläche · Farbe
  function subtab(name){
    document.querySelectorAll('[data-subtab]').forEach(function(b){ b.setAttribute('aria-selected',String(b.getAttribute('data-subtab')===name)); });
    document.querySelectorAll('[data-subpane]').forEach(function(p){ p.hidden=p.getAttribute('data-subpane')!==name; });
  }
  document.querySelectorAll('[data-subtab]').forEach(function(b){ b.addEventListener('click',function(){ subtab(b.getAttribute('data-subtab')); }); });
  // Ja/Nein-Auswahlen setzen ihre Felder, bevor das Formular das Ereignis sieht
  document.querySelectorAll('[data-kk]').forEach(function(g){
    g.addEventListener('input',function(e){ $(g.getAttribute('data-kk')).value=e.target.value; });
  });
  document.querySelector('[data-stamp]').addEventListener('input',function(e){ $('markSize').checked = e.target.value==='ja'; });
  // eigener Text: mit „Übernehmen“ oder Enter bestätigen, dann weiter zur Menge
  var engravingOk=false;   // eigener Text gilt erst nach „Übernehmen“ (oder Enter)
  window.inbStampOk=function(){ var sz=document.querySelector('input[name=size]:checked'), sv=sz?parseFloat(sz.value):0; if(sv && sv<3) return true; var br=document.querySelector('input[name=brand]:checked'); return !!(document.querySelector('input[name=stampYN]:checked') && br && (br.value!=='eigene' || $('engraving').value.trim()) && document.querySelector('input[name=migYN]:checked') && document.querySelector('input[name=crvYN]:checked')); };
  function stampCheck(){ var li=$('engraving').closest('.cfg-step');
    li.classList.toggle('is-set', window.inbStampOk()); gate(); setTimeout(summary,0); }
  $('engraving').addEventListener('input',function(){ if(engravingOk){ engravingOk=false; } setTimeout(stampCheck,0); });   // jede Änderung muss neu übernommen werden
  function confirmEngraving(){
    if(!$('engraving').value.trim()) { $('engraving').focus({preventScroll:true}); return; }
    engravingOk=true; stampCheck();
    $('engraving').blur();
    var li=$('engraving').closest('.cfg-step'); if(li.classList.contains('is-set')) reveal(nextFieldAfter(li));
  }
  $('engravingOk').addEventListener('click',confirmEngraving);
  window.inbConfirmEngraving=confirmEngraving;
  $('engraving').addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); confirmEngraving(); } });
  document.querySelectorAll('input[name=fcYN]').forEach(function(i){ i.addEventListener('click',function(){ var nn=document.querySelector('input[name=fcYN][value=nein]'); nn.__auto=false; }); });   // eigene Wahl bleibt stehen
  // Sonderlänge: Werte außerhalb des erlaubten Bereichs (2 × s … 2 × Extra-lang, l₂ ≤ l₁) sind rot,
  // beim Verlassen des Felds wird auf die nächste zulässige Länge gesetzt
  function lenLimits(){ return window.inbLenBounds ? window.inbLenBounds() : {min:0,max:1e9}; }
  function lenMark(){ const b=lenLimits(); ['l1','l2'].forEach(k=>{ const v=parseFloat($(k).value); let bad=$(k).value!=='' && (!(v>=b.min) || v>b.max);
      if(k==='l2' && !bad && $('l1').value!=='' && v>parseFloat($('l1').value)) bad=true; $(k).setAttribute('aria-invalid', bad?'true':'false'); }); }
  function lenClamp(k){ const el=$(k); if(el.value==='') return; const b=lenLimits(); let v=parseFloat(el.value); if(!isFinite(v)) { el.value=''; return; }
      v=Math.min(b.max, Math.max(b.min, v)); if(k==='l2' && $('l1').value!=='') v=Math.min(v, parseFloat($('l1').value));
      v=Math.round(v*2)/2; if(String(v)!==el.value){ const was=el.value; el.value=String(v); el.dispatchEvent(new Event('input',{bubbles:true})); el.dispatchEvent(new Event('change',{bubbles:true}));
        const h=$('lenHint'); h.__keep=true; window.inbNote(h,'change','Länge geändert','Außerhalb des zulässigen Bereichs.');
        clearTimeout(h.__t); h.__t=setTimeout(()=>{ h.__keep=false; window.inbNote(h); },8000); } lenMark(); }
  ['l1','l2'].forEach(function(k){ $(k).addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); $(k).blur(); } }); });
  ['l1','l2'].forEach(function(k){ $(k).addEventListener('input',function(){ setTimeout(lenMark,0); }); $(k).addEventListener('blur',function(){ lenClamp(k); if(k==='l1') lenClamp('l2'); $('cfg').dispatchEvent(new Event('input',{bubbles:true})); }); });
  // Sonderlänge: sobald man tippt, gilt Sonderlänge (Standard/Extra-lang abgewählt);
  // wählt man Standard oder Extra-lang, werden die Eingaben geleert (Normmaß steht als Platzhalter)
  ['l1','l2'].forEach(function(k){ $(k).addEventListener('input',function(){
    if(!$(k).value) return; var so=document.querySelector('input[name=series][value=sonder]');
    if(so && !so.checked){ so.checked=true; so.dispatchEvent(new Event('change',{bubbles:true})); } }); });
  document.querySelectorAll('input[name=series]').forEach(function(r){ r.addEventListener('change',function(){
    if(r.checked && r.value!=='sonder'){ $('l1').value=''; $('l2').value=''; } }); });
  // Pulverbeschichtung „Ja“ bei anderer Oberfläche: auf vernickelt umstellen und das sichtbar machen
  function fcNotice(title,txt){ var h=$('fcHint'); h.__notice=true; window.inbNote(h,'change',title,txt); clearTimeout(h.__t); h.__t=setTimeout(function(){ h.__notice=false; window.inbNote(h); },8000);
    var sel=$('surface').closest('.cfg-select'); if(sel){ sel.classList.remove('is-flash'); void sel.offsetWidth; sel.classList.add('is-flash'); } }
  document.querySelector('[data-fc]').addEventListener('change',function(e){
    if(e.target.value==='ja' && $('surface').value!=='' && $('surface').value!=='vernickelt'){
      $('surface').value='vernickelt'; $('surface').dispatchEvent(new Event('input',{bubbles:true})); $('surface').__fromFc=true; $('surface').dispatchEvent(new Event('change',{bubbles:true})); $('surface').__fromFc=false;
      fcNotice('Oberfläche geändert','Pulverbeschichtung nur auf vernickelter Oberfläche.'); } });
  $('surface').addEventListener('change',function(){ if($('surface').__fromFc) return; var fc=document.querySelector('input[name=fcYN]:checked');
    if(fc && fc.value==='ja' && $('surface').value!=='vernickelt'){ var n=document.querySelector('input[name=fcYN][value=nein]'); n.checked=true; n.dispatchEvent(new Event('input',{bubbles:true})); n.dispatchEvent(new Event('change',{bubbles:true}));
      fcNotice('Pulverbeschichtung entfernt','Pulverbeschichtung nur auf vernickelter Oberfläche.'); } });
  // Eigene Stempelung: sobald Text drinsteht, ersetzt er INBUS® (INBUS® → Nein)
  $('engraving').addEventListener('input',function(){ if($('engraving').value.trim()){ var n=document.querySelector('input[name=inbusYN][value=nein]'); if(n && !n.checked){ n.checked=true; n.dispatchEvent(new Event('input',{bubbles:true})); n.dispatchEvent(new Event('change',{bubbles:true})); } } });
  // INBUS® Ja: eigenen Text leeren (INBUS® wird gestempelt)
  document.querySelector('[data-inbus]').addEventListener('change',function(e){ if(e.target.value==='ja' && $('engraving').value){ $('engraving').value=''; $('engraving').dispatchEvent(new Event('input',{bubbles:true})); } });
  // Stempelung: Kamera fährt weich auf die Unterseite, wo sie sitzt
  function showStamp(){ if(window.__cfgLoading) return; if(window.inbView && !document.getElementById('cfg-pane-3d').hidden) window.inbView('bottom'); }
  document.querySelector('[data-stamp]').addEventListener('change',function(){ showStamp(); });
  document.querySelector('[data-inbus]').addEventListener('change',function(){ showStamp(); });
  // Marke: INBUS® · Eigene · Keine – „Eigene“ öffnet direkt darunter das Eingabefeld
  document.querySelectorAll('input[name=brand]').forEach(function(r){ r.addEventListener('change',function(){
    var v=r.value, own=$('ownRow'), ib=document.querySelector('input[name=inbusYN][value='+(v==='inbus'?'ja':'nein')+']');
    if(ib && !ib.checked){ ib.checked=true; ib.dispatchEvent(new Event('input',{bubbles:true})); ib.dispatchEvent(new Event('change',{bubbles:true})); }
    var was=own.hidden; own.hidden = v!=='eigene';
    if(v!=='eigene' && $('engraving').value){ $('engraving').value=''; $('engraving').dispatchEvent(new Event('input',{bubbles:true})); }
    if(v==='eigene' && was){ unlockFx(own); setTimeout(function(){ try{ $('engraving').focus({preventScroll:true}); }catch(e){} },60); }
    showStamp(); }); });   // schon bei der ersten Antwort (Ja oder Nein)
  $('engraving').addEventListener('input',function(){ if($('engraving').value.trim()) showStamp(); });
  // Stempelung nur in Großbuchstaben, Ziffern und wenigen Zeichen (keine Unterlängen)
  $('engraving').addEventListener('input',function(){
    var el=$('engraving'), pos=el.selectionStart, v=el.value.toUpperCase().replace(/[^A-Z0-9ÄÖÜ®.,\-\/&+ ]/g,'').slice(0,(window.inbStampMax?window.inbStampMax():10));   // Höchstzahl je nach Schenkellänge
    var cut = el.value.toUpperCase().replace(/[^A-Z0-9ÄÖÜ®.,\-\/&+ ]/g,'').length > v.length;
    if(v!==el.value){ el.value=v; try{ el.setSelectionRange(pos,pos); }catch(e){} }
    if(cut){ var sn=$('stampCut'); window.inbNote(sn,'change','Text gekürzt','Textlänge überschritten.'); clearTimeout(sn.__t); sn.__t=setTimeout(function(){ window.inbNote(sn); },8000); }
  },true);
  // Stempelung: Hinweis, wenn mehr getippt oder eingefügt wird, als passt (das Feld schneidet selbst ab)
  function stampCutNote(){ var sn=$('stampCut'); window.inbNote(sn,'change','Text gekürzt','Textlänge überschritten.'); clearTimeout(sn.__t); sn.__t=setTimeout(function(){ window.inbNote(sn); },8000); }
  $('engraving').addEventListener('beforeinput',function(e){ var el=e.target; if(!/^insert/.test(e.inputType)) return;
    var sel=(el.selectionEnd||0)-(el.selectionStart||0), add=(e.data||'').length; if(el.value.length-sel+add>el.maxLength) stampCutNote(); });
  $('engraving').addEventListener('paste',function(e){ var el=e.target, t=(e.clipboardData&&e.clipboardData.getData('text'))||''; var sel=(el.selectionEnd||0)-(el.selectionStart||0); if(el.value.length-sel+t.length>el.maxLength) stampCutNote(); });
  // Eigene Stempelung: erst nach „Ja“ das Feld freigeben; „Nein“ leert es
  (document.querySelector('[data-own]')||document.createElement('div')).addEventListener('input',function(e){
    var on=e.target.value==='ja'; if(on && $('ownRow').hidden) unlockFx($('ownRow')); $('ownRow').hidden=!on;
    if(!on && $('engraving').value){ $('engraving').value=''; $('engraving').dispatchEvent(new Event('input',{bubbles:true})); }
    if(on) setTimeout(function(){ try{ $('engraving').focus({preventScroll:true}); }catch(e){ $('engraving').focus(); } },0);   // ohne Sprung; sichtbar macht es das ruhige Scrollen
  });
  // Menge: 0 = noch nicht gewählt; frei eingebbar ab 1
  function setQty(v){ var q=$('qty'); v=v||0; q.value = v<=0 ? '' : Math.max(1,Math.round(v)); q.dispatchEvent(new Event('input',{bubbles:true})); }   // freie Menge ab 1
  document.querySelectorAll('[data-qty]').forEach(function(b){ b.addEventListener('click',function(){ setQty((parseInt($('qty').value,10)||0)+Number(b.getAttribute('data-qty'))); }); });
  $('qty').addEventListener('input',function(){ var v=$('qty').value.replace(/[^0-9]/g,'').replace(/^0+/,''); if(v && parseInt(v,10)>99999999) v='99999999'; if(v!==$('qty').value) $('qty').value=v; });   // nur Ziffern, 1 bis 99.999.999
  $('qty').addEventListener('blur',function(){ var v=parseInt($('qty').value,10); if(!(v>=1)) $('qty').value=''; });

  // Auswahl getroffen: Klick auf eine Auswahl oder Eingabe im Schritt
  var form=$('cfg');
  function mark(li){ if(li && !li.classList.contains('is-set')){ li.classList.add('is-set'); gate(); } setTimeout(summary,0); }
  // Als Auswahl zählt eine eigene Wahl im Schritt; bei der Stempelung müssen beide Fragen beantwortet sein
  // Nach einer Wahl per Knopf oder Liste zum nächsten offenen Schritt scrollen.
  // Nicht beim Tippen (Sonderlänge, eigene Stempelung, Menge) und nicht nach
  // „Sonderlänge“, weil dann noch die Maße einzugeben sind.
  var wantScroll=false, setBefore=0, glideId=0, pickedLi=null;
  var qtySeen=false;   // Menge ist mit 100 gültig, gilt für das Scrollen aber erst als erledigt, wenn man dort war
  function nextFieldAfter(li){
    var nx=steps[steps.indexOf(li)+1]||finalStep; if(!nx) return null;
    if(nx.getAttribute('data-key')==='qty') qtySeen=true;
    return firstOpenQuestion(nx) || nx.querySelector('.cfg-length, .cfg-options, .cfg-qty, .cfg-finish__buttons') || nx.querySelector('.cfg-step__head');
  }
  // erste noch unbeantwortete, freigegebene Frage in einem Schritt
  function firstOpenQuestion(li){
    var fields=[].slice.call(li.querySelectorAll('.cfg-field')).filter(function(f){ return f.offsetParent!==null && !f.closest('[hidden]'); });
    for(var i=0;i<fields.length;i++){
      var f=fields[i], radios=f.querySelectorAll('input[type=radio]:not(:disabled)'), sel=f.querySelector('select:not(:disabled)'), txt=f.querySelector('input[type=text]:not(:disabled)');
      if(radios.length && !f.querySelector('input[type=radio]:checked')) return f;
      if(sel && sel.value==='') return f;
      if(txt && txt.value.trim()==='') return f;
    }
    return null;
  }
  // nur so weit scrollen, bis das Element ganz sichtbar ist
  const AUTO_SCROLL=false;   // Weiterscrollen nach einer Auswahl vorerst aus; nur „Zurücksetzen“ scrollt (nach oben)
  function reveal(el){
    if(!AUTO_SCROLL) return;
    var pan=document.querySelector('.cfg-panel'); if(!pan||!el) return;
    // unten mehr Luft (≈ 100px), damit man sieht, dass danach noch etwas kommt
    var r=el.getBoundingClientRect(), pr=pan.getBoundingClientRect(), m=24, mb=Math.min(110, pr.height*0.18);
    if(r.bottom>pr.bottom-mb) glide(pan, pan.scrollTop+Math.min(r.bottom-(pr.bottom-mb), r.top-(pr.top+m)));
    else if(r.top<pr.top+m) glide(pan, pan.scrollTop-((pr.top+m)-r.top));
  }
  // Ruhig gleiten: kurze Pause, damit man die Wahl noch sieht, dann ~0,9 s mit sanftem Ein- und Auslauf
  function glide(el, to){
    var id=++glideId, from=el.scrollTop, max=el.scrollHeight-el.clientHeight; to=Math.max(0,Math.min(max,to));
    if(Math.abs(to-from)<4) return;
    if(matchMedia('(prefers-reduced-motion: reduce)').matches){ el.scrollTop=to; return; }
    var dur=1500, t0=null, ease=function(t){ return t<.5 ? 4*t*t*t : 1-Math.pow(-2*t+2,3)/2; };
    setTimeout(function(){
      function step(ts){ if(id!==glideId) return; if(t0===null) t0=ts; var k=Math.min(1,(ts-t0)/dur); el.scrollTop=from+(to-from)*ease(k); if(k<1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    },700);
    // Eigenes Scrollen (Mausrad, Finger) bricht das Gleiten ab
    ['wheel','touchstart','pointerdown','keydown'].forEach(function(ev){ el.addEventListener(ev,function stop(){ glideId++; el.removeEventListener(ev,stop); },{once:true,passive:true}); });
  }
  function onPick(e){
    var tg=e.target, kind=tg.type;
    if((kind==='radio'||tg.tagName==='SELECT') && !(tg.name==='series'&&tg.value==='sonder')){ wantScroll=true; pickedLi=tg.closest('.cfg-step'); }
    var li=e.target.closest&&e.target.closest('.cfg-step');
    if(li && li.getAttribute('data-key')==='material'){
      // Schritt 3: Oberfläche gewählt und Pulverbeschichtung beantwortet; bei „Ja“ mit RAL-Ton
      var fc=document.querySelector('input[name=fcYN]:checked');
      var wasHidden=$('colorRow').hidden; $('colorRow').hidden=!(fc && fc.value==='ja'); if(wasHidden && !$('colorRow').hidden) unlockFx($('colorRow'));
      li.classList.toggle('is-set', !!document.querySelector('input[name=hardYN]:checked') && $('surface').value!=='' && !!fc && (fc.value==='nein' || !!document.querySelector('input[name=ral]:checked'))); gate(); setTimeout(summary,0); return;
    }
    if(li && li.getAttribute('data-key')==='ends'){
      // Kugelkopf: erst grün, wenn beide Schenkel beantwortet sind
      li.classList.toggle('is-set', !!(document.querySelector('input[name=kkLong]:checked') && document.querySelector('input[name=kkShort]:checked') && document.querySelector('input[name=chamfer]:checked'))); gate(); setTimeout(summary,0); return;
    }
    if(li && li.getAttribute('data-key')==='stamp'){
      var ok=window.inbStampOk();   // eigener Text erst nach „Übernehmen“
      li.classList.toggle('is-set',ok); gate(); setTimeout(summary,0);
      return;
    }
    if(li && li.getAttribute('data-key')==='length'){
      var se=document.querySelector('input[name=series]:checked');
      var lenOk=true; if(se && se.value==='sonder' && window.inbLenBounds){ var b=window.inbLenBounds(), a1=parseFloat($('l1').value), a2=parseFloat($('l2').value); lenOk = a1>=b.min && a2>=b.min && a1<=b.max && a2<=b.max && a1>=a2; }
      li.classList.toggle('is-set', !!se && (se.value!=='sonder' || ($('l1').value!=='' && $('l2').value!=='' && lenOk)));
      gate(); setTimeout(summary,0); return;
    }
    if(li && li.getAttribute('data-key')==='qty'){
      // Menge: erst ab 100 gewählt; dann weiter zur 7
      var was=li.classList.contains('is-set'), q=parseInt($('qty').value,10)||0;
      li.classList.toggle('is-set', q>=1); gate(); setTimeout(summary,0);
      if(!was && q>=1 && e.target.type!=='number') reveal(finalStep.querySelector('.cfg-finish__buttons'));
      if(!was && q>=1 && e.target.type==='number' && e.type==='input' && document.activeElement!==e.target) reveal(finalStep.querySelector('.cfg-finish__buttons'));
      return;
    }
    var ok=li && (e.target.value!=='' || e.target.type==='number');
    if(ok) mark(li); else setTimeout(summary,0);
    if(wantScroll) gate();   // auch wenn der Schritt schon grün war (z. B. Sonderlänge → Kurz)
  }
  // Innerhalb eines Schritts nacheinander freigeben: die nächste Frage erst,
  // wenn die vorige beantwortet ist
  function subGate(){
    var dis=function(name,off){
      document.querySelectorAll('input[name='+name+']').forEach(function(i){ if(i.disabled && !off) unlockFx(i.nextElementSibling); i.disabled=off; });
      var g=document.querySelector('input[name='+name+']'); if(g){ var f=g.closest('.cfg-field'); if(f) f.classList.toggle('is-waiting',off); }
    };
    dis('kkShort', !document.querySelector('input[name=kkLong]:checked'));     // Kugelkopf: erst langer, dann kurzer Schenkel
    var szS=document.querySelector('input[name=size]:checked'), small=!!szS && parseFloat(szS.value)<3;
    dis('stampYN', small);
    dis('inbusYN', small || !document.querySelector('input[name=stampYN]:checked'));    // Stempelung: erst Schlüsselweite, dann INBUS®
    dis('brand', small || !document.querySelector('input[name=stampYN]:checked'));
    dis('migYN', small || !document.querySelector('input[name=brand]:checked'));
    dis('crvYN', small || !document.querySelector('input[name=migYN]:checked'));
    if(small){ ['migYN','crvYN'].forEach(function(n){ document.querySelectorAll('input[name='+n+']').forEach(function(i){ i.checked=false; }); }); }
    // Platz: MADE IN GERMANY und Werkstoff nur, wenn sie noch auf die halbe Länge von l₁ passen (Vorrang 8 → Marke → MiG → Werkstoff)
    if(!small && window.inbStampParts){ var sp=window.inbStampParts(), fn=$('stampFitNote'), msgs=[];
      var mj=document.querySelector('input[name=migYN][value=ja]'), cj=document.querySelector('input[name=crvYN][value=ja]');
      if(mj && document.querySelector('input[name=brand]:checked')){ mj.disabled=!sp.migFits; if(!sp.migFits){ msgs.push('MADE IN GERMANY'); var mn=document.querySelector('input[name=migYN][value=nein]'); if(!mn.checked){ mn.checked=true; mn.dispatchEvent(new Event('input',{bubbles:true})); mn.dispatchEvent(new Event('change',{bubbles:true})); } } }   // passt nicht: „Nein“ gesetzt, „Ja“ gesperrt
      if(cj && document.querySelector('input[name=migYN]:checked')){ cj.disabled=!sp.crvFits; if(!sp.crvFits){ msgs.push('Werkstoff'); var cn2=document.querySelector('input[name=crvYN][value=nein]'); if(!cn2.checked){ cn2.checked=true; cn2.dispatchEvent(new Event('input',{bubbles:true})); cn2.dispatchEvent(new Event('change',{bubbles:true})); } } }
      if(msgs.length) window.inbNote(fn,'info',(msgs.length>1?'Made in Germany und Werkstoff':msgs[0]==='MADE IN GERMANY'?'Made in Germany':'Werkstoff')+' nicht verfügbar','Textlänge überschritten.');
      else if(sp.crv==='CrV' && sp.items.indexOf('CrV')>=0) window.inbNote(fn,'info','Werkstoff gekürzt','Textlänge überschritten. Stempelung „CrV“ statt „59CrV4“.');
      else window.inbNote(fn); }
    $('engraving').disabled = small || !document.querySelector('input[name=stampYN]:checked');
    $('stampNote').hidden = !small;
    if(small){ ['stampYN','inbusYN'].forEach(function(n){ document.querySelectorAll('input[name='+n+']').forEach(function(i){ i.checked=false; }); }); if($('engraving').value){ $('engraving').value=''; } $('markSize').checked=false; }
    var lsS=$('engraving').closest('.cfg-step'); if(lsS) lsS.classList.toggle('is-set', window.inbStampOk());
    if($('surface').disabled && document.querySelector('input[name=hardYN]:checked')) unlockFx($('surface').closest('.cfg-select'));
    $('surface').disabled = !document.querySelector('input[name=hardYN]:checked');   // erst Gehärtet, dann Oberfläche
    $('surface').closest('.cfg-field').classList.toggle('is-waiting', $('surface').disabled);
    dis('fcYN',    $('surface').value==='');                                   // erst Oberfläche, dann Pulverbeschichtung
    // Pulverbeschichtung nur für s = 1,5 · 2 · 2,5 · 3 · 4 · 5 · 6 · 8 · 10
    var sz=document.querySelector('input[name=size]:checked'), okSize=!!sz && window.inbFcSizes.indexOf(parseFloat(sz.value))>=0, okSurf=$('surface').value==='vernickelt';
    var ja=document.querySelector('input[name=fcYN][value=ja]');
    // Größe passt nicht → Pulver nie möglich (schon vor der Oberfläche); Oberfläche nicht vernickelt → ebenfalls nicht
    var surfSet=$('surface').value!=='', row=document.getElementById('fcRow'), nn=document.querySelector('input[name=fcYN][value=nein]');
    if(ja && row && (!okSize || surfSet)){ /* Größe entscheidet, ob die Frage erscheint */
      var onlyNo=!okSize;   // nur die Größe sperrt; eine andere Oberfläche wird bei „Ja“ auf vernickelt umgestellt
      ja.disabled = onlyNo;
      if(onlyNo){ row.hidden=true; if(!nn.checked){ nn.checked=true; nn.__auto=true; nn.dispatchEvent(new Event('change',{bubbles:true})); } }   // nur „Nein“ möglich: keine Auswahl zeigen
      else { if(row.hidden){ row.hidden=false; unlockFx(row); } if(nn.__auto){ nn.checked=false; nn.__auto=false; nn.dispatchEvent(new Event('change',{bubbles:true})); } }   // wieder wählbar: Nutzer entscheidet selbst
    } else if(row && row.hidden){ row.hidden=false; if(nn.__auto){ nn.checked=false; nn.__auto=false; nn.dispatchEvent(new Event('change',{bubbles:true})); } }
    { var hint=document.getElementById('fcHint'), SZ='s = 1,5 · 2 · 2,5 · 3 · 4 · 5 · 6 · 8 · 10 mm';
      var FC_TXT='Pulverbeschichtung ist nur bei vernickelter Oberfläche und für <span class="cfg-nowrap">s = 1,5 · 2 · 2,5 · 3 · 4 · 5 · 6 · 8 · 10 mm</span> möglich.';
      if(hint && !okSize && hint.__notice){ hint.__notice=false; clearTimeout(hint.__t); }   /* Größe passt nicht: diese Info hat Vorrang */
      if(hint && !hint.__notice){ if(!okSize) window.inbNote(hint,'info','Pulverbeschichtung nicht verfügbar','Für diese Schlüsselweite nicht lieferbar.'); else window.inbNote(hint); } }
    // „Ja“ nur für die Schlüsselweiten mit Pulverbeschichtung; sonst gesperrt und ggf. auf „Nein“ zurück
    var sz=document.querySelector('input[name=size]:checked'), fcOk=!sz || (window.inbFcOk && window.inbFcOk(sz.value));
    var ja=document.querySelector('input[name=fcYN][value=ja]');
    if(ja){ if(!fcOk){ ja.disabled=true; if(ja.checked){ var nn=document.querySelector('input[name=fcYN][value=nein]'); nn.checked=true; setTimeout(function(){ nn.dispatchEvent(new Event('input',{bubbles:true})); nn.dispatchEvent(new Event('change',{bubbles:true})); },0); } } }
    avail();
  }
  // ---------- Verfügbarkeiten (hart gesperrt) ----------
  // Oberflächen: verzinkt nur Standard/Extra-lang, s 1,5–6, gratfrei (dadurch ohne Kugelkopf);
  //              verchromt nur Extra-lang mit Kugelkopf (langer Schenkel), s 1,5–10 ohne 3,5 · 4,5 · 9.
  // Kugelkopf:   Standard s 1,5–10, Extra-lang s 1,5–12, jeweils ohne 3,5 · 4,5 · 9; Sonderlänge vorerst frei (offen).
  // Fase:        unter 3 mm immer gratfrei, über 6 mm immer gefast; 3–6 mm Wahl (mit Kugelkopf gefast).
  var availBusy=false;
  function avail(){
    if(availBusy) return; availBusy=true;
    try{
      var szI=document.querySelector('input[name=size]:checked'), s=szI?parseFloat(szI.value):null;
      var seI=document.querySelector('input[name=series]:checked'), ser=seI?seI.value:null;
      var KKX=[3.5,4.5,9];
      var kkOk = s==null || ser==null || ser==='sonder' || (!KKX.includes(s) && s>=1.5 && s<=(ser==='lang'?12:10));
      var znOk = s==null || ((ser==null || ser!=='sonder') && s>=1.5 && s<=6);
      var crOk = s==null || ((ser==null || ser==='lang') && s>=1.5 && s<=10 && !KKX.includes(s));
      var sel=$('surface'), o=function(v){ return sel.querySelector('option[value="'+v+'"]'); };
      if(o('verzinkt')) o('verzinkt').disabled=!znOk;
      if(o('verchromt')) o('verchromt').disabled=!crOk;
      var why=[], heads=[]; if(!znOk){ why.push('Verzinkte Oberfläche nur Standardlänge und Extra-lang bis 6 mm.'); heads.push('Verzinkte Oberfläche'); }
      if(!crOk){ why.push('Verchromte Oberfläche nur Extra-lang mit Kugelkopf bis 10 mm.'); heads.push('Verchromte Oberfläche'); }
      var sn=$('surfNote');
      if((sel.value==='verzinkt' && !znOk) || (sel.value==='verchromt' && !crOk)){
        sel.value=''; sel.dispatchEvent(new Event('input',{bubbles:true})); sel.dispatchEvent(new Event('change',{bubbles:true}));
        window.inbNote(sn,'change','Oberfläche geändert','Gewählte Oberfläche für diese Konfiguration nicht verfügbar.'); sn.__until=Date.now()+8000;
      } else if(!sn.__until || Date.now()>sn.__until){
        window.inbNote(sn, why.length?'info':null, why.length?((heads.length>1?'Verzinkte und verchromte Oberfläche':heads[0])+' nicht verfügbar'):'', why.join(' '));
      }
      var surf=sel.value;
      // Kugelkopf
      var setR=function(name,v){ var i=document.querySelector('input[name='+name+'][value='+v+']'); if(i && !i.checked){ i.checked=true; i.dispatchEvent(new Event('input',{bubbles:true})); i.dispatchEvent(new Event('change',{bubbles:true})); } };
      var lock=function(name,off){ document.querySelectorAll('input[name='+name+']').forEach(function(i){ i.disabled=off; }); };
      var kn=$('kkAvailNote');
      if(!kkOk || surf==='verzinkt'){
        setR('kkLong','gerade'); setR('kkShort','gerade'); lock('kkLong',true); lock('kkShort',true);
        window.inbNote(kn,'info','Kugelkopf nicht verfügbar', !kkOk?'Für diese Schlüsselweite und Länge nicht lieferbar.':'Verzinkte Oberfläche immer ohne Kugelkopf.');
      } else if(surf==='verchromt'){
        setR('kkLong','kugel'); lock('kkLong',true); lock('kkShort',false);
        window.inbNote(kn,'info','Kugelkopf festgelegt','Verchromte Oberfläche immer mit Kugelkopf am langen Schenkel.');
      } else {
        lock('kkLong',false); lock('kkShort', !document.querySelector('input[name=kkLong]:checked'));
        window.inbNote(kn);
      }
      // Fase
      var kL=(document.querySelector('input[name=kkLong]:checked')||{}).value, kS=(document.querySelector('input[name=kkShort]:checked')||{}).value;
      var noKK = kL==='gerade' && kS==='gerade', answered = !!kL && !!kS;
      var ufOk = noKK && s!=null && s>=3 && s<=6;   // freie Wahl gefast/gratfrei
      var row=$('chamferRow'), cn=$('chamferNote'), g=document.querySelector('input[name=chamfer][value=gefast]');
      var anyKK = kL==='kugel' || kS==='kugel';
      var fixed = s!=null && (s<3 || s>6 || surf==='verzinkt' || anyKK);   // Ergebnis steht schon fest – nicht auf beide Antworten warten
      var waiting=!answered && !fixed;
      row.classList.toggle('is-waiting', waiting);
      if(s!=null && s<3){                          // unter 3 mm: immer gratfrei (sofort)
        setR('chamfer','gratfrei'); lock('chamfer',true); window.inbNote(cn,'info','Fase festgelegt','Winkelschraubendreher mit Schlüsselweiten unter 3 mm immer gratfrei.');
      } else if(surf==='verzinkt'){                // verzinkt: nur gratfrei
        setR('chamfer','gratfrei'); lock('chamfer',true);
        window.inbNote(cn,'info','Fase festgelegt','Verzinkte Oberfläche immer gratfrei.');
      } else if(answered && ufOk){                  // 3–6 mm ohne Kugelkopf: freie Wahl
        if(g.__auto){ document.querySelectorAll('input[name=chamfer]').forEach(function(i){ i.checked=false; }); g.__auto=false; }
        lock('chamfer',false); window.inbNote(cn);
      } else if(answered || fixed){                 // nur gefast – ausgegraut (sofort, wenn schon feststeht)
        if(!g.checked){ setR('chamfer','gefast'); g.__auto=true; }
        lock('chamfer',true);
        window.inbNote(cn,'info','Fase festgelegt', (s!=null && s>6)?'Winkelschraubendreher mit Schlüsselweiten über 6 mm immer gefast.':'Mit Kugelkopf immer gefast.');
      } else {                                      // erst Kugelkopf beantworten
        document.querySelectorAll('input[name=chamfer]').forEach(function(i){ i.checked=false; }); lock('chamfer',true); window.inbNote(cn);
      }
    } finally { availBusy=false; }
  }
  form.addEventListener('input',subGate);
  form.addEventListener('change',subGate);
  form.addEventListener('input',onPick);
  form.addEventListener('change',onPick);
  // Beim Start ist nichts ausgewählt (die Vorschau zeigt bis dahin einen Hinweis)
  function unpick(){ setTimeout(function(){ if(window.inbRender) window.inbRender(); },0);   // Angaben danach neu: „–“, solange nichts gewählt ist

    $('ownRow').hidden=true;
    ['size','series','kkLong','kkShort','chamfer','stampYN','ownYN','brand','inbusYN','migYN','crvYN','hardYN','fcYN','ral'].forEach(function(n){ document.querySelectorAll('input[name='+n+']').forEach(function(i){ i.checked=false; }); });
    $('material').value='CrV';   /* CrV ist die einzige Legierung und bleibt gewählt */
    $('surface').selectedIndex=0; $('qty').value=''; document.querySelectorAll('input[name=hardYN]').forEach(function(i){ i.checked=false; }); subtab('finish'); $('colorRow').hidden=true; $('markSize').checked=false; $('ownRow').hidden=false; $('engraving').value='';
  }
  unpick(); subGate();
  $('resetBtn').addEventListener('click',function(){
    // alles auf Anfang – die Ansicht (3D oder Zeichnung) bleibt, wie sie gerade ist;
    // Kamera Isometrie mit Drehen, 2D-Zoom zurück, Leiste weich nach oben
    if(window.inbCamReset) window.inbCamReset();
    if(window.inb2dReset) window.inb2dReset();
    var pan=document.querySelector('.cfg-panel'); if(pan) glide(pan,0);
  });
  $('resetBtn').addEventListener('click',function(){ qtySeen=false; engravingOk=false; if(window.inbResetConfigIds) window.inbResetConfigIds(); setTimeout(function(){ unpick(); subGate(); },0); steps.forEach(function(li){ li.classList.remove('is-set'); }); gate(); open(steps[0]); setTimeout(summary,0); });
  var rv0=$('cfgReveal');
  rv0.setAttribute('aria-hidden','true');
  rv0.addEventListener('transitionend',function(e){ if(e.propertyName==='max-height' && rv0.classList.contains('is-open')) rv0.style.maxHeight='none'; });
  gate(); open(steps[0]);

  // Kurzwert neben dem Schritt
  function val(id){ var e=$(id); return e?e.value:''; }
  function selText(id){ var e=$(id); return e&&e.selectedOptions[0]?e.selectedOptions[0].text:''; }
  function summary(){
    var sz=document.querySelector('input[name=size]:checked'), se=document.querySelector('input[name=series]:checked'), ral=document.querySelector('input[name=ral]:checked');
    var endT=function(v){ return v==='kugel'?'Kugelkopf':'gerade'; };
    var v={
      length: (se?{kurz:'Standard',lang:'Extra-lang',sonder:'Sonderlänge'}[se.value]+', ':'')+String(val('l1')).replace('.',',')+' × '+String(val('l2')).replace('.',',')+' mm',
      size: sz?sz.value+' mm':'',
      material: (val('material')||'–')+', '+(val('surface')?selText('surface'):'–')+(function(){ var fc=document.querySelector('input[name=fcYN]:checked'); return fc&&fc.value==='ja'&&ral?', '+ral.parentNode.textContent.trim():''; })(),
      ends: {'gerade|gerade':'ohne Kugelkopf','kugel|gerade':'am langen Schenkel','gerade|kugel':'am kurzen Schenkel','kugel|kugel':'an beiden Schenkeln'}[val('endLong')+'|'+val('endShort')]+(((document.querySelector('input[name=chamfer]:checked')||{}).value==='gratfrei')?', gratfrei':''),
      stamp: ((window.inbStampParts && window.inbStampParts().line) || 'ohne'),
      qty: (val('qty')||'–')+' Stück'
    };
    steps.forEach(function(li){ li.querySelector('[data-step-value]').textContent=v[li.getAttribute('data-key')]||''; });
  }
  summary();

  // Abschluss: zwei Dialoge (System: .inb-dialog, data-inb-dialog-open)
  document.querySelectorAll('[data-page-open]').forEach(function(b){
    b.addEventListener('click',function(){
      if(finalStep) finalStep.classList.add('is-set');   // 7 wird grün, sobald Teilen/Speichern oder Anfrage angeklickt ist
      var d=$(b.getAttribute('data-page-open'));   // Seite 8: Formular im Seitenfluss (Zusammenfassung stand auf Seite 7)
      d.querySelector('.cfg-finish__form').hidden=false; d.querySelector('.cfg-finish__thanks').hidden=true;
      d.querySelectorAll('.toast').forEach(function(t){ t.textContent=''; });
      if(d.id==='cfg-dialog-share') $('permalink').textContent=window.inbConfigLink();
    });
  });
  function check(fields,toast){
    var bad=fields.filter(function(f){ return !f.value.trim()||(f.type==='email'&&!f.checkValidity()); });
    fields.forEach(function(f){ f.setAttribute('aria-invalid',bad.indexOf(f)>-1?'true':'false'); });
    if(bad.length){ toast.style.color='var(--warn)'; toast.textContent='Bitte die mit * markierten Felder ausfüllen.'; bad[0].focus(); return false; }
    toast.textContent=''; return true;
  }
  function thanks(id,text){
    if(finalStep) finalStep.classList.add('is-set');   // Bestätigung: Schritt 7 grün
    document.dispatchEvent(new CustomEvent('cfg:thanks'));   // Punkt 8 grün
    var d=$(id); d.querySelector('.cfg-finish__form').hidden=true;
    var t=d.querySelector('.cfg-finish__thanks'); t.hidden=false; t.querySelector('[data-thanks-text]').textContent=text;
  }
  $('shareSend').addEventListener('click',function(){
    if(!check([$('shareFrom')],$('shareToast'))) return;
    var to=[$('shareFrom').value.trim(), $('shareTo').value.trim()].filter(Boolean).join(' und ');
    thanks('cfg-dialog-share','Ihre Konfiguration geht mit Link und PDF an '+to+'.');
  });
  // Anfrage über das Shopify-Kontaktformular senden (im Hintergrund; bei Spamschutz-Prüfung normal absenden)
  $('sendBtn').addEventListener('click',function(){
    if(!check([$('person'),$('email')],$('cardToast'))) return;
    var cf=document.getElementById('inbCfgContact'); if(!cf){ $('cardToast').textContent='Kontaktformular fehlt.'; return; }
    var sid=(document.getElementById('sumId')||{}).textContent||'', link=window.inbConfigLink?window.inbConfigLink():'';
    var put=function(n,v){ var i=cf.querySelector('[name="'+n+'"]'); if(i) i.value=v||''; };
    put('contact[name]',$('person').value.trim()); put('contact[email]',$('email').value.trim()); put('contact[phone]',$('phone').value.trim());
    put('contact[Firma]',$('company').value.trim()); put('contact[Adresse]',[$('address').value.trim(),$('city').value.trim()].filter(Boolean).join(', '));
    put('contact[Konfigurations-ID]',sid); put('contact[Link]',link);
    put('contact[body]','Anfrage Winkelschraubendreher (Konfigurator)\n\n'+(($('sum')||{}).textContent||'')+'\n\nHinweise: '+($('notes').value.trim()||'–'));
    var btn=$('sendBtn'); btn.disabled=true; $('cardToast').textContent='Wird gesendet …';
    var done=function(){
      btn.disabled=false; $('cardToast').textContent='';
      thanks('cfg-dialog-quote','Vielen Dank für Ihre Anfrage. Wir prüfen Ihre Konfiguration auf Realisierbarkeit und melden uns zeitnah per E-Mail an '+$('email').value.trim()+' – in der Regel innerhalb von zwei Werktagen.');
      var t2=document.querySelector('#cfg-dialog-quote .cfg-finish__thanks [data-thanks-more]'); if(t2){ t2.innerHTML='Bei Fragen erreichen Sie uns unter <a class="inb-link" href="mailto:info@inbus.de?subject='+encodeURIComponent('Konfiguration '+sid)+'">info@inbus.de</a>. Bitte geben Sie dabei Ihre Konfigurations-ID <span class="cfg-nowrap">'+sid+'</span> an.'; }
    };
    var fallback=function(){ try{ sessionStorage.setItem('inbCfgSent',sid); }catch(e){} cf.submit(); };   // Spamschutz: normal absenden, nach dem Neuladen geht es weiter
    fetch(cf.action,{method:'POST',body:new FormData(cf),credentials:'same-origin'}).then(function(r){
      if(r.ok && !/\/challenge/.test(r.url)) return done(); fallback();
    }).catch(fallback);
  });
  $('copyLink').addEventListener('click',function(){
    var link=window.inbConfigLink(); $('permalink').textContent=link;
    var t=$('shareToast'); t.style.color='';
    (navigator.clipboard?navigator.clipboard.writeText(link):Promise.reject()).then(function(){ t.textContent='Link kopiert.'; },function(){ t.textContent='Link markieren und kopieren.'; });
  });
})();
/* Dialoge öffnen und schließen: wie im Styleguide */
(function () {
  if (window.inbDialogBound) return;
  window.inbDialogBound = true;
  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-inb-dialog-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-inb-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function') { event.preventDefault(); if (!dialog.open) dialog.showModal(); }
      return;
    }
    var closer = event.target.closest('[data-inb-dialog-close]');
    if (closer) { var parent = closer.closest('dialog'); if (parent) parent.close(); return; }
    if (event.target.tagName === 'DIALOG' && event.target.classList.contains('inb-dialog')) event.target.close();
  });
})();
/* 2D-Zeichnung zoomen und verschieben */
(function(){
  var pane=document.getElementById('cfg-pane-2d'), d=pane&&pane.querySelector('.cfg-drawing');
  if(!d) return;
  var z=1, tx=0, ty=0, ptr=new Map(), last=null, pinch=0;
  // Zoom über den Ausschnitt (viewBox) der Zeichnung: sie wird bei jeder Stufe neu als Vektor
  // gezeichnet und bleibt scharf (eine CSS-Vergrößerung wird in Safari als Bild hochskaliert = pixelig)
  function apply(){
    var svg=document.getElementById('svg'); d.style.transform='none';
    var W=+svg.dataset.vbw||800, H=+svg.dataset.vbh||600, dw=d.clientWidth||1, dh=d.clientHeight||1;
    var k=Math.min(dw/W, dh/H), ox=(dw-W*k)/2, oy=(dh-H*k)/2;
    var bx=+svg.dataset.vbx||0, by=+svg.dataset.vby||0;
    if(z<=1.001){ svg.setAttribute('viewBox',bx+' '+by+' '+W+' '+H); }
    else { var x=bx+((-tx)/z-ox)/k, y=by+((-ty)/z-oy)/k, w=(dw/z)/k, h=(dh/z)/k; svg.setAttribute('viewBox',[x+ (w-W/z)*0, y, w, h].map(function(v){return v.toFixed(3);}).join(' ')); }
    pane.classList.toggle('is-zoomed', z>1.001);
  }
  window.inb2dApply=apply;
  function zoomAt(cx,cy,f){
    var r=d.getBoundingClientRect(), ox=r.left, oy=r.top;                  // Lage der Zeichenfläche (bleibt fest)
    var nz=Math.min(8,Math.max(1,z*f)); f=nz/z;
    var px=cx-ox, py=cy-oy; tx=px-(px-tx)*f; ty=py-(py-ty)*f; z=nz;
    if(z<=1.001){ z=1; tx=0; ty=0; }
    apply();
  }
  pane.addEventListener('wheel',function(e){ e.preventDefault(); zoomAt(e.clientX,e.clientY,Math.exp(-e.deltaY*0.0015)); },{passive:false});
  pane.addEventListener('dblclick',function(){ z=1; tx=0; ty=0; apply(); });
  window.inb2dReset=function(){ z=1; tx=0; ty=0; apply(); };
  pane.addEventListener('pointerdown',function(e){ pane.setPointerCapture(e.pointerId); ptr.set(e.pointerId,{x:e.clientX,y:e.clientY}); last={x:e.clientX,y:e.clientY};
    if(ptr.size===2){ var a=[].slice.call(ptr.values()); pinch=Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y); } });
  pane.addEventListener('pointermove',function(e){
    if(!ptr.has(e.pointerId)) return; ptr.set(e.pointerId,{x:e.clientX,y:e.clientY});
    if(ptr.size===2){ var a=[].slice.call(ptr.values()), dd=Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y), mx=(a[0].x+a[1].x)/2, my=(a[0].y+a[1].y)/2; if(pinch) zoomAt(mx,my,dd/pinch); pinch=dd; return; }
    if(z>1){ tx+=e.clientX-last.x; ty+=e.clientY-last.y; apply(); } last={x:e.clientX,y:e.clientY};
  });
  function up(e){ ptr.delete(e.pointerId); pinch=0; }
  pane.addEventListener('pointerup',up); pane.addEventListener('pointercancel',up);
  apply();
})();
/* Tastatur oder Zeiger: Fokusringe nur bei Tastaturbedienung */
(function(){
  var h=document.documentElement;
  document.addEventListener('keydown',function(e){ if(e.key==='Tab'||e.key.indexOf('Arrow')===0||e.key===' '||e.key==='Enter') h.classList.add('is-keyboard'); },true);
  document.addEventListener('pointerdown',function(){ h.classList.remove('is-keyboard'); },true);
})();
/* Seiten: jeder Schritt eine Seite. Zahlen oben (1–8), Pfeile ganz unten.
   1–6 werden grün mit „Weiter“, 7 (Zusammenfassung) mit Klick auf Teilen/Anfrage,
   8 (Teilen bzw. Anfrage) nach dem Absenden. Das Grün wächst als eine Linie von
   links nach rechts und läuft beim Zurücksetzen zurück. Gleiten wie das Etikett. */
(function(){
  var $=function(id){ return document.getElementById(id); };
  // Ordnung der Seitenkarte: Zahlen · Seiten (scrollen) · unterer Block (ID, Export, Knopf) · Zurück/Weiter
  (function(){ var pager=document.getElementById('cfgPager'), pages=document.getElementById('cfgPages'), nav=document.querySelector('.cfg-pager__nav--text'), act=document.getElementById('cfgActions'), fin=document.getElementById('cfgFinish'), foot=document.getElementById('cfgFoot');
    if(fin) pages.appendChild(fin); if(act) pager.appendChild(act); if(foot && act) act.insertBefore(foot, act.firstChild); if(nav) pager.appendChild(nav); })();
  var lis=[].slice.call(document.querySelectorAll('.cfg-flow > .cfg-step'));   // 1–6, 7
  var page8=$('cfgFinish'), pagesBox=$('cfgPages'), dotsBox=$('cfgDots'), actions=$('cfgActions');
  var reached=0;   // am weitesten bestätigte Seite (bleibt beim Zurückgehen erhalten)
  var N=lis.length, TOTAL=N+1, cur=0, confirmed=0, onPage8=false, seen8=false, done8=false, lastDlg='cfg-dialog-quote';
  var reduce=window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR=reduce?1:900;
  var titles=lis.map(function(li){ return ((li.querySelector('.cfg-step__title')||{}).textContent||'Zusammenfassung').trim(); }).concat(['Anfrage']);
  dotsBox.innerHTML='<span class="cfg-dots__track"><span class="cfg-dots__fill" id="cfgDotsFill"></span></span>'
    + titles.map(function(t,k){ return '<button type="button" class="cfg-dot" data-k="'+k+'" aria-label="'+(k+1)+'. '+t+'">'+(k+1)+'</button>'; }).join('');
  var dots=[].slice.call(dotsBox.querySelectorAll('.cfg-dot')), fill=$('cfgDotsFill'), progPrev=0;

  function valid(k){ return k<N-1 ? lis[k].classList.contains('is-set') : false; }
  function prog(){ var p=confirmed; if(p===N-1 && lis[N-1].classList.contains('is-set')){ p=N; if(done8) p=N+1; } return p; }
  function reachable(k){ return k<=confirmed || (k===N && seen8); }
  function stampReady(k){
    var li=lis[k]; if(!li || li.getAttribute('data-key')!=='stamp') return false;
    var own=document.querySelector('input[name=ownYN]:checked');
    return !!(document.querySelector('input[name=stampYN]:checked') && own && own.value==='ja' && $('engraving').value.trim());
  }
  function paintDots(){
    var p=prog(), from=progPrev, span=Math.max(1,Math.abs(p-from));
    var r0=dots[0].getBoundingClientRect(), tgt=dots[Math.min(p,TOTAL-1)].getBoundingClientRect();
    fill.style.transitionDuration=DUR+'ms'; fill.style.width=Math.max(0,(tgt.left+tgt.width/2)-(r0.left+r0.width/2))+'px';
    dots.forEach(function(d,k){
      var delay=0;
      if(p>from && k>=from && k<=p) delay=DUR*(k-from)/span;
      if(p<from && k<from && k>=p) delay=DUR*(from-1-k)/span;
      d.style.transitionDelay=Math.round(Math.max(0,delay))+'ms';
      d.classList.toggle('is-done', k<p);
      d.classList.toggle('is-open', k>=p && reachable(k));
      d.classList.toggle('is-current', onPage8 ? k===N : k===cur);
      d.disabled=!reachable(k);
    });
    progPrev=p;
  }
  var finishBtns=document.querySelector('.cfg-finish__buttons'), finishHome=finishBtns.parentNode;
  function paintNav(){
    var onSummary = cur===N-1 && !onPage8;
    // „Exportieren & speichern“: auf der Zusammenfassung unter der ID, auf Seite 8 über „Anfrage senden“
    // ID + Export: unten angeheftet – auf Seite 7 über „Produkt anfragen“, auf Seite 8 über „Anfrage senden“
    // ID + Export: fest unten in der Karte, darunter der Knopf der Seite („Produkt anfragen“ bzw. „Anfrage senden“)
    if(onPage8 && lastDlg==='cfg-dialog-share' && window.inbRenderQr) window.inbRenderQr();
    var send8=window.__send8 || (window.__send8=document.querySelector('#cfg-dialog-quote .cfg-sticky'));   // einmal merken: nach dem Verschieben liegt er nicht mehr im Formular
    if(send8){ if(!send8.__home) send8.__home=send8.parentNode;
      if(onPage8 && lastDlg==='cfg-dialog-quote' && !done8){ if(send8.parentNode!==actions) actions.appendChild(send8); }
      else if(send8.parentNode!==send8.__home) send8.__home.appendChild(send8); }
    document.querySelector('.cfg-panel').classList.toggle('is-summary', cur===N-1 || onPage8);   // Angaben-Kasten ausblenden, Seite wächst
    if(window.inbDimRender) window.inbDimRender();
    if(onSummary && finishBtns.parentNode!==actions) actions.appendChild(finishBtns);   // Knopf unter ID und Export
    if(!onSummary && finishBtns.parentNode!==finishHome) finishHome.appendChild(finishBtns);
    actions.hidden=!(onSummary || onPage8);
    // ID + Export: auf der Zusammenfassung und nach dem Absenden (Bestätigung); im Anfrageformular nicht
    { var ft=document.getElementById('cfgFoot'); if(ft) ft.hidden = !(onPage8 && (lastDlg==='cfg-dialog-share' || done8)); }   // ID + Export: Speichern-Seite und Bestätigung
    $('pgPrev').disabled = !(cur>0 || onPage8);
    var last = cur===N-1 || onPage8;

    $('pgNext').disabled = last || !(valid(cur) || stampReady(cur));
    $('pgNext').hidden = last;
  }
  function showEl(elNew, elOld, dir){
    if(elOld===elNew){ elNew.classList.add('is-page'); return; }
    elNew.classList.add('is-page');
    if(!elOld || reduce){ if(elOld) elOld.classList.remove('is-page'); return; }
    elNew.style.setProperty('--from', dir>0 ? '48px' : '-48px'); elOld.style.setProperty('--to', dir>0 ? '-48px' : '48px');
    elNew.classList.remove('is-leave'); elOld.classList.remove('is-enter');
    elNew.classList.add('is-enter'); elOld.classList.add('is-leave');
    setTimeout(function(){ elOld.classList.remove('is-page','is-leave'); elNew.classList.remove('is-enter'); }, 560);
  }
  function currentEl(){ return onPage8 ? page8 : lis[cur]; }
  function go(k, toPage8){
    var old=currentEl(), dir=toPage8 ? 1 : (onPage8 ? -1 : (k>cur?1:-1));
    if(!toPage8 && k===cur && !onPage8) return;
    // Stempelung: Kamera bleibt unten, solange man auf der Seite ist – erst beim Verlassen dreht sie wieder
    var wasStamp=!onPage8 && lis[cur] && lis[cur].getAttribute('data-key')==='stamp';
    if(wasStamp && (toPage8 || lis[k].getAttribute('data-key')!=='stamp') && window.inbResumeSpin) setTimeout(window.inbResumeSpin,0);
    if(toPage8){ seen8=true; page8.querySelectorAll('dialog').forEach(function(d){ d.open = d.id===lastDlg; }); }
    onPage8=!!toPage8; if(!toPage8) cur=k;
    page8.hidden=!onPage8;
    showEl(currentEl(), old, dir); pagesBox.scrollTop=0;
    paintDots(); paintNav();
  }
  $('pgNext').addEventListener('click',function(){
    if(stampReady(cur) && window.inbConfirmEngraving) window.inbConfirmEngraving();
    if(!valid(cur)) return;
    confirmed=Math.max(confirmed,cur+1); reached=Math.max(reached,confirmed);
    if(lis[cur] && lis[cur].getAttribute('data-key')==='stamp' && window.inbResumeSpin) setTimeout(window.inbResumeSpin,0);   // erst mit „Weiter“ wieder drehen
    var old=currentEl(); cur=cur+1; onPage8=false; page8.hidden=true; showEl(lis[cur], old, 1); pagesBox.scrollTop=0;
    paintDots(); paintNav();
  });
  $('pgPrev').addEventListener('click',function(){ if(onPage8) go(N-1,false); else if(cur>0) go(cur-1,false); });
  dots.forEach(function(d){ d.addEventListener('click',function(){ var k=+d.getAttribute('data-k'); if(!reachable(k)) return; if(k===N) go(N-1,true); else go(k,false); }); });
  document.querySelectorAll('[data-page-open]').forEach(function(b){
    b.addEventListener('click',function(){ lastDlg=b.getAttribute('data-page-open'); done8=false;
      var c=document.querySelector('#sumList dd.cfg-summary__code'), sc=document.getElementById('shareCode'); if(c&&sc) sc.textContent=c.textContent;
      setTimeout(function(){ go(N-1,true); },0); });
  });
  document.addEventListener('cfg:thanks',function(){ done8=true; paintDots(); paintNav(); });
  // Wischen
  var sx=null, sy=null;
  pagesBox.addEventListener('touchstart',function(e){ var t=e.touches[0]; sx=t.clientX; sy=t.clientY; },{passive:true});
  pagesBox.addEventListener('touchend',function(e){
    if(sx===null) return; var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy; sx=null;
    if(Math.abs(dx)<50 || Math.abs(dx)<Math.abs(dy)*1.5) return;
    if(dx<0 && !$('pgNext').disabled && $('pgNext').style.visibility!=='hidden') $('pgNext').click();
    if(dx>0 && !$('pgPrev').disabled) $('pgPrev').click();
  },{passive:true});
  function sync(){
    // Bestätigt ist alles bis zur ersten ungültigen Seite – höchstens so weit, wie man schon einmal war.
    // Wird eine Seite kurz ungültig (z. B. „Ja“ ohne RAL-Ton) und dann wieder gültig, sind die
    // folgenden Seiten sofort wieder über die Zahlen erreichbar.
    var c=0; while(c<N-1 && c<reached && valid(c)) c++;
    if(c!==confirmed){ var lost=c<confirmed; confirmed=c; if(lost){ seen8=false; done8=false; } }
    paintDots(); paintNav();
    return;
    paintDots(); paintNav();
  }
  var form=$('cfg');
  form.addEventListener('input',function(){ setTimeout(sync,0); });
  form.addEventListener('change',function(){ setTimeout(sync,0); });
  $('resetBtn').addEventListener('click',function(){
    setTimeout(function(){ confirmed=0; reached=0; seen8=false; done8=false; var old=currentEl(); cur=0; onPage8=false; page8.hidden=true; showEl(lis[0],old,-1); paintDots(); paintNav(); },20);
  });
  // Hinweis, dass die Seite weitergeht
  function moreHint(){ var rest=pagesBox.scrollHeight-pagesBox.clientHeight-pagesBox.scrollTop, on=pagesBox.classList.contains('is-more');
    if(!on && rest>16) pagesBox.classList.add('is-more'); else if(on && rest<4) pagesBox.classList.remove('is-more'); }   // mit Abstand zwischen An und Aus, damit nichts flackert
  pagesBox.addEventListener('scroll',moreHint,{passive:true});
  window.addEventListener('resize',moreHint);
  setInterval(moreHint,400);
  function metaHeight(){ var c=document.querySelector('#tb > div:last-child'), m=$('cfgMeta'); if(!c||!m) return;
    var h=c.getBoundingClientRect().height; m.parentNode.style.setProperty('--meta-h', h>0 ? Math.round(h)+'px' : 'auto'); }   // volle Höhe einer Schriftfeld-Reihe
  window.addEventListener('resize',metaHeight); setTimeout(metaHeight,50); setTimeout(metaHeight,600);
  window.addEventListener('resize',function(){ fill.style.transitionDuration='0ms'; var p=progPrev; progPrev=prog(); paintDots(); progPrev=p; });
  lis.forEach(function(li,k){ li.classList.toggle('is-page',k===0); });
  // Willkommensseite: erst „Konfiguration starten“ blendet Zahlen, Schritt 1, Angaben und Zurücksetzen ein
  var panel=document.querySelector('.cfg-panel');
  // Willkommen: das Grundprodukt dreht sich wie gewohnt (Überblend-Animation abgeschaltet)
  // Nach dem Laden: zur Zusammenfassung – oder zum ersten Schritt, der nach einer Korrektur noch offen ist
  window.inbPagerFinish=function(){
    var k=-1; for(var i=0;i<N-1;i++){ if(!lis[i].classList.contains('is-set')){ k=i; break; } }
    if(k<0){ confirmed=N-1; reached=N-1; go(N-1,false); }
    else { confirmed=k; reached=Math.max(reached,k); go(k,false); }
    paintDots(); paintNav(); };
  $('cfgStart').addEventListener('click',function(){
    if(window.inbDimApply) setTimeout(window.inbDimApply,60);
    if(window.inbDemo) window.inbDemo.stop();
    panel.classList.remove('is-welcome');
    lis[0].classList.add('is-enter'); setTimeout(function(){ lis[0].classList.remove('is-enter'); },560);
    fill.style.transitionDuration='0ms'; progPrev=0; paintDots(); paintNav();
    var first=lis[0].querySelector('input,button,select'); if(first) try{ first.focus({preventScroll:true}); }catch(e){}
  });
  paintDots(); paintNav();
})();
/* Konfiguration aus einer Konfigurations-ID laden (Eingabefeld oder ?c= in der Adresse) */
(function(){
  const $=id=>document.getElementById(id);
  function set(name,val){ const i=document.querySelector('input[name='+name+'][value="'+val+'"]'); if(!i) return; i.disabled=false; i.checked=true; ['input','change'].forEach(t=>i.dispatchEvent(new Event(t,{bubbles:true}))); }
  function setVal(id,val){ const el=$(id); if(!el) return; el.value=val; ['input','change'].forEach(t=>el.dispatchEvent(new Event(t,{bubbles:true}))); }
  function apply(o){
    set('size', String(o.size));
    if(o.series==='sonder'){ set('series','sonder'); setVal('l1',o.l1); setVal('l2',o.l2); $('l1').dispatchEvent(new Event('blur')); $('l2').dispatchEvent(new Event('blur')); }
    else set('series',o.series);
    set('hardYN',o.hard);
    const surf = o.ral ? 'vernickelt' : o.surface; const sel=$('surface'); sel.disabled=false; setVal('surface',surf);
    if(o.ral){ set('fcYN','ja'); const r=document.querySelector('input[name=ral][value]'); const all=[...document.querySelectorAll('input[name=ral]')]; const hit=all.find(x=>x.closest('label') && x.closest('label').textContent.includes(o.ral)); if(hit){ hit.checked=true; ['input','change'].forEach(t=>hit.dispatchEvent(new Event(t,{bubbles:true}))); } }
    else set('fcYN','nein');
    set('kkLong',o.endLong); set('kkShort',o.endShort); set('chamfer', o.chamfer || (o.size<3 ? 'gratfrei' : 'gefast'));
    if(o.size>=3){ set('stampYN', o.sw?'ja':'nein'); set('brand', o.text?'eigene':o.inbus?'inbus':'keine'); set('inbusYN', o.inbus?'ja':'nein'); if(o.text) setVal('engraving',o.text); set('migYN', o.mig?'ja':'nein'); set('crvYN', o.crv?'ja':'nein'); }
    if(o.qty>0) setVal('qty',String(o.qty));
  }
  function load(raw, fromUrl){
    const o=window.inbParseCode && window.inbParseCode(raw), note=$('loadIdNote');
    if(!o){ if(note && window.inbNote) window.inbNote(note,'error','Konfigurations-ID prüfen','ID unvollständig oder fehlerhaft.'); return false; }
    if(note && window.inbNote) window.inbNote(note);
    if(document.querySelector('.cfg-panel.is-welcome')) $('cfgStart').click();
    window.__cfgLoading=true;
    setTimeout(()=>{ apply(o); setTimeout(()=>{ if(window.inbPagerFinish) window.inbPagerFinish(); window.__cfgLoading=false; if(window.inbCamReset) window.inbCamReset(); adjusted(o); },250); },120);   // danach Ausgangslage und Drehen (nicht Unterseite)
    return true;
  }
  // Nach dem Laden: Wurde etwas korrigiert, oben in der Zusammenfassung gelb darauf hinweisen
  function adjusted(o){
    const now=window.inbParseCode && window.inbParseCode(window.inbCodeOf && window.inbCodeOf()); if(!now) return;
    const diff=[];
    if(o.series!==now.series || (o.series==='sonder' && (o.l1!==now.l1 || o.l2!==now.l2))) diff.push('Schenkellänge');
    if(o.surface!==now.surface) diff.push('Oberfläche');
    if((o.ral||null)!==(now.ral||null)) diff.push('Pulverbeschichtung');
    if((o.chamfer||(o.size<3?'gratfrei':'gefast'))!==(now.chamfer||(now.size<3?'gratfrei':'gefast'))) diff.push('Fase');
    if(!!o.mig!==!!now.mig || !!o.crv!==!!now.crv) diff.push('Stempelung');
    if(o.sw!==now.sw || o.inbus!==now.inbus || (o.text||'')!==(now.text||'')) diff.push('Stempelung');
    if((o.qty||0)!==(now.qty||0)) diff.push('Menge');
    let el=document.getElementById('loadAdjust');
    { const page=document.querySelector('.cfg-flow > .cfg-step.is-page .cfg-step__body') || document.querySelector('.cfg-summary');
      if(!el){ el=document.createElement('p'); el.id='loadAdjust'; el.className='cfg-note'; }
      if(page && el.parentNode!==page) page.prepend(el); }
    const uniq=[...new Set(diff)];
    if(uniq.length && window.inbNote) window.inbNote(el,'change','Konfiguration geändert','Nicht lieferbare Angaben korrigiert: '+uniq.join(', ')+'.');
    else if(window.inbNote) window.inbNote(el);
    const clear=()=>{ if(window.inbNote) window.inbNote(el); document.getElementById('cfg').removeEventListener('change',clear); };
    document.getElementById('cfg').addEventListener('change',clear);
  }
  window.inbLoadCode=load;
  // Startseite: zwischen „Konfiguration starten“ und „Mit gespeicherter Konfiguration fortfahren“ umschalten
  function loadMode(on){ const t=$('loadToggle'), box=$('loadBox'), st=$('cfgStart'); if(!t||!box||!st) return;
    box.hidden=!on; st.hidden=on; t.setAttribute('aria-expanded',String(on));
    t.textContent = on ? 'Neue Konfiguration starten' : 'Mit gespeicherter Konfiguration fortfahren';
    if(on){ try{ $('loadId').focus({preventScroll:true}); }catch(e){} } else if(window.inbNote) window.inbNote($('loadIdNote')); }
  $('loadToggle') && $('loadToggle').addEventListener('click',()=>loadMode($('loadBox').hidden));
  $('loadIdBtn') && $('loadIdBtn').addEventListener('click',()=>load($('loadId').value));
  $('loadId') && $('loadId').addEventListener('keydown',e=>{ if(e.key==='Enter'){ e.preventDefault(); load($('loadId').value); } });
  const q=new URLSearchParams(location.search).get('c'); if(q) setTimeout(()=>{ loadMode(true); $('loadId').value=q; load(q,true); },400);
})();
/* Ansicht: 3D · Technische Zeichnung */
(function(){
  var tabs=[document.getElementById('cfg-tab-3d'),document.getElementById('cfg-tab-2d')], view=document.querySelector('.cfg-stage__view');
  // Mini-Vorschau: zeigt immer die jeweils andere Ansicht; Klick wechselt
  // Galerie: beide Miniaturen, die aktive gerahmt
  function galRender(){
    const svg=document.getElementById('svg'), t2=document.getElementById('galThumb2d'), t3=document.getElementById('galThumb3d');
    if(svg && t2){ const vb=[svg.dataset.vbx||0, svg.dataset.vby||0, svg.dataset.vbw||800, svg.dataset.vbh||600].join(' ');
      t2.innerHTML='<svg viewBox="'+vb+'" preserveAspectRatio="xMidYMid meet">'+svg.innerHTML.replace(/<g class="mm-paper"[\s\S]*?<\/g>/,'')+'</svg>'; }
    if(t3 && window.inbSnap3d){ const url=window.inbSnap3d(); if(url) t3.innerHTML='<img alt="" src="'+url+'">'; }
  }
  window.inbGalRender=function(){ clearTimeout(window.__galT); window.__galT=setTimeout(galRender,150); };
  document.querySelectorAll('[data-gal]').forEach(function(b){ b.addEventListener('click',function(){ document.getElementById(b.getAttribute('data-gal')==='2d'?'cfg-tab-2d':'cfg-tab-3d').click(); }); });
  function swapRender(){
    const v=document.querySelector('.cfg-stage__view'), is2d=v && v.getAttribute('data-view')==='2d', th=document.getElementById('viewSwapThumb'), lb=document.getElementById('viewSwapLabel'); if(!th||!lb) return;
    lb.textContent = is2d ? '3D-Ansicht' : 'Technische Zeichnung';
    if(!is2d){ const svg=document.getElementById('svg'); if(!svg) return; const vb=[svg.dataset.vbx||0, svg.dataset.vby||0, svg.dataset.vbw||svg.dataset.vbw0||800, svg.dataset.vbh||600].join(' ');
      th.innerHTML='<svg viewBox="'+vb+'" preserveAspectRatio="xMidYMid meet">'+svg.innerHTML.replace(/<g class="mm-paper"[\s\S]*?<\/g>/,'')+'</svg>'; }
    else { const url=window.inbSnap3d && window.inbSnap3d(); th.innerHTML = url ? '<img alt="" src="'+url+'">' : '<span class="cfg-swap__cube">3D</span>'; }
  }
  window.inbSwapRender=function(){ if(window.inbGalRender) window.inbGalRender(); clearTimeout(window.__swapT); window.__swapT=setTimeout(swapRender,120); };
  document.getElementById('viewSwap').addEventListener('click',function(){ const v=document.querySelector('.cfg-stage__view'); const to2d=!(v && v.getAttribute('data-view')==='2d'); document.getElementById(to2d?'cfg-tab-2d':'cfg-tab-3d').click(); });
  // Einmaliger Hinweis auf die technische Zeichnung (erscheint kurz nach dem Start, verschwindet bei der ersten Aktion)
  (function(){ const KEY='inb-cfg-hint-2d', hint=document.getElementById('drawHint'); if(!hint) return; let tAuto=null, shown=false;
    const REMEMBER=false;   // Test: Hinweis bei jedem Start zeigen (für den Shop auf true setzen)
    const seen=()=>{ if(!REMEMBER) return false; try{ return localStorage.getItem(KEY)==='1'; }catch(e){ return false; } };
    const mark=()=>{ if(!REMEMBER) return; try{ localStorage.setItem(KEY,'1'); }catch(e){} };
    function fill(){ const svg=document.getElementById('svg'), img=document.getElementById('drawHintImg'), o=svg && svg.querySelector('[data-side-outline]'); if(!svg||!img) return;
      let vb=[svg.dataset.vbx||0, svg.dataset.vby||0, svg.dataset.vbw||800, svg.dataset.vbh||600].join(' ');
      if(img.innerHTML) return;   // immer dieselbe Grundansicht (Standardkonfiguration beim Start)
      // Ausschnitt: nur die Seitenansicht mit ihren Maß- und Mittellinien (links Platz für die Maßlinie l₂);
      // andere Ansichten liegen außerhalb und werden abgeschnitten, Schrift ist ausgeblendet
      if(svg.dataset.side){ const b=svg.dataset.side.split(' ').map(Number); vb=[b[0]-48, b[1]-22, b[2]+72, b[3]+46].map(v=>v.toFixed(1)).join(' '); }
      const tmp=document.createElement('div'); tmp.innerHTML='<svg>'+svg.innerHTML+'</svg>';
      tmp.querySelectorAll('.mm-paper, [data-hint-drop], text, rect[fill^="url(#grid"], pattern').forEach(n=>n.remove());   // ohne r, A–A, f, Schrift und Rastermuster
      let extra='';
      if(false && svg.dataset.side){ const b=svg.dataset.side.split(' ').map(Number), x1=b[0], x2=b[0]+b[2], yb=b[1]+b[3], y=yb+24, a=4.5;
        extra='<g stroke="var(--line)" stroke-width=".7" fill="none"><line x1="'+x1+'" y1="'+(yb+3)+'" x2="'+x1+'" y2="'+(y+6)+'"/><line x1="'+x2+'" y1="'+(yb+3)+'" x2="'+x2+'" y2="'+(y+6)+'"/><line x1="'+x1+'" y1="'+y+'" x2="'+x2+'" y2="'+y+'"/></g>'
          +'<path d="M'+x1+' '+y+' l'+(a*2)+' '+(-a/2)+' v'+a+' z M'+x2+' '+y+' l'+(-a*2)+' '+(-a/2)+' v'+a+' z" fill="var(--line)"/>';
}
      if(svg.dataset.side){ const b=svg.dataset.side.split(' ').map(Number); vb=[b[0]-48, b[1]-22, b[2]+72, b[3]+90].map(v=>v.toFixed(1)).join(' '); }
      img.innerHTML='<svg viewBox="'+vb+'" preserveAspectRatio="xMidYMid meet">'+tmp.firstChild.innerHTML+extra+'</svg>'; }
    let hover=false;
    function hide(force){ if(!shown) return; if(hover && !force) return; shown=false; clearTimeout(tAuto); hint.classList.remove('is-in'); setTimeout(()=>{ if(!shown) hint.hidden=true; },650); }
    function arrow(){ const t=document.getElementById('cfg-tab-2d').getBoundingClientRect(), top=document.querySelector('.cfg-stage__top').getBoundingClientRect(); hint.style.setProperty('--hint-arrow', Math.max(12, (t.left+t.width/2)-top.left-7)+'px'); }
    function prune(){ const svg=document.getElementById('svg'), ms=document.querySelector('#drawHintImg svg'); if(!svg||!ms||!svg.dataset.side) return;
      const b=svg.dataset.side.split(' ').map(Number), L=b[0]-50, T=b[1]-4, R=b[0]+b[2]+30, B=b[1]+b[3]+60;
      [...ms.children].forEach(n=>{ try{ const r=n.getBBox(); if(!(r.width||r.height)) return; const hit = r.x < R && r.x+r.width > L && r.y < B && r.y+r.height > T; if(!hit) n.remove(); }catch(e){} }); }
    function open(){ arrow(); { const tb=document.querySelector('.cfg-stage__top > .cfg-tabs-legacy'); if(tb) hint.style.width=tb.getBoundingClientRect().width+'px'; }
      if(seen() || document.querySelector('.cfg-stage__view[data-view="2d"]')) return; fill(); hint.hidden=false; prune(); void hint.offsetWidth; hint.classList.add('is-in'); shown=true; mark(); tAuto=setTimeout(hide,8000); }
    hint.addEventListener('pointerenter',()=>{ hover=true; clearTimeout(tAuto); });
    hint.addEventListener('pointerleave',()=>{ hover=false; clearTimeout(tAuto); tAuto=setTimeout(hide,3000); });   // beim Überfahren stehen lassen
    window.inbHint2d={open,hide};
    // entfällt seit app-268: die Zeichnung ist jetzt Standard, der Hinweis zeigt stattdessen auf 3D
    hint.addEventListener('click',()=>{ hide(true); document.getElementById('cfg-tab-2d').click(); });
    ['input','change'].forEach(ev=>document.getElementById('cfg').addEventListener(ev,hide));
    document.querySelector('.cfg-stage__canvas') && document.querySelector('.cfg-stage__canvas').addEventListener('pointerdown',hide);
    document.getElementById('cfg-tab-2d').addEventListener('click',()=>hide(true)); document.getElementById('cfg-tab-3d').addEventListener('click',()=>hide(true));
  })();
  // Stempel-Seite: wer dort zu 3D wechselt, sieht direkt die Unterseite mit der Stempelung
  document.getElementById('cfg-tab-3d').addEventListener('click',function(){
    if(document.querySelector('.cfg-flow > .cfg-step.is-page[data-key=stamp]') && window.inbView) setTimeout(function(){ window.inbView('bottom'); },60);
  });
  function show(i){
    ['cfg-tab-3d','cfg-tab-2d'].forEach(function(id,k){ var b=document.getElementById(id); if(b) b.setAttribute('aria-pressed', String(k===i)); });
    document.querySelectorAll('[data-gal]').forEach(function(b){ b.setAttribute('aria-pressed', String((b.getAttribute('data-gal')==='2d')===(i===1))); });
    tabs.forEach(function(t,k){ var on=k===i; t.setAttribute('aria-selected',String(on)); t.tabIndex=on?0:-1; document.getElementById(t.getAttribute('aria-controls')).hidden=!on; });
    view.setAttribute('data-view', i===1?'2d':'3d');
    requestAnimationFrame(function(){ if(window.inbDimApply) window.inbDimApply(); if(i===1 && window.inbDraw) window.inbDraw(); if(window.inbSwapRender) window.inbSwapRender(); });   // Abmessungen je Ansicht; Zeichnung neu, sobald sichtbar   // Papier ausrichten, sobald die Zeichnung sichtbar ist
  }
  tabs.forEach(function(t,i){
    t.addEventListener('click',function(){ show(i); });
    t.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'||e.key==='ArrowLeft'){ e.preventDefault(); var j=(i+1)%2; show(j); tabs[j].focus(); } });
  });
  show(0);
})();
;
/* QR-Code-Erzeugung: QRCode for JavaScript, (c) 2009 Kazuhiko Arase, MIT-Lizenz */
(function(){ var M={}, C={};
function req(n){ n=n.replace(/^\.\/|\.js$/g,""); if(C[n]) return C[n].exports; var m={exports:{}}; C[n]=m; M[n](m,m.exports); return m.exports; }
M["QRErrorCorrectLevel"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};


};
M["QRPolynomial"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
var QRMath = require('./QRMath');

function QRPolynomial(num, shift) {
	if (num.length === undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] === 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i) ) + QRMath.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = QRMath.glog(this.get(0) ) - QRMath.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var x = 0; x < e.getLength(); x++) {
			num[x] ^= QRMath.gexp(QRMath.glog(e.get(x) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

module.exports = QRPolynomial;

};
M["QRMaskPattern"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
module.exports = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

};
M["QRMode"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
module.exports = {
    MODE_NUMBER :       1 << 0,
    MODE_ALPHA_NUM :    1 << 1,
    MODE_8BIT_BYTE :    1 << 2,
    MODE_KANJI :        1 << 3
};

};
M["QRUtil"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
var QRMode = require('./QRMode');
var QRPolynomial = require('./QRPolynomial');
var QRMath = require('./QRMath');
var QRMaskPattern = require('./QRMaskPattern');

var QRUtil = {

    PATTERN_POSITION_TABLE : [
        [],
        [6, 18],
        [6, 22],
        [6, 26],
        [6, 30],
        [6, 34],
        [6, 22, 38],
        [6, 24, 42],
        [6, 26, 46],
        [6, 28, 50],
        [6, 30, 54],        
        [6, 32, 58],
        [6, 34, 62],
        [6, 26, 46, 66],
        [6, 26, 48, 70],
        [6, 26, 50, 74],
        [6, 30, 54, 78],
        [6, 30, 56, 82],
        [6, 30, 58, 86],
        [6, 34, 62, 90],
        [6, 28, 50, 72, 94],
        [6, 26, 50, 74, 98],
        [6, 30, 54, 78, 102],
        [6, 28, 54, 80, 106],
        [6, 32, 58, 84, 110],
        [6, 30, 58, 86, 114],
        [6, 34, 62, 90, 118],
        [6, 26, 50, 74, 98, 122],
        [6, 30, 54, 78, 102, 126],
        [6, 26, 52, 78, 104, 130],
        [6, 30, 56, 82, 108, 134],
        [6, 34, 60, 86, 112, 138],
        [6, 30, 58, 86, 114, 142],
        [6, 34, 62, 90, 118, 146],
        [6, 30, 54, 78, 102, 126, 150],
        [6, 24, 50, 76, 102, 128, 154],
        [6, 28, 54, 80, 106, 132, 158],
        [6, 32, 58, 84, 110, 136, 162],
        [6, 26, 54, 82, 110, 138, 166],
        [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)    | (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
        var d = data << 10;
        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
            d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) );    
        }
        return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
        var d = data << 12;
        while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
            d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) );    
        }
        return (data << 12) | d;
    },

    getBCHDigit : function(data) {

        var digit = 0;

        while (data !== 0) {
            digit++;
            data >>>= 1;
        }

        return digit;
    },

    getPatternPosition : function(typeNumber) {
        return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
        
        switch (maskPattern) {
            
        case QRMaskPattern.PATTERN000 : return (i + j) % 2 === 0;
        case QRMaskPattern.PATTERN001 : return i % 2 === 0;
        case QRMaskPattern.PATTERN010 : return j % 3 === 0;
        case QRMaskPattern.PATTERN011 : return (i + j) % 3 === 0;
        case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 === 0;
        case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 === 0;
        case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 === 0;
        case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 === 0;

        default :
            throw new Error("bad maskPattern:" + maskPattern);
        }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

        var a = new QRPolynomial([1], 0);

        for (var i = 0; i < errorCorrectLength; i++) {
            a = a.multiply(new QRPolynomial([1, QRMath.gexp(i)], 0) );
        }

        return a;
    },

    getLengthInBits : function(mode, type) {

        if (1 <= type && type < 10) {

            // 1 - 9

            switch(mode) {
            case QRMode.MODE_NUMBER     : return 10;
            case QRMode.MODE_ALPHA_NUM  : return 9;
            case QRMode.MODE_8BIT_BYTE  : return 8;
            case QRMode.MODE_KANJI      : return 8;
            default :
                throw new Error("mode:" + mode);
            }

        } else if (type < 27) {

            // 10 - 26

            switch(mode) {
            case QRMode.MODE_NUMBER     : return 12;
            case QRMode.MODE_ALPHA_NUM  : return 11;
            case QRMode.MODE_8BIT_BYTE  : return 16;
            case QRMode.MODE_KANJI      : return 10;
            default :
                throw new Error("mode:" + mode);
            }

        } else if (type < 41) {

            // 27 - 40

            switch(mode) {
            case QRMode.MODE_NUMBER     : return 14;
            case QRMode.MODE_ALPHA_NUM  : return 13;
            case QRMode.MODE_8BIT_BYTE  : return 16;
            case QRMode.MODE_KANJI      : return 12;
            default :
                throw new Error("mode:" + mode);
            }

        } else {
            throw new Error("type:" + type);
        }
    },

    getLostPoint : function(qrCode) {
        
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        var row = 0; 
        var col = 0;

        
        // LEVEL1
        
        for (row = 0; row < moduleCount; row++) {

            for (col = 0; col < moduleCount; col++) {

                var sameCount = 0;
                var dark = qrCode.isDark(row, col);

                for (var r = -1; r <= 1; r++) {

                    if (row + r < 0 || moduleCount <= row + r) {
                        continue;
                    }

                    for (var c = -1; c <= 1; c++) {

                        if (col + c < 0 || moduleCount <= col + c) {
                            continue;
                        }

                        if (r === 0 && c === 0) {
                            continue;
                        }

                        if (dark === qrCode.isDark(row + r, col + c) ) {
                            sameCount++;
                        }
                    }
                }

                if (sameCount > 5) {
                    lostPoint += (3 + sameCount - 5);
                }
            }
        }

        // LEVEL2

        for (row = 0; row < moduleCount - 1; row++) {
            for (col = 0; col < moduleCount - 1; col++) {
                var count = 0;
                if (qrCode.isDark(row,     col    ) ) count++;
                if (qrCode.isDark(row + 1, col    ) ) count++;
                if (qrCode.isDark(row,     col + 1) ) count++;
                if (qrCode.isDark(row + 1, col + 1) ) count++;
                if (count === 0 || count === 4) {
                    lostPoint += 3;
                }
            }
        }

        // LEVEL3

        for (row = 0; row < moduleCount; row++) {
            for (col = 0; col < moduleCount - 6; col++) {
                if (qrCode.isDark(row, col) && 
                        !qrCode.isDark(row, col + 1) && 
                         qrCode.isDark(row, col + 2) && 
                         qrCode.isDark(row, col + 3) && 
                         qrCode.isDark(row, col + 4) && 
                        !qrCode.isDark(row, col + 5) && 
                         qrCode.isDark(row, col + 6) ) {
                    lostPoint += 40;
                }
            }
        }

        for (col = 0; col < moduleCount; col++) {
            for (row = 0; row < moduleCount - 6; row++) {
                if (qrCode.isDark(row, col) &&
                        !qrCode.isDark(row + 1, col) &&
                         qrCode.isDark(row + 2, col) &&
                         qrCode.isDark(row + 3, col) &&
                         qrCode.isDark(row + 4, col) &&
                        !qrCode.isDark(row + 5, col) &&
                         qrCode.isDark(row + 6, col) ) {
                    lostPoint += 40;
                }
            }
        }

        // LEVEL4
        
        var darkCount = 0;

        for (col = 0; col < moduleCount; col++) {
            for (row = 0; row < moduleCount; row++) {
                if (qrCode.isDark(row, col) ) {
                    darkCount++;
                }
            }
        }
        
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;

        return lostPoint;       
    }

};

module.exports = QRUtil;

};
M["QRMath"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

module.exports = QRMath;

};
M["QR8bitByte"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
var QRMode = require('./QRMode');

function QR8bitByte(data) {
	this.mode = QRMode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function() {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

module.exports = QR8bitByte;

};
M["index"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of 
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
// Modified to work in node for this project (and some refactoring)
//---------------------------------------------------------------------

var QR8bitByte = require('./QR8bitByte');
var QRUtil = require('./QRUtil');
var QRPolynomial = require('./QRPolynomial');
var QRRSBlock = require('./QRRSBlock');
var QRBitBuffer = require('./QRBitBuffer');

function QRCode(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

QRCode.prototype = {
	
	addData : function(data) {
		var newData = new QR8bitByte(data);
		this.dataList.push(newData);
		this.dataCache = null;
	},
	
	isDark : function(row, col) {
		if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
			throw new Error(row + "," + col);
		}
		return this.modules[row][col];
	},

	getModuleCount : function() {
		return this.moduleCount;
	},
	
	make : function() {
		// Calculate automatically typeNumber if provided is < 1
		if (this.typeNumber < 1 ){
			var typeNumber = 1;
			for (typeNumber = 1; typeNumber < 40; typeNumber++) {
				var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

				var buffer = new QRBitBuffer();
				var totalDataCount = 0;
				for (var i = 0; i < rsBlocks.length; i++) {
					totalDataCount += rsBlocks[i].dataCount;
				}

				for (var x = 0; x < this.dataList.length; x++) {
					var data = this.dataList[x];
					buffer.put(data.mode, 4);
					buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
					data.write(buffer);
				}
				if (buffer.getLengthInBits() <= totalDataCount * 8)
					break;
			}
			this.typeNumber = typeNumber;
		}
		this.makeImpl(false, this.getBestMaskPattern() );
	},
	
	makeImpl : function(test, maskPattern) {
		
		this.moduleCount = this.typeNumber * 4 + 17;
		this.modules = new Array(this.moduleCount);
		
		for (var row = 0; row < this.moduleCount; row++) {
			
			this.modules[row] = new Array(this.moduleCount);
			
			for (var col = 0; col < this.moduleCount; col++) {
				this.modules[row][col] = null;//(col + row) % 3;
			}
		}
	
		this.setupPositionProbePattern(0, 0);
		this.setupPositionProbePattern(this.moduleCount - 7, 0);
		this.setupPositionProbePattern(0, this.moduleCount - 7);
		this.setupPositionAdjustPattern();
		this.setupTimingPattern();
		this.setupTypeInfo(test, maskPattern);
		
		if (this.typeNumber >= 7) {
			this.setupTypeNumber(test);
		}
	
		if (this.dataCache === null) {
			this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
		}
	
		this.mapData(this.dataCache, maskPattern);
	},

	setupPositionProbePattern : function(row, col)  {
		
		for (var r = -1; r <= 7; r++) {
			
			if (row + r <= -1 || this.moduleCount <= row + r) continue;
			
			for (var c = -1; c <= 7; c++) {
				
				if (col + c <= -1 || this.moduleCount <= col + c) continue;
				
				if ( (0 <= r && r <= 6 && (c === 0 || c === 6) ) || 
                     (0 <= c && c <= 6 && (r === 0 || r === 6) ) || 
                     (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
					this.modules[row + r][col + c] = true;
				} else {
					this.modules[row + r][col + c] = false;
				}
			}		
		}		
	},
	
	getBestMaskPattern : function() {
	
		var minLostPoint = 0;
		var pattern = 0;
	
		for (var i = 0; i < 8; i++) {
			
			this.makeImpl(true, i);
	
			var lostPoint = QRUtil.getLostPoint(this);
	
			if (i === 0 || minLostPoint >  lostPoint) {
				minLostPoint = lostPoint;
				pattern = i;
			}
		}
	
		return pattern;
	},
	
	createMovieClip : function(target_mc, instance_name, depth) {
	
		var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
		var cs = 1;
	
		this.make();

		for (var row = 0; row < this.modules.length; row++) {
			
			var y = row * cs;
			
			for (var col = 0; col < this.modules[row].length; col++) {
	
				var x = col * cs;
				var dark = this.modules[row][col];
			
				if (dark) {
					qr_mc.beginFill(0, 100);
					qr_mc.moveTo(x, y);
					qr_mc.lineTo(x + cs, y);
					qr_mc.lineTo(x + cs, y + cs);
					qr_mc.lineTo(x, y + cs);
					qr_mc.endFill();
				}
			}
		}
		
		return qr_mc;
	},

	setupTimingPattern : function() {
		
		for (var r = 8; r < this.moduleCount - 8; r++) {
			if (this.modules[r][6] !== null) {
				continue;
			}
			this.modules[r][6] = (r % 2 === 0);
		}
	
		for (var c = 8; c < this.moduleCount - 8; c++) {
			if (this.modules[6][c] !== null) {
				continue;
			}
			this.modules[6][c] = (c % 2 === 0);
		}
	},
	
	setupPositionAdjustPattern : function() {
	
		var pos = QRUtil.getPatternPosition(this.typeNumber);
		
		for (var i = 0; i < pos.length; i++) {
		
			for (var j = 0; j < pos.length; j++) {
			
				var row = pos[i];
				var col = pos[j];
				
				if (this.modules[row][col] !== null) {
					continue;
				}
				
				for (var r = -2; r <= 2; r++) {
				
					for (var c = -2; c <= 2; c++) {
					
						if (Math.abs(r) === 2 || 
                            Math.abs(c) === 2 ||
                            (r === 0 && c === 0) ) {
							this.modules[row + r][col + c] = true;
						} else {
							this.modules[row + r][col + c] = false;
						}
					}
				}
			}
		}
	},
	
	setupTypeNumber : function(test) {
	
		var bits = QRUtil.getBCHTypeNumber(this.typeNumber);
        var mod;
	
		for (var i = 0; i < 18; i++) {
			mod = (!test && ( (bits >> i) & 1) === 1);
			this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
		}
	
		for (var x = 0; x < 18; x++) {
			mod = (!test && ( (bits >> x) & 1) === 1);
			this.modules[x % 3 + this.moduleCount - 8 - 3][Math.floor(x / 3)] = mod;
		}
	},
	
	setupTypeInfo : function(test, maskPattern) {
	
		var data = (this.errorCorrectLevel << 3) | maskPattern;
		var bits = QRUtil.getBCHTypeInfo(data);
        var mod;
	
		// vertical		
		for (var v = 0; v < 15; v++) {
	
			mod = (!test && ( (bits >> v) & 1) === 1);
	
			if (v < 6) {
				this.modules[v][8] = mod;
			} else if (v < 8) {
				this.modules[v + 1][8] = mod;
			} else {
				this.modules[this.moduleCount - 15 + v][8] = mod;
			}
		}
	
		// horizontal
		for (var h = 0; h < 15; h++) {
	
			mod = (!test && ( (bits >> h) & 1) === 1);
			
			if (h < 8) {
				this.modules[8][this.moduleCount - h - 1] = mod;
			} else if (h < 9) {
				this.modules[8][15 - h - 1 + 1] = mod;
			} else {
				this.modules[8][15 - h - 1] = mod;
			}
		}
	
		// fixed module
		this.modules[this.moduleCount - 8][8] = (!test);
	
	},
	
	mapData : function(data, maskPattern) {
		
		var inc = -1;
		var row = this.moduleCount - 1;
		var bitIndex = 7;
		var byteIndex = 0;
		
		for (var col = this.moduleCount - 1; col > 0; col -= 2) {
	
			if (col === 6) col--;
	
			while (true) {
	
				for (var c = 0; c < 2; c++) {
					
					if (this.modules[row][col - c] === null) {
						
						var dark = false;
	
						if (byteIndex < data.length) {
							dark = ( ( (data[byteIndex] >>> bitIndex) & 1) === 1);
						}
	
						var mask = QRUtil.getMask(maskPattern, row, col - c);
	
						if (mask) {
							dark = !dark;
						}
						
						this.modules[row][col - c] = dark;
						bitIndex--;
	
						if (bitIndex === -1) {
							byteIndex++;
							bitIndex = 7;
						}
					}
				}
								
				row += inc;
	
				if (row < 0 || this.moduleCount <= row) {
					row -= inc;
					inc = -inc;
					break;
				}
			}
		}
		
	}

};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = QRRSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new QRBitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), QRUtil.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var x = 0; x < rsBlocks.length; x++) {
		totalDataCount += rsBlocks[x].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. (" + 
            buffer.getLengthInBits() + 
            ">" +  
            totalDataCount * 8 + 
            ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 !== 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode.PAD1, 8);
	}

	return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = QRUtil.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new QRPolynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var x = 0; x < ecdata[r].length; x++) {
            var modIndex = x + modPoly.getLength() - ecdata[r].length;
			ecdata[r][x] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var y = 0; y < rsBlocks.length; y++) {
		totalCodeCount += rsBlocks[y].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var z = 0; z < maxDcCount; z++) {
		for (var s = 0; s < rsBlocks.length; s++) {
			if (z < dcdata[s].length) {
				data[index++] = dcdata[s][z];
			}
		}
	}

	for (var xx = 0; xx < maxEcCount; xx++) {
		for (var t = 0; t < rsBlocks.length; t++) {
			if (xx < ecdata[t].length) {
				data[index++] = ecdata[t][xx];
			}
		}
	}

	return data;

};

module.exports = QRCode;

};
M["QRBitBuffer"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
function QRBitBuffer() {
	this.buffer = [];
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

module.exports = QRBitBuffer;

};
M["QRRSBlock"]=function(module,exports){ var require=function(p){ return req(p.replace(/^.*\//,"")); };
var QRErrorCorrectLevel = require('./QRErrorCorrectLevel');

function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock === undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = [];
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case QRErrorCorrectLevel.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case QRErrorCorrectLevel.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case QRErrorCorrectLevel.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case QRErrorCorrectLevel.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

module.exports = QRRSBlock;

};
window.QRCodeLib=req("index"); window.QRLevel=req("QRErrorCorrectLevel"); })();
;
/* Start: technische Zeichnung ist Standard. Beim Start blendet das 3D-Bild weich in die Zeichnung über
   (eine Bewegung). Danach erscheint kurz ein Hinweis über der Ansichtswahl unten links: kleiner Kasten
   mit drehendem 3D und Pfeil auf „3D“ – 4 s, beim Überfahren länger, Klick öffnet 3D. */
(function(){
  const v3=document.getElementById('v3'), start=document.getElementById('cfgStart');
  const tab3=document.getElementById('cfg-tab-3d'), tab2=document.getElementById('cfg-tab-2d');
  const view=document.querySelector('.cfg-stage__view'), tabsBox=document.querySelector('.cfg-stage__bottom .cfg-tabs-legacy');
  if(!v3||!start||!tab3||!tab2||!view||!tabsBox) return;
  const frame=document.createElement('button'); frame.type='button'; frame.className='cfg-mini3d is-below'; frame.hidden=true;
  frame.setAttribute('aria-label','3D-Ansicht öffnen'); view.appendChild(frame);
  let tHold=null, tShow=null, hover=false, active=false, shown=false;
  function reset(){ ['transition','transform','clipPath','transformOrigin','opacity','zIndex'].forEach(k=>v3.style[k]=''); v3.classList.remove('is-mini'); document.documentElement.classList.remove('is-mini3d'); }
  function finish(toThree){
    if(!active) return; active=false; shown=false; window.__mini3d=false; hover=false; clearTimeout(tHold); clearTimeout(tShow);
    frame.classList.remove('is-in','is-arrow');
    if(toThree){ setTimeout(()=>{ frame.hidden=true; },400); reset(); tab3.click(); if(window.inbRefit3d) setTimeout(window.inbRefit3d,50); return; }
    v3.style.transition='opacity 1000ms cubic-bezier(.4,0,.2,1)'; v3.style.opacity='0';   // weich ausblenden
    setTimeout(()=>{ frame.hidden=true; reset(); if(window.inbRefit3d) window.inbRefit3d(); },1040);
  }
  function hold(ms){ clearTimeout(tHold); tHold=setTimeout(()=>{ if(!hover) finish(false); },ms); }
  function showHint(reduce){
    const pr=v3.getBoundingClientRect(), vr=view.getBoundingClientRect(), tb=tabsBox.getBoundingClientRect();
    let cr=document.querySelector('.cfg-stage__canvas').getBoundingClientRect();
    if(innerWidth<=989){ const pn=document.querySelector('.cfg-panel').getBoundingClientRect(); if(pn.top>cr.top) cr={left:cr.left,right:cr.right,top:cr.top,width:cr.width,height:Math.min(cr.height,pn.top-cr.top-12)}; cr.bottom=cr.top+cr.height; }
    const pad=8, gap=12, w=Math.max(tb.width,220), iw=w-2*pad, k=iw/cr.width, ih=cr.height*k, h=ih+2*pad;
    const fl=tb.left, ft=tb.top-gap-h;                                       // Kasten über der Ansichtswahl
    frame.style.width=w+'px'; frame.style.height=h+'px'; frame.style.left=(fl-vr.left)+'px'; frame.style.top=(ft-vr.top)+'px';
    const t3=tab3.getBoundingClientRect(); frame.style.setProperty('--hint-arrow', Math.max(10,(t3.left+t3.width/2)-fl-6)+'px');
    v3.style.transition='none';
    v3.style.clipPath=`inset(${cr.top-pr.top}px ${pr.right-(cr.left+cr.width)}px ${pr.bottom-(cr.top+cr.height)}px ${cr.left-pr.left}px)`;
    v3.style.transformOrigin=`${cr.left-pr.left}px ${cr.top-pr.top}px`;
    v3.style.transform=`translate(${fl+pad-cr.left}px, ${ft+pad-cr.top}px) scale(${k})`;
    v3.style.opacity='0'; frame.hidden=false; void v3.offsetWidth;
    document.documentElement.classList.add('is-mini3d');
    v3.style.transition = reduce ? 'none' : 'opacity 900ms cubic-bezier(.4,0,.2,1)'; v3.style.opacity='1';
    shown=true; frame.classList.add('is-in','is-arrow'); hold(8000);   // weich einblenden, 8 s stehen lassen
  }
  start.addEventListener('pointerdown',()=>{ window.__mini3d=true; },true);
  start.addEventListener('click',()=>{
    window.__mini3d=true;
    const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(()=>{
      // 3D bleibt kurz sichtbar über der Zeichnung und blendet weich aus – die Zeichnung erscheint darunter
      v3.classList.add('is-mini'); active=true; v3.style.zIndex='36';
      tab2.click();
      v3.style.transition = reduce ? 'none' : 'opacity 520ms ease'; v3.style.opacity='0';
      tShow=setTimeout(()=>showHint(reduce), reduce ? 3000 : 3500);   // Hinweis erst ~3 s nach dem Vollbild; wer vorher schon wählt, bekommt ihn nicht
    });
  });
  [frame,v3].forEach(el=>{
    el.addEventListener('pointerenter',()=>{ if(active && shown){ hover=true; clearTimeout(tHold); } });
    el.addEventListener('pointerleave',()=>{ if(active && shown && hover){ hover=false; hold(3500); } });   // nur nach echtem Überfahren verkürzen
  });
  frame.addEventListener('click',()=>finish(true));
  v3.addEventListener('click',e=>{ if(active && v3.style.opacity!=='0'){ e.stopPropagation(); finish(true); } },true);
  tab3.addEventListener('click',()=>{ if(active) finish(true); });
  ['input','change'].forEach(ev=>document.getElementById('cfg').addEventListener(ev,()=>{ if(active && (!shown || !hover)) finish(false); }));   // vor dem Erscheinen: jede Auswahl bricht ab
  addEventListener('load',()=>setTimeout(()=>window.inbRefit3d&&window.inbRefit3d(),300));
  addEventListener('resize',()=>{ if(active) return; clearTimeout(window.__rf3); window.__rf3=setTimeout(()=>window.inbRefit3d&&window.inbRefit3d(),200); });
  window.inbMini3d={finish};
})();
;
/* SHOP-TEST: Section im Seitenfluss → beim Start ganzes Browserfenster (gleichzeitig blendet 3D in die Zeichnung über) */
(function(){
  const emb=document.getElementById('cfgEmbed'), start=document.getElementById('cfgStart'), panel=document.querySelector('.cfg-panel');
  const restartRow=document.getElementById('restartRow'), restart=document.getElementById('restartBtn');
  if(!emb||!start) return;
  let full=false, place=null, started=false;
  const EASE='cubic-bezier(.2,0,0,1)', DUR=520;
  const nudge=()=>{ window.dispatchEvent(new Event('resize')); if(window.inbRefit3d) window.inbRefit3d(); if(window.inbDraw) window.inbDraw(); };
  // Vollbild per Aufdecken: der Konfigurator liegt sofort in Endgröße über der Seite und wird nur
  // von der Section-Fläche aus aufgedeckt (clip-path). So wird nichts nachträglich neu skaliert.
  const clipOf=r=>`inset(${Math.max(0,r.top)}px ${Math.max(0,innerWidth-r.right)}px ${Math.max(0,innerHeight-r.bottom)}px ${Math.max(0,r.left)}px)`;
  function expand(){
    if(full) return;
    const r=emb.getBoundingClientRect();
    place=document.createElement('div'); place.style.height=r.height+'px'; place.style.background=getComputedStyle(document.getElementById('cfg')).backgroundColor; emb.parentNode.insertBefore(place,emb);
    emb.classList.add('is-full');
    Object.assign(emb.style,{top:'0px',left:'0px',width:'100vw',height:'100dvh',clipPath:clipOf(r),transition:'none'});
    document.documentElement.classList.add('cfg-locked');
    nudge();                                             // sofort in Endgröße einpassen (unsichtbar unter der Maske)
    void emb.offsetWidth;
    emb.style.transition=`clip-path ${DUR}ms ${EASE}`; emb.style.clipPath='inset(0px 0px 0px 0px)';
    full=true; try{ history.pushState({cfgFull:1},'',location.pathname+location.search+'#konfigurator'); }catch(e){}
    setTimeout(()=>{ emb.style.transition=''; emb.style.clipPath=''; },DUR+20);
  }
  // Schließen: Inhalt blendet aus, während sich die Maske auf die Section schließt; dort wechselt
  // er unsichtbar auf 3D und das Section-Format und blendet dann weich wieder ein – ohne Sprung.
  function collapse(){
    if(!full) return; full=false;
    if(window.inbMini3d) window.inbMini3d.finish(false);
    const app=document.getElementById('cfg'), r=place.getBoundingClientRect();
    app.style.transition='opacity 260ms cubic-bezier(.4,0,1,1)'; app.style.opacity='0';
    emb.style.clipPath='inset(0px 0px 0px 0px)'; void emb.offsetWidth;
    emb.style.transition=`clip-path ${DUR}ms ${EASE}`; emb.style.clipPath=clipOf(r);
    setTimeout(()=>{   // unsichtbar: zurück auf 3D in Ausgangslage
      const t3=document.getElementById('cfg-tab-3d'); if(t3 && document.querySelector('.cfg-stage__view').getAttribute('data-view')!=='3d') t3.click();
      if(window.inbCamReset) window.inbCamReset();
    },280);
    setTimeout(()=>{
      emb.classList.remove('is-full'); emb.removeAttribute('style'); place.remove(); place=null; document.documentElement.classList.remove('cfg-locked');
      if(started){ panel.classList.add('is-welcome'); start.textContent='Konfiguration fortsetzen'; restartRow.hidden=false; }
      nudge();
      requestAnimationFrame(()=>{ app.style.transition='opacity 520ms cubic-bezier(.2,0,0,1)'; app.style.opacity='1';
        setTimeout(()=>{ app.style.transition=''; app.style.opacity=''; },560); });
    },DUR+20);
  }
  // Start: Vollbild und Start gleichzeitig – eine Bewegung
  start.addEventListener('click',()=>{ started=true; expand(); },true);
  const lb=document.getElementById('loadIdBtn'); if(lb) lb.addEventListener('click',()=>{ started=true; expand(); },true);
  if(new URLSearchParams(location.search).get('c')){ started=true; expand(); }
  // „Mit gespeicherter Konfiguration fortfahren“: nur EIN Rückweg sichtbar
  const lt=document.getElementById('loadToggle');
  if(lt) new MutationObserver(()=>{ const on=lt.getAttribute('aria-expanded')==='true';
    if(started){ restartRow.hidden=on; if(on) lt.textContent='Zurück zur aktuellen Konfiguration'; }
  }).observe(lt,{attributes:true,attributeFilter:['aria-expanded']});
  restart && restart.addEventListener('click',()=>{ const r=document.getElementById('resetBtn'); if(r) r.click(); start.textContent='Konfiguration starten'; restartRow.hidden=true; setTimeout(()=>start.click(),60); });
  let ignorePop=false;
  const leave=()=>{ collapse(); if(history.state && history.state.cfgFull){ ignorePop=true; history.back(); } };   // sofort schließen, Adresse nur aufräumen
  document.querySelectorAll('[data-cfg-exit]').forEach(b=>b.addEventListener('click',leave));
  addEventListener('popstate',()=>{ if(ignorePop){ ignorePop=false; return; } if(full) collapse(); });
  addEventListener('keydown',e=>{ if(e.key==='Escape' && full && !document.querySelector('dialog[open]')) leave(); });
})();
;
/* Nach normalem Absenden (Spamschutz): Konfiguration wieder laden und Bestätigung zeigen */
(function(){
  var sid=null; try{ sid=sessionStorage.getItem('inbCfgSent'); }catch(e){}
  if(!sid || !document.getElementById('inbCfgPosted')) return;
  try{ sessionStorage.removeItem('inbCfgSent'); }catch(e){}
  setTimeout(function(){ if(window.inbLoadCode) window.inbLoadCode(sid); },400);
})();
